//v1.0 REACT
import * as d3 from 'd3';
import _ from 'lodash';

function widgetRender(wpObject, action, options){
	
	//update widget options
	if(options){
		//tagId
		if(options.containerId && typeof options.containerId === "string"){
			wpObject.contextualProperties.tagId = options.containerId;
		} else {
			
		}
		//dataset
		if(options.dataset && typeof options.dataset === "object"){
			wpObject.contextualProperties.dataIn = options.dataset;
		} else {
			
		}
		//themes
		if(options.widgetTheme && typeof options.widgetTheme === "string"){
			wpObject.detailProperties.styles.themeScheme = options.widgetTheme;
		}
		//language
		if(options.localeFormat){
			localeFormat(wpObject,options.localeFormat);
		}
	}
	
	if(action === 'init' || action === null || action === undefined){
		checkWidgetProperties(wpObject);
	} else {
		setWidgetSize(wpObject);
	}
	
	//calculate a min/max with the complete dataset - du coup on doit faire une 1ere passe pour calculer les min/max sans render le chart
	if(action === 'init' && wpObject.detailProperties.dataFiltering && wpObject.detailProperties.dataFiltering.active && wpObject.detailProperties.XYChart && wpObject.detailProperties.XYChart.linearAxisMinMaxOnDataset){
		if(wpObject.detailProperties.dataAggregation){
			wpObject.contextualProperties.dataOut = calculationEngine(wpObject, action);
		} else {
			wpObject.contextualProperties.dataOut = _.cloneDeep(wpObject.contextualProperties.dataIn);
		}
		
		drawWidget(wpObject, action, true);
		action = 'updateData';
	}
	
	if(wpObject.detailProperties.dataAggregation){
		if(wpObject.generalProperties.chartType === 'sunburst' || wpObject.generalProperties.chartType === 'forceSimulation' || wpObject.generalProperties.chartType === 'circlePack'){
			wpObject.contextualProperties.dataOut = calculationEngineHierarchy(wpObject);
		} else if(wpObject.generalProperties.chartType === 'parallel'){
			wpObject.contextualProperties.dataOut = calculationEngineParallel(wpObject);
		} else {
			wpObject.contextualProperties.dataOut = calculationEngine(wpObject, action);
		}
	} else {
		wpObject.contextualProperties.d3viz.dom['check'] = "l";
		if(wpObject.detailProperties.dataFiltering && wpObject.detailProperties.dataFiltering.active){
			wpObject.contextualProperties.dataOut = dataFiltering(wpObject);
		} else {
			wpObject.contextualProperties.dataOut = _.cloneDeep(wpObject.contextualProperties.dataIn);
		}
	}

 	if(wpObject.detailProperties.dataHighlight && wpObject.detailProperties.dataHighlight.rules.length > 0 && wpObject.detailProperties.dataHighlight.applyOnAdjustedValue === false){
		dataHighlight(wpObject);
	}
	
	if(wpObject.detailProperties.calculationFieldsTotal){
		totalCalculation(wpObject);
	}	
	
	return drawWidget(wpObject, action);
	
}

function redrawWidget(wpObject, action){

	let resizeFlag;
	let animationFlag = wpObject.detailProperties.animation.active;
	
	
	d3.select("#" + wpObject.contextualProperties.tagId + " svg").style('display','none');
	d3.select("#" + wpObject.contextualProperties.tagId + " div").style('display','none');

		
	resizeFlag = setWidgetSize(wpObject, action);

	d3.select("#" + wpObject.contextualProperties.tagId + " svg").style('display','inline');
	d3.select("#" + wpObject.contextualProperties.tagId + " div").style('display','block');
	
	if(animationFlag && action === 'resize'){
		wpObject.detailProperties.animation.active = false;
	}
	
	//check minimum size
	if(wpObject.generalProperties.size.width < wpObject.generalProperties.minSize.width || wpObject.generalProperties.size.height < wpObject.generalProperties.minSize.height){
		drawErrorMsg(wpObject);
	} else {
		if(action !== 'resize'){
			drawWidget(wpObject, action);
		} else if(action === 'resize' && resizeFlag === true){
			drawWidget(wpObject, action);
		}
	}
	
	wpObject.detailProperties.animation.active = animationFlag;
	
}

function drawErrorMsg(wpObject){

	let vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height;

		
	d3.select("#" + wpObject.contextualProperties.tagId + " svg").remove();
	d3.select("#" + wpObject.contextualProperties.tagId + " div").remove();
	
	wpObject.contextualProperties.d3viz.dom.viz = d3.select("#" + wpObject.contextualProperties.tagId).append("svg")
				.attr("id", "viz")
    			.attr("width", vizWidth)
				.attr("height", vizHeight)
				.append('text')
				.attr('dy','1em')
				.append('tspan')
				.text(wpObject.generalProperties.errorMsg);
	
}

function localeFormat(wpObject, localeFormat){
	
	
	let timeFormatSpecifier, numberFormatSpecifier;
	
	switch(localeFormat){
		case 'FR' :
			numberFormatSpecifier = {
								"decimal": ".",
								"thousands": " ",
								"grouping": [3],
								"currency": [""," €"],
								"percent" : " %"
							};
			timeFormatSpecifier = {
								"dateTime": "%a %b %e %X %Y",
								"date": "%d/%m/%Y",
								"time": "%H:%M:%S",
								"periods": ["AM", "PM"],
								"days": ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
								"shortDays": ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
								"months": ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
								"shortMonths": ["jan.", "fév.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."]
							};
			break;
		case 'EU' :
			numberFormatSpecifier = {
										  "decimal": ".",
										  "thousands": " ",
										  "grouping": [3],
										  "currency": [""," €"],
											"percent" : " %"
										};
			timeFormatSpecifier = {
											"dateTime": "%a %b %e %X %Y",
											"date": "%d/%m/%Y",
											"time": "%H:%M:%S",
											"periods": ["AM", "PM"],
											"days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
											"shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
											"months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
											"shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
							};
			break;
		case 'UK' :
			numberFormatSpecifier = {
										  "decimal": ".",
										  "thousands": " ",
										  "grouping": [3],
										  "currency": [""," £"],
											"percent" : " %"
										  
										};
			timeFormatSpecifier = {
											"dateTime": "%a %b %e %X %Y",
											"date": "%d/%m/%Y",
											"time": "%H:%M:%S",
											"periods": ["AM", "PM"],
											"days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
											"shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
											"months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
											"shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
							};
			break;
		case 'US' :
			numberFormatSpecifier = {
										  "decimal": ",",
										  "thousands": ".",
										  "grouping": [3],
										  "currency": ["$",""],
										  "percent" : " %"
										};
			timeFormatSpecifier = {
											"dateTime": "%a %b %e %X %Y",
											"date": "%Y/%m/%d",
											"time": "%H:%M:%S",
											"periods": ["AM", "PM"],
											"days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
											"shortDays": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
											"months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
											"shortMonths": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
											};
			break;
			
		case 'DE' :
			numberFormatSpecifier = {
										  "decimal": ".",
										  "thousands": " ",
										  "grouping": [3],
										  "currency": [""," €"],
										"percent" : " %"
										};
			timeFormatSpecifier = {
											"dateTime": "%a %b %e %X %Y",
											"date": "%d/%m/%Y",
											"time": "%H:%M:%S",
											"periods": ["AM", "PM"],
											"days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
											"shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
											"months": ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
											"shortMonths": ["Jän", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Dez"]
											};
			break;
		case 'IT' :
			numberFormatSpecifier = {
										  "decimal": ".",
										  "thousands": " ",
										  "grouping": [3],
										  "currency": [""," €"],
										"percent" : " %"
										};
			timeFormatSpecifier = {
											"dateTime": "%a %b %e %X %Y",
											"date": "%d/%m/%Y",
											"time": "%H:%M:%S",
											"periods": ["AM", "PM"],
											"days": ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
											"shortDays": ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
											"months": ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
											"shortMonths": ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"]
											};
			break;
		case 'ES' :
			numberFormatSpecifier = {
										  "decimal": ".",
										  "thousands": " ",
										  "grouping": [3],
										  "currency": [""," €"],
										"percent" : " %"
										};
			timeFormatSpecifier = {
											"dateTime": "%a %b %e %X %Y",
											"date": "%d/%m/%Y",
											"time": "%H:%M:%S",
											"periods": ["AM", "PM"],
											"days": ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
											"shortDays": ["Dom", "Lun", "Mar", "Mi", "Jue", "Vie", "Sab"],
											"months": ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
											"shortMonths": ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]
											};
			break;
	}
	
	if(wpObject.contextualProperties.d3viz){
		wpObject.contextualProperties.d3viz.localeNumberFormat = d3.formatLocale(numberFormatSpecifier)
		wpObject.contextualProperties.d3viz.localeFormat = d3.timeFormatLocale(timeFormatSpecifier);			
	} else {
		wpObject.contextualProperties.d3viz = {'localeNumberFormat' : d3.formatLocale(numberFormatSpecifier), 'localeFormat' : d3.timeFormatLocale(timeFormatSpecifier)}
	}
	wpObject.contextualProperties.d3viz.numberFormatSpecifier = numberFormatSpecifier;
	wpObject.contextualProperties.d3viz.timeFormatSpecifier = timeFormatSpecifier;
	
}

function checkWidgetProperties(wpObject){
	
	var defaultWidgetProperties = {
			'generalProperties' : {
				'chartType' : null,	// barchart, pie, linechart
				'orientation' : 'horizontal',	// horizontal, vertical (for XY axis chart)
				'direction' : 'standard', 	// standard, opposite
				'margin' : {'top' : 10, 'right' : 10, 'bottom' : 10, 'left' : 10},
				'defaultLocalFormat' : 'US',
				'size' : {'width' : '100%', 'height' : '100%'},
				'minPlotSize' : {'width' : 0, 'height' : 0},
				'activeClipPath' : true,
				'backgroundColor' : null,
				'errorMsg' : 'taille de visualisation inadapté'
			},
			'detailProperties' : {
				'dataAggregation' : false,
				'adjustPct' : false,
				'dimensionFields' : null,
				'dimensionFieldsLabel' : null,
				'dimensionFieldsDatatype' : null,
				'dimensionFieldsFormat' : null,
				'dimensionFieldsCustomSort' : null,
				'dimensionFieldsSortOrder' : null,
				'multiDimensionStyle' : null,		//grouped, stacked, diverging, bullet (for bullet & diverging multiDimensionStyle , 2nd axis must have 2 values max !!!)
				'splitPadding' : 0,
				'multiDimensionStyleSwitch' : null,
				'calculationFields' : ['__count__'],
				'calculationFieldsFormula' : ['__sum__'],		//__count__, __sum__, __cumSum__ 
				'calculationFieldsLabel' : ['nombre'],
				'calculationFieldsTotal' : null,
				'calculationFieldsDatatype' : ['number'],
				'calculationFieldsFormat' : ['none'],
				'currentCalculationFieldsIndex' : 0,
				'dataFiltering' : {
					'active' : false,
					'restrictionColumn' : null,
					'restrictionColumnToValue' : null,
				},
				'XYChart' : {
					'includeOrigin' : true,		//used for barchart / linechart
					'linearGridline' : true,
					'categoricalGridline' : false,
					'linearAxis' : true,
					'linearAxisReverse' : false,
					'linearAxisPosition' : 'default',		// default (i.e left if horizontal, i.e bottom if vertical), both, left, right, top, bottom 
					'linearAxisLabel' : true,
					'linearAxisLabelTextAnchor' : null,
					'linearAxisLabelHPadding' : 0,
					'linearAxisLabelVPadding' : 0,
					'linearAxisTick' : true,
					'linearAxisTicksNumber' : null,
					'linearAxisMinMaxAdjust' : false,		//simple way to adjust min & max scale value to a tick step
					'categoricalAxis' : true,
					'categoricalAxisReverse' : false,
					'categoricalAxisLabel' : true,
					'categoricalAxisLabelTextAnchor' : null,
					'categoricalAxisLabelHPadding' : 0,
					'categoricalAxisLabelVPadding' : 0,
					'categoricalAxisLabelTextShift' : 0,
					'categoricalAxisLabelTextOverlapRule' : 'none',	// none, cut, hide
					'categoricalAxisTick' : true,
					'linearAxisMinMax' : null,
					'linearAxisMinMaxExtendFactor' : null,
					'divergingBarSpacing' : 0,
					'stackOrder' : 'stackOrderNone',
					'stackOffset' : 'stackOffsetNone',					
					'barPadding' : 0.1,		// value between 0 and 1
					'barRadius' : 8,		// value in px
					'barGroupPadding' : 0.1,		// value between 0 and 1
					'barBandwithReduction' : 0,
					'barZeroValue' : {			//update lch 25/08/20
						'show' : false,
						'size' : 5
					},
					'barchartArea' : {
						'active' : false
					},
					'lineInterpolation' : 'curveMonotoneX',
					'lineDashArray' : '0',
					'altLineAltArray' : '4 5',
					'lineWidth' : 2,
					'altLineWidth' : 2,
					'linechartArea' : false,
					'linechartLabel' : {
								'visible' : false,
								'position' : 'end',	// start, end, both
								'padding' : 5,
								'relativePosition' : 'outside',
								'fontFamily' : 'Montserrat',
								'fontSize' : '12px',
								'fontWeight' : 'normal',
								'Dy' : '0.35em',
								'Dx' : null,
								//'color' : 'pink',
								'altColor' : '#FFFFFF',
								'highlight' : {
									'active' : false,
									'strokeColor' : "lime",
									'strokeWidth' :4,
									'fillColor' : null,
									'opacity' : 1,
									'noneHighlight' : {
										'strokeColor' : "grey",
										'strokeWidth' :null,
										'fillColor' : null,
										'opacity' : 0.5,
									}
								}
					},
					'benchmarkLabelVisible' : false,
					'benchmarkLabelPadding' : 12,
					'benchmarkLineColor' : '#FFFFFF',
					'benchmarkLineAltColor' : '#000000',
					'benchmarkLineWidth' : 1,
					'benchmarkLineDashArray' : '6 3'
				},
				'spider' : {
					'includeOrigin' : true,		
					'linearGridline' : true,
					'linearGridlineStyle' : 'curveLinearClosed',	//curveLinearClosed, curveCardinalClosed
					'linearGridlineNumber' : 5,
					'linearAxis' : true,
					'linearAxisPosition' : 'background',
					'linearAxisLabel' : true,
					'linearAxisLabelFormat' : null,
					'linearAxisLabelTextAnchor' : null,
					'linearAxisLabelHPadding' : 0,
					'linearAxisLabelVPadding' : 0,
					'linearAxisMinMax' : null,
					'linearAxisMinMaxExtendFactor' : null,
					'area' : {
						'visible' : true,
						'opacity' : 0.1
					},
					'hPosition' : 'center',
					'vPosition' : 'center',
					'hPadding' : 0,
					'vPadding' : 0,
					'lineWidth' : 3,
					'lineDashArray' : '0'
				},
				'pieChart' : {
					'pieType' : 'standard',		// gauge : only 1 value, standard (multiples values)
					'hPosition' : 'center',
					'vPosition' : 'center',
					'hPadding' : 0,
					'vPadding' : 0,
					'pieRadius' : 0,
					'outterRadius' : 1,
					'innerradius' : 0.8,
					'cornerRadius' : 0,
					'startAngle' : 0,
					'endAngle' : 360,					
					'padAngle' : 0,
					'pieBackgroundColor' : 'rgba(151, 151, 151, 0.24)',
					'pieBackgroundTextureScheme' : null,
					'gaugeLabelUnderline' : false,
					'labelLine' : false,
					'labelLineLength' : 150,
					'labelAltPadding' : 20,
					'labelLineWidth' : 0.5,
					'labelLinePadding' : 5,
				},
				'picto' : {
					'link' : null,
					'pictos' : null
				},
				'label' : {
					'visible' : true,
					'text' : 'default',		// default, [__value__], [__pct__] , ...
					'position' : 'top',		// top, bottom
					'relativePosition' : 'inside', // inside or outside shape element
					'padding' : 0,
					'hPadding' : 0,
					'vPadding' : 0,
					'fontFamily' : 'Montserrat',
					'fontSize' : '10px',
					'fontWeight' : 'normal',
					'textAnchor' : 'middle',
					'color' : '#FFFFFF',
					'altColor' : '#000000',					
					'prefix' : '',
					'suffix' : '',
					'SVG' : null,
					'labelVisibilityCorrection' : 'none',	// none, shadow, contrast
					'textShadow' : {
						'active' : false,
						'shadowColor' : '#E5E2E0',
						'shadowWidth' : '6px',
						'shadowOpacity' : 1,
					},
					'variableFormat' : null
				},
				'marker' : {
					'visible' : false,
					'style' : 'circle',	//circle, square
					'r' : 6,
					'strokeColor' : null,
					'strokeWidth' : 2,
					'fillColor' : "#FFFFFF"
				},
				'highlightArea' : {
					'active' : false,
					'strokeColor' : "#737373",
					'strokeWidth' :0,
					'fill' : "#737373",
					'opacity' : 0.4,
					'colorScheme' : null,
					'colorGradientScheme' : null
				},
				'axis' : {
					'fontFamily' : 'Montserrat',
					'fontSize' : '14px',
					'fontWeight' : 'normal',
					'color' : '#000000',
					'labelColor' : '#000000',
					'tickSize' : 6,
					'lineWidth' : 0.5,
					'tickPadding' : 3,
					'padding' : 0,
					'title' : false,
					'titlePosition' : 'outside',
					'titleRelPosition' : 'center',
					'titlePadding' : 0,
					'titleFontSize' : '16px',
					'titleFontWeight' : 'normal'
				},
				'gridline' : {
						'padding' : 0,
						'showExtend' : true,
						'dashArray' : '0',
						'width' : 0.5,
						'color' : '#7D7D7D',
						'altColor' : '#000000',
						'opacity' : 1
				},
				'title' : {
					'visible' : true,
					'text' : null,
					'hPosition' : 'center',
					'vPosition' : 'top',
					'padding' : 0,					
					'alignment' : 'center',
					'fontFamily' : 'Montserrat',
					'fontSize' : '14px',
					'fontWeight' : 'normal',
					'fontStyle': 'normal',
					'textAnchor' : 'middle',
					'SVG' : null,
					'variableFormat' : null
				},
				'caption' : {
					'visible' : false,
					'text' : null,
					'hPosition' : 'center',
					'vPosition' : 'top',
					'padding' : 0,
					'alignment' : 'center',
					'fontFamily' : 'Montserrat',
					'fontSize' : '14px',
					'fontWeight' : 'normal',
					'fontStyle': 'italic',
					'textAnchor' : 'middle',
					'SVG' : null,
					'variableFormat' : null
				},
				'legend' : {
					'type' : 'manual',	// manual, data, dimension, measure
					'scaleMode' : null,	// null, categorical, continous
					'text' : null,
					'marker' : null,	// square, circle, line
					'markerSize' : 0,
					'orientation' : 'horizontal',
					'hPosition' : 'center',
					'vPosition' : 'top',
					'alignment' : 'center',
					'fontFamily' : 'Montserrat',
					'padding' : 0,
					'color' : '#535353',
					'fontSize' : '16px',
					'fontWeight' : 'normal',
					'textAnchor' : 'middle',
					'maxBlockPerRow' : 0,
					'maxBlockPerCol' : 0,
					'multiRowPadding' : 25,
					'multiColPadding' : 0,
					'blockPadding' : 0,
					'minBlockSize' : 0,
					'SVG' : null,
					'variableFormat' : null
				},
				'tooltip' : {
					'active' : false,
					'theme' : 'default',
					'pointer' : true,
					'detectionArea' : 'shape',	// shape , shapeExtend, categoricalAxis, linearAxis
					'hPosition' : 'mouse',	// shape, mouse, top, bottom
					'vPosition' : 'mouse',
					'hRelPosition' : 'adjust',	// adjust, left, right, center
					'vRelPosition' : 'adjust',	// adjust, up, down, center
					'highlight' : {
						'active' : false,
						'direction' : 'parent',
						'strokeColor' : null,
						'strokeWidth' : null,
						'fillColor' : null,
						'opacity' : 1,
						'noneHighlight' : {
							'strokeColor' : null,
							'strokeWidth' : null,
							'fillColor' : null,
							'opacity' : 0.5,
						}
					},
					'column' : null,
					'columnFormat' : null,
					'columnSuffix' : null,
					'lineSeparator' : true,
					'fontFamily' : 'Montserrat',
					'padding' : 0,
					'color' : '#000000',	//'#FFFFFF'
					'fontSize' : '15px',
					'fontWeight' : '400',
					'textAnchor' : 'start',
					'backgroundColor' : '#999999',	//'#535353',
					'borderRadius' : 0,
					'contourColor' : '#000000',
					'contourWidth' : 0,
					'SVG' : null,
					'SVGColumnFormat' : null,
					'variableFormat' : null,
					'tooltipSpecificFn' : null,
					'message' : {
						'text' : null,
						'automaticHide' : true,		//hide if tooltip visible
						'automaticDisappear' : 10,	// hide if tooltip has been shown x times, if 0 then never hide
						'hPosition' : 'center',
						'vPosition' : 'bottom',
						'fontFamily' : 'Montserrat',
						'vPadding' : 0,
						'hPadding' : 0,
						'color' : '#a2a6ab',
						'fontSize' : '14px',
						'fontWeight' : 300,
						'textAnchor' : 'middle',
						'fontStyle': 'italic',
						'SVG' : null
					},
				},
				'annotation' : {
					'active' : false,
					'visible' : false,
					'annotationToggleIndicator' : {
						'visible' : false,
						'visibleInAnimation' : false,
						'hPosition' : 'leftPlot',
						'vPosition' : 'topPlot',
						'hPadding' : 5,
						'vPadding' : -25,
					},
				},
				'animation' : {
					'active' : true,
					'duration' : 300,
					'labelValue' : false,
					'delay' : 0,
					'incrementalDelay' : 150,
					'incrementationBy' : 'index',	// index, serie, dimension
					'style' : 'default',
					'ease' : 'easeCubic'	//default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
				},
				'events' : {
					'mouseover' : true,
					'click' : false
				}
			},
			'contextualProperties' :  {
				'tagId' : 'widget1',				
				'dataIn' : null,
				'dataOut' : null,
				'total' : null,
				'state' : null,	// to identify if we are in a animation or not
				'animationList' : [],
				'debug' : false,
				'animation' : {
					'state' : null,
					'currentStepIdx' : null,					
				},
				'promises' : [],
				'd3viz' : {	'dom' : {'viz' : null, 'svgDefs' : null, 'gridline' : null, 'backgroundPlot' : null, 'foregroundPlot' : null,'check': null, 'plot' : null, 'axis' : null, 'title' : null, 'caption' : null, 'legend' : null},
							'axis' : {'dimension' : {'axis' : null, 'domain' : null}, 'measure' : {'axis' : null, 'domain' : null}, 'x' : null, 'y' : null, 'x2' : null, 'y2' : null, 'color' : null, 'colorGradient' : null, 'texture' : null},
							'tooltip' : {'visible' : false},
							'styles' : {
								'colors' : null,
								'textures' : null
							},
							'highlightArea' : {},
							'barchart' : {'bandwidth' : null},
							'dotPlot' : {
								'sizeAxis' : null,
								'shapeAxis' : null,
							},
							'linechart' : {	
								'lineLayout' : d3.line(),
								'areaLayout' : d3.area()
							},
							'spider' : {
								'lineLayout' : d3.lineRadial(),
							},
							'pie' : {
								'arcLayout' : d3.arc(),
								'pieFn' : d3.pie().sort(null),
								'pieData' : null,
								'outerRadius' : null, 'innerRadius' : null,
								'xPos' : null, 'yPos' : ''
							},
							'sunburst' : {
								'partitionFn' : d3.partition(),
								'arcLayout' : d3.arc(),
								'middleArcLine' : null,
								'textFits' : null
							},
							'forceSimulation' : {
								'forceLayout' : null
							},
							'circlePack' : {								
								'cpLayout' : d3.pack()
							},
							'annotation' : {
								'annotationList' : null,
								'notes' : null,
								'containerVisible' : false,
							},
							'specificFn' : null,
							'localeNumberFormat' : null,
							'localeFormat' : null
				}
			}
		};
	
	//format localization for date, number and currency
	localeFormat(defaultWidgetProperties, (wpObject.generalProperties.defaultLocalFormat ? wpObject.generalProperties.defaultLocalFormat : 'US'));
		
	
	// add default properties & values where undefined
	_.defaultsDeep(wpObject, defaultWidgetProperties);
	
	//mutate wpObject to assign themes values
	//mis en commentaire pour react
	/* if(bei_themes && wpObject.detailProperties.styles && wpObject.detailProperties.styles.themeScheme){
		let themeScheme = _.filter(bei_themes.schemes, function(o){ return o.name === wpObject.detailProperties.styles.themeScheme});
		if(themeScheme && themeScheme.length === 1){
			
			let themes = _.orderBy(themeScheme[0].schemes, ['priority'], ['desc']);
			themes.forEach(function(t,i){
				let activeTheme = false;
				
				if(!t.condition){
					activeTheme = true;
				} else {
					let widgetContainer = d3.select("#" + wpObject.contextualProperties.tagId);
					let widgetContainerSize;
					if(widgetContainer && widgetContainer.node()){
						widgetContainerSize = widgetContainer.node().getBoundingClientRect();							
					}
					if(t.condition.width){
						if(widgetContainerSize.width){
							if(t.condition.width >= parseInt(widgetContainerSize.width)){
								activeTheme = true;
							}
						}
					}
				}
				
				if(activeTheme){
					let theme = _.filter(bei_themes.themes, function(o){ return o.name === t.name})
					if(theme && theme.length === 1){
						// apply theme generic properties
						if(theme[0].genericValues){
							_.forIn(theme[0].genericValues, function(value, key) {
								if(isCyclic(wpObject.generalProperties) === false){
									deepAssignProperty(wpObject.generalProperties, key, value);
								}
								if(isCyclic(wpObject.detailProperties) === false){
									deepAssignProperty(wpObject.detailProperties, key, value);
								}
							});
						}
						// apply theme properties
						_.merge(wpObject, theme[0].values);
					}
				}
			})
		} else {
			console.log(" alert :'" + wpObject.detailProperties.styles.themeScheme + "' is not setup :(");
		}
	} else if(bei_themes && wpObject.detailProperties.styles && wpObject.detailProperties.styles.themes && wpObject.detailProperties.styles.schemes.length > 0){
		let themes = _.orderBy(wpObject.detailProperties.styles.themes, ['priority'], ['desc']);
		themes.forEach(function(t,i){
			let theme = _.filter(bei_themes.themes, function(o){ return o.name === t.name})
			if(theme && theme.length === 1){
				_.merge(wpObject, theme[0].values);
			}
		})		
	}
	 */
	
	setWidgetSize(wpObject);

	return true;
	
}

function dataFiltering(wpObject){
	
	if(wpObject.detailProperties.dataFiltering.active && wpObject.detailProperties.dataFiltering.restrictionColumn && wpObject.detailProperties.dataFiltering.restrictionColumn.length > 0){
		let restrictionRule = (wpObject.detailProperties.dataFiltering.restrictionRule ? wpObject.detailProperties.dataFiltering.restrictionRule : 'OR');
		let dataset = _.cloneDeep(wpObject.contextualProperties.dataIn);
		dataset.forEach(function(row,i){
			row.filter = true;
			wpObject.detailProperties.dataFiltering.restrictionColumn.forEach(function(col,j){
				let restrictionColumnSign = (wpObject.detailProperties.dataFiltering.restrictionColumnSign ? wpObject.detailProperties.dataFiltering.restrictionColumnSign : '===');
				let columnValues = wpObject.detailProperties.dataFiltering.restrictionColumnToValue[j];
				if( typeof columnValues === 'object' && _.isArray(columnValues) && columnValues.length > 1){
					let intermediaryFilter = true;
					columnValues.forEach(function(colVal,k){
						if(row[col] === colVal){
							intermediaryFilter = false;
						}
					})
					if(intermediaryFilter === false){
						if(restrictionRule === 'OR'){
							row.filter = false;
						} else if(restrictionRule === 'AND'){
							if(j == 0){
								row.filter = false;
							}
						}
					} else {
						if(restrictionRule === 'AND'){
							row.filter = true;
						}
					}
				} else {
					let expressionToEvaluate; 					
					if(wpObject.detailProperties.dataFiltering.restrictionColumnDatatype && wpObject.detailProperties.dataFiltering.restrictionColumnDatatype[j] === 'date'){
						let dateParse = d3.timeParse(wpObject.detailProperties.dataFiltering.restrictionColumnFormat[j]);
						let unixFormat = d3.timeFormat('%s');
						
						let limitVal = dateParse(columnValues), limitNumber = unixFormat(limitVal);
						let dateVal = dateParse(row[col]), dateNumber = unixFormat(dateVal);
												
						expressionToEvaluate = dateNumber + restrictionColumnSign + limitNumber;						
					} else {
						expressionToEvaluate = row[col] + restrictionColumnSign + columnValues;
					}
					
					let evaluate = eval(expressionToEvaluate);
					if(evaluate){
						if(restrictionRule === 'OR'){
							row.filter = false;
						} else if(restrictionRule === 'AND'){
							if(j === 0){
								row.filter = false;
							}
						}
					} else {
						if(restrictionRule === 'AND'){
							row.filter = true;
						}
					}
				}
			})
		})
		
		//wpObject.contextualProperties.dataIn = dataset.filter(function(d){ return d.filter == false;});
		dataset = dataset.filter(function(d){ return d.filter === false;});
		
		//delete row.filter attribute
		dataset.forEach(function(row,i){
			delete row.filter;
		});
		
		return dataset;
	}
	
}

function dataAdjustPct(wpObject){
	
	let cumul = 0;
	
	let formatting = wpObject.detailProperties.calculationFieldsFormat[wpObject.detailProperties.currentCalculationFieldsIndex];
	let column = wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex];
	
	
	//serieIndex
	let series = _.chain(wpObject.contextualProperties.dataOut).map('serieIndex').uniq().value();
	let serieMax = [];
	series.forEach(function(s){
		let serieDataset = wpObject.contextualProperties.dataOut.filter(function(r){ return r.serieIndex === s;})
		serieMax[s] = {'value' : null, 'index' : null};
		cumul = 0;
		serieDataset.forEach(function(d, i){
			if(serieMax[s].index !== null){
				if(serieMax[s].value < d[column]){
					serieMax[s].index = i;
					serieMax[s].value = d[column];
				}
			} else {
				serieMax[s].index = i;
				serieMax[s].value = d[column];
			}
			cumul += Number(d3.format(formatting)(d[column]).replace('%',''))/100;
		})
		serieDataset[serieMax[s].index][column] = 1 - (cumul - serieMax[s].value);
	})

}

function dataPicto(wpObject){

	let data = wpObject.contextualProperties.dataOut;
	
	if(!wpObject.detailProperties.dataPicto || !wpObject.detailProperties.dataPicto.visible || !wpObject.detailProperties.dataPicto.items){
		return false;
	}
	
	wpObject.detailProperties.dataPicto.items.forEach(function(p,i){
		if(data[i]){
			data[i].__picto__ = p;
		}
	});
}

function dataHighlight(wpObject, dataset){
	
	let min = {'value' : null, 'index' : null, 'rule' : null},
		max = {'value' : null, 'index' : null, 'rule' : null};
	
	let calcField = wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex];
	let data;
	
	if(!dataset){
		data = wpObject.contextualProperties.dataOut;
	} else {
		data = dataset;
	}
	
	if(wpObject.generalProperties.chartType === 'forceSimulation'){
		calcField = 'value';
	}
	
	data.forEach(function(d, i){
		d.__index__ = i;
		wpObject.detailProperties.dataHighlight.rules.forEach(function(r, j){
			r.ruleOrder = j;
			switch(r.rule){
				case 'first' :
					if(i === 0){						
						d.__highlightRule__ = r;
					}
					break;
				case 'last' :
					if(i === (data.length - 1)){
						d.__highlightRule__ = r;
					}				
					break;
				case 'min' :
					if(min.index){
						if(min.value > d[calcField]){
							min.index = i;
							min.value = d[calcField];
						}
					} else {
						min.index = i;
						min.value = d[calcField];
						min.rule = r;
					}
					break;
				case 'max' :
					if(max.index){
						if(max.value < d[calcField]){
							max.index = i;
							max.value = d[calcField];
						}
					} else {
						max.index = i;
						max.value = d[calcField];
						max.rule = r;
					}
					break;
				case 'serie' :
					if(d[wpObject.detailProperties.dimensionFields[1]] && r.value === d[wpObject.detailProperties.dimensionFields[1]]){
						d.__highlightRule__ = r;
					} else if(wpObject.detailProperties.serieFields && d[wpObject.detailProperties.serieFields[0]] && r.value === d[wpObject.detailProperties.serieFields[0]]){
						d.__highlightRule__ = r;
					}
					break;
				case 'serieIndex' :
					if((d.serieIndex || d.serieIndex === 0) && r.value === d.serieIndex){
						d.__highlightRule__ = r;
					}
					break;
				case 'axis' :
					if(r.operator){
						if(wpObject.detailProperties.dimensionFieldsDatatype[0] === 'date'){
							let dateParse = d3.timeParse(wpObject.detailProperties.dimensionFieldsFormat[0]);
							let locale = wpObject.contextualProperties.d3viz.localeFormat;
							let dateFormat = locale.format('%s');
							let d1 = dateFormat(dateParse(d[wpObject.detailProperties.dimensionFields[0]]));
							let d2 = dateFormat(dateParse(r.value));
							if(eval(d1 + r.operator + d2)){
								d.__highlightRule__ = r;
							}
						} else if(eval(d[wpObject.detailProperties.dimensionFields[0]] + r.operator + r.value)){
							d.__highlightRule__ = r;
						}
					} else if(r.value === d[wpObject.detailProperties.dimensionFields[0]]){
						d.__highlightRule__ = r;
					}
					break;
				case 'fieldValue' :
					if(r.operator){
						let expressionToEvaluate;						
						if(r.fieldDataType === 'text'){
							expressionToEvaluate = eval("'" + d[r.field] + "'" + r.operator + "'" + r.value + "'");
						} else if(r.fieldDataType === 'date'){
							// à coder
						} else {
							expressionToEvaluate = eval(d[r.field] + r.operator + r.value);
						}
						if(expressionToEvaluate){
							d.__highlightRule__ = r;
						}
					} else if(r.value === d[r.field]){
						d.__highlightRule__ = r;
					}
					break;
				case 'value' :
					if(r.operator){
						if(eval(d[calcField] + r.operator + r.value)){
							d.__highlightRule__ = r;
						}
					} else if(r.value === d[calcField]){
						d.__highlightRule__ = r;
					}
					break;
			}
		})
	})	
	
	if(min.index && (!data[min.index].__highlightRule__ || (data[min.index].__highlightRule__ && data[min.index].__highlightRule__.ruleOrder > min.rule.ruleOrder))){
		wpObject.contextualProperties.dataOut[min.index].__highlightRule__ = min.rule;
	}
	
	if(max.index && (!data[max.index].__highlightRule__ || (data[max.index].__highlightRule__ && data[max.index].__highlightRule__.ruleOrder > max.rule.ruleOrder))){
		wpObject.contextualProperties.dataOut[max.index].__highlightRule__ = max.rule;
	}

	// top/bottom rules are done after because the logic is different
	wpObject.detailProperties.dataHighlight.rules.forEach(function(r, j){
		if(r.rule === 'top' || r.rule === 'bottom'){
			let topDataset = _.cloneDeep(data);
			let order = (r.rule === 'top' ? 'desc' : 'asc');
			topDataset = _.orderBy(topDataset, function(o){return o[calcField]}, order);
			topDataset = topDataset.slice(0, r.value);
			topDataset.forEach(function(t){
				if(!data[t.__index__].__highlightRule__ || data[t.__index__].__highlightRule__.ruleOrder > r.ruleOrder){
					data[t.__index__].__highlightRule__ = r;
				}
			})
		}
	})
	
}

function totalCalculation(wpObject){
		
	wpObject.contextualProperties.total = {'__count__' : 0};
	if(!wpObject.detailProperties.calculationFieldsTotal){
		return null;
	}
	
	wpObject.detailProperties.calculationFieldsTotal.forEach(function(c,i){
		switch(c){
			case '__count__' :
				wpObject.contextualProperties.total[c] = wpObject.contextualProperties.dataOut.length;
				break;
			case '__sum__' :
				wpObject.contextualProperties.total[c] = 0;
				wpObject.contextualProperties.dataOut.forEach(function(d){
					wpObject.contextualProperties.total[c] += d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]];
				});
				break;
			case '__last__' :
				wpObject.contextualProperties.total[c] = 0;
				let nbVal = wpObject.contextualProperties.dataOut.length;
				wpObject.contextualProperties.total[c] = wpObject.contextualProperties.dataOut[nbVal-1][wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]];
				break;
		}
	})	
	
}

function datasetSorting(wpObject, dataset){

	let dimSort, dimDatatype, customSort, data;
	
	if(!dataset){
		data = wpObject.contextualProperties.dataOut;
	} else {
		data = dataset;
	}

	if(!wpObject.detailProperties.dimensionFields){
		wpObject.contextualProperties.dataOut = data;
	} else {
 		if(wpObject.detailProperties.dimensionFields.length === 1){
			customSort = [];
			dimSort = wpObject.detailProperties.dimensionFields;
			dimDatatype = wpObject.detailProperties.dimensionFieldsDatatype;
			customSort[0] = wpObject.contextualProperties.d3viz.axis.dimension.domain;
		} else {
			dimSort = _.chain(wpObject.detailProperties.dimensionFields).clone().reverse().value();
			dimDatatype = _.chain(wpObject.detailProperties.dimensionFieldsDatatype).clone().reverse().value();
			customSort = _.chain(wpObject.contextualProperties.d3viz.axis.dimension.domain).clone().reverse().value();
		}		

		//set order 
		data.forEach(function(d,i){
			d.order = [];
			dimSort.forEach(function(dim, idx){
				if(dimDatatype[idx] === 'text' || dimDatatype[idx] === 'string' || dimDatatype[idx] === 'date'){
					d.order[idx] = customSort[idx].indexOf(d[dim]);
					if(wpObject.detailProperties.dimensionFields.length === 1){
						d.serieIndex = 0;
					} else if(idx === 0){
						d.serieIndex = d.order[idx];
					}
					if(idx === (dimSort.length - 1)){
						d.dimensionIndex = d.order[idx];
					}
				} else if(dimDatatype[idx] === 'numeric' || dimDatatype[idx] === 'number'){
					let x = wpObject.contextualProperties.d3viz.axis[wpObject.contextualProperties.d3viz.axis.dimension.axis];
					d.order[idx] = x(d[dim]);					
				}
			})
		});		
		let orders = [];
		dimSort.forEach(function(dim, idx){
			orders.push("order[" + idx + "]");
		});
		

		wpObject.contextualProperties.dataOut = _.sortBy(data, orders);

	}
}

function setWidgetSize(wpObject, action){

	let container, containerSize, flagSizeChange = false;
	
	
	container = d3.select("#" + wpObject.contextualProperties.tagId);
	
	if(container && container.node()){
		containerSize = container.node().getBoundingClientRect();
	} else {
		throw "container tagId is not existing : " + wpObject.contextualProperties.tagId;
		return false;
	}
	
/* 	if(action === 'resize' || (typeof wpObject.generalProperties.size.width === 'string' && wpObject.generalProperties.size.width.indexOf('%')>0)){
		if(action === 'resize' && wpObject.generalProperties.size.width !== parseInt(containerSize.width)){
			flagSizeChange = true;
		}
		wpObject.generalProperties.size.width = parseInt(containerSize.width);
	} */
	if(typeof wpObject.generalProperties.size.width === 'string' && wpObject.generalProperties.size.width.indexOf('%')>0){
		if(wpObject.generalProperties.size.width !== parseInt(containerSize.width)){
			flagSizeChange = true;
		}
		wpObject.generalProperties.size.width = parseInt(containerSize.width);
	} else if(typeof wpObject.generalProperties.size.width === 'number' && wpObject.generalProperties.size.width !== parseInt(containerSize.width)){
		flagSizeChange = true;
		wpObject.generalProperties.size.width = parseInt(containerSize.width);
	}
	
	/* if(action === 'resize' || (typeof wpObject.generalProperties.size.height === 'string' && wpObject.generalProperties.size.height.indexOf('%')>0)){
		if(action === 'resize' && wpObject.generalProperties.size.height !== parseInt(containerSize.height)){
			flagSizeChange = true;
		}
		wpObject.generalProperties.size.height = parseInt(containerSize.height);
	} */
	if(typeof wpObject.generalProperties.size.height === 'string' && wpObject.generalProperties.size.height.indexOf('%')>0){
		if(wpObject.generalProperties.size.height !== parseInt(containerSize.height)){
			flagSizeChange = true;
		}
		wpObject.generalProperties.size.height = parseInt(containerSize.height);
	} else if(typeof wpObject.generalProperties.size.height === 'number' && wpObject.generalProperties.size.height !== parseInt(containerSize.height)){
		flagSizeChange = true;
		wpObject.generalProperties.size.height = parseInt(containerSize.height);
	}
	
/* 	if(action === 'resize'){
		if(!flagSizeChange){
			return false;
		}
	} */
	if(!flagSizeChange){
		return false;
	}

	return true;
	
}


/*****************************************/
/***     dataset chart computation     ***/
/*****************************************/

function setPieData(wpObject){

	let dataset = {'label' : [], 'values' : [], data : []};
	
	
	//sorting
	if(wpObject.detailProperties.pieChart.fieldSort){
		let fieldSort;
		if(typeof wpObject.detailProperties.pieChart.fieldSort === 'object'){
		} else {
			if(wpObject.detailProperties.pieChart.fieldSort === '__calc__'){
				fieldSort = wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex];
			} else {
				fieldSort = wpObject.detailProperties.pieChart.fieldSort;
			}
			wpObject.contextualProperties.dataOut = _.orderBy(wpObject.contextualProperties.dataOut,[fieldSort], [wpObject.detailProperties.pieChart.fieldSortOrder]);
		}
	}
	
	wpObject.contextualProperties.dataOut.forEach(function(row,i){
		dataset.label.push(row[wpObject.detailProperties.dimensionFields[0]]);
		dataset.values.push(row[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
		dataset.data.push(row);
	})
	
	wpObject.contextualProperties.dataOut = dataset.data;
		
	if(wpObject.detailProperties.pieChart.pieType === 'standard'){
		wpObject.contextualProperties.d3viz.pie.pieData = wpObject.contextualProperties.d3viz.pie.pieFn(dataset.values);
		wpObject.contextualProperties.d3viz.pie.pieData.forEach(function(d,i){
			d.__pct__ = (d.endAngle - d.startAngle)/ (2 * Math.PI);
			d.__value__ = d.value;
			d[wpObject.detailProperties.dimensionFields[0]] = wpObject.contextualProperties.dataOut[i][wpObject.detailProperties.dimensionFields[0]];
			d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]] = wpObject.contextualProperties.dataOut[i][wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]];
		})
	} else if(wpObject.detailProperties.pieChart.pieType === 'gauge'){
		let piedata = {'startAngle' : 0, 'endAngle' : dataset.values[0]* 2 * Math.PI};
		
		let s = deg2rad(wpObject.detailProperties.pieChart.startAngle);
		let e = deg2rad(wpObject.detailProperties.pieChart.endAngle);
		let t;
		if(s < 0){
			if(e < 0){
				t = Math.abs(s) - Math.abs(e);
			} else {
				t = Math.abs(s) + e;
			}
		} else {
			t = e - s;
		}
		let v = t * dataset.values[0];
		let ev = v + s;
		
		piedata = {'startAngle' : s, 'endAngle' : ev, '__value__' : dataset.values[0], 'total' : t};
				
		piedata[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]] = dataset.values[0];
		wpObject.contextualProperties.d3viz.pie.pieData = [piedata];
		
	}
	
}

function linechartDatasetComputing(wpObject){
	
	let margin = wpObject.generalProperties.margin,
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		dataset, x, y, x2, y2;

	if(wpObject.generalProperties.chartType !== 'linechart'){
		return false;
	}

	//axis scale shortcut
	x = wpObject.contextualProperties.d3viz.axis.x;
	x2 = wpObject.contextualProperties.d3viz.axis.x2;
	y = wpObject.contextualProperties.d3viz.axis.y;
	y2 = wpObject.contextualProperties.d3viz.axis.y2;

	dataset = wpObject.contextualProperties.dataOut;
	let series = wpObject.contextualProperties.d3viz.axis.dimension.domain[1];
	let dataSeries = _.groupBy(dataset, function(o){ return o[wpObject.detailProperties.dimensionFields[1]]; });
	let calcField = wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex];
	
	let markerProperties;
	
	dataset = series.map(function(i){
		let datapoints = _.filter(dataSeries[i],function(o){
											return (o[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]] || o[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]] === 0);
										})
										
		let countPoints = datapoints.length;
		datapoints.forEach(function(o,j){
			o.__key__ = o[wpObject.detailProperties.dimensionFields[0]] + "__.__" + o[wpObject.detailProperties.dimensionFields[1]];
			o.serieIndex = dataSeries[i][0].serieIndex;
			//calculate if linechart-point is visible
			markerProperties = wpObject.detailProperties.marker;
			o.__visible__ = markerProperties.visible;
			if(markerProperties.visible){
				let restrictionflag = true;
				if(markerProperties.restrictionColumn){
					markerProperties.restrictionColumn.forEach(function(c,i){
						if(c === '__point__'){
							switch(markerProperties.restrictionColumnToValue[i]){
								case 'first' :
									if(j === 0){
										restrictionflag = false;
									}
									break;
								case 'last' :
									if(j === (countPoints-1)){
										restrictionflag = false;
									}
									break;
								default :
									restrictionflag = false;
							}
						} else if(_.has(o, c) && (markerProperties.restrictionColumnToValue[i] || markerProperties.restrictionColumnToValue[i] === 0)){
							if(o[c] === markerProperties.restrictionColumnToValue[i]){
								restrictionflag = false;
							}
						}
					})
				} else {
					restrictionflag = false;
				}
				o.__visible__ = !restrictionflag;
			}				
		});
		return {
			key : dataSeries[i][0][wpObject.detailProperties.dimensionFields[1]],
			__key__ : dataSeries[i][0][wpObject.detailProperties.dimensionFields[1]],
			x : 0,
			y : 0,
			serieIndex : dataSeries[i][0].serieIndex,
			__highlightRule__ : dataSeries[i][0].__highlightRule__,
			values : datapoints
		};
	});
	
	dataset = _.filter(dataset, function(o){ 
		return o.values.length > 0
		});
		
	let curveModel = d3[wpObject.detailProperties.XYChart.lineInterpolation];
	wpObject.contextualProperties.d3viz.linechart.lineLayout
						.curve(curveModel)
						.x(function(d) { return x(d[wpObject.detailProperties.dimensionFields[0]]); })
						.y(function(d) { return y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]); });
						
	wpObject.contextualProperties.d3viz.linechart.areaLayout
						.curve(curveModel)
						.x(function(d) { return x(d[wpObject.detailProperties.dimensionFields[0]]); })
						.y0(plotHeight)
						.y1(function(d) { return y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]); });

	return dataset;
	
}

function parallelDatasetComputing(wpObject){
	
	let serieDomain, serieField,
		dimensionDomain, dimensionField,
		x, y = [],
		data = wpObject.contextualProperties.dataOut,
		dataset = {'node' : [], 'link' : []};

	let margin = wpObject.generalProperties.margin,
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom;
		
	if(wpObject.generalProperties.chartType !== 'parallel'){
		return false;
	}
	
	wpObject.contextualProperties.d3viz.axis.dimension.domain = [];
	wpObject.contextualProperties.d3viz.axis.measure.domain = [];
	
	// duplication de la fonction de setAxisScales avec les spécifités du parallel chart
	function linearScale(axis, data, linearAxis, calcIndex){
		
		let minExtendFactor = 1, maxExtendFactor = 1, calculateDomain = [],
			calcColumn = wpObject.detailProperties.calculationFields[calcIndex];
		
		
		if(linearAxis.axisMinMaxExtendFactor && linearAxis.axisMinMaxExtendFactor.length === 2){
			minExtendFactor = linearAxis.axisMinMaxExtendFactor[0];
			maxExtendFactor = linearAxis.axisMinMaxExtendFactor[1];
		}
		
		if(wpObject.detailProperties.serieStyle === 'stacked'){
			calcColumn = '__stackValue__';
		} else if(wpObject.detailProperties.serieStyle === 'ranking'){
			calcColumn = '__rankValue__';
		}
		
		if(linearAxis.axisMinMax){
			calculateDomain = linearAxis.axisMinMax;
		} else if(linearAxis.includeOrigin){
			calculateDomain =  d3.extent(data, function(d){	return d[calcColumn];});
			calculateDomain[0] = d3.min([0,calculateDomain[0]]);
		} else {
			calculateDomain =  d3.extent(data, function(d){	return d[calcColumn];});
		}
		
		calculateDomain[0] = calculateDomain[0] * minExtendFactor;
		calculateDomain[1] = calculateDomain[1] * maxExtendFactor;
		
		if(linearAxis.axisReverse){
			let tmp = calculateDomain[0];
			calculateDomain[0] = calculateDomain[1];
			calculateDomain[1] = tmp;
		}
		axis.domain(calculateDomain);
		wpObject.contextualProperties.d3viz.axis.measure.domain.push(axis.domain());
	};
	
	//get series domain
	serieField = wpObject.detailProperties.serieFields[0];
	serieDomain = _.chain(data).map(wpObject.detailProperties.serieFields[0]).uniq().value();

	data.forEach(function(d,i){
		d.serieIndex = serieDomain.indexOf(d[serieField]);
		d.__key__ = d[serieField];
	})
	
	if(wpObject.detailProperties.chartSubtype === 'slopegraph'){		
		dimensionField = wpObject.detailProperties.dimensionFields[0];
		dimensionDomain = _.chain(data).map(dimensionField).uniq().value();
		if(wpObject.detailProperties.dimensionFieldsSortOrder[0] && (wpObject.detailProperties.dimensionFieldsSortOrder[0] === 'asc' || wpObject.detailProperties.dimensionFieldsSortOrder[0] === 'desc')){
			dimensionDomain = _.orderBy(dimensionDomain, function(o){return o;}, [wpObject.detailProperties.dimensionFieldsSortOrder[0]]);
		}
		let calcField = wpObject.detailProperties.calculationFields[0];
		dimensionDomain.forEach(function(domValue,i){
			let rows = _.cloneDeep(data);
			let total = 0;
			rows = _.filter(rows,function(r){
						return (r[dimensionField] === domValue);
					})
					
			if(wpObject.detailProperties.serieStyle === 'ranking'){	//remplacer ce if par un if sur  calculationFieldsSortOrder et calculationFieldsCustomOrder
				rows = _.orderBy(rows, function(o){return o[calcField];}, [wpObject.detailProperties.calculationFieldsSortOrder[0]]);
			}	
			rows.forEach(function(r, j){ 
							r.dimensionIndex = i;
							r.__key__ += "__.__" + domValue;
							r.__rankValue__ = j + 1;
							
							r['__y0__'] = total;
							total += Math.abs(r[calcField]);
							r['__stackValue__'] = total;
							r['__stackHeight__'] = Math.abs(r[calcField]);
							return r;
						});
			
			if(wpObject.detailProperties.serieStyle === 'stacked' || wpObject.detailProperties.serieStyle === 'ranking'){
				y[i] = d3.scaleLinear().range([0, plotHeight]);
			} else {
				y[i] = d3.scaleLinear().range([plotHeight, 0]);
			}
			if(wpObject.detailProperties.parallel.slopeLinearAxis.scalePerDimension){
				linearScale(y[i], rows, wpObject.detailProperties.parallel.slopeLinearAxis, 0);
			}			
			dataset.node = _.concat(dataset.node,rows);		
		})
		if(!wpObject.detailProperties.parallel.slopeLinearAxis.scalePerDimension){
			dimensionDomain.forEach(function(domValue,i){
				linearScale(y[i], dataset.node, wpObject.detailProperties.parallel.slopeLinearAxis, 0);
			})
		}
	} else {
		dimensionDomain = wpObject.detailProperties.calculationFields;
		dimensionDomain.forEach(function(calc,i){
			let rows = _.cloneDeep(data);
			let total = 0;
			//let totalNegative = 0;
			
			rows = _.filter(rows,function(r){
						return (r[calc] || r[calc] === 0);
					})
			
			if(wpObject.detailProperties.serieStyle === 'stacked' || wpObject.detailProperties.serieStyle === 'ranking'){
				rows = _.orderBy(rows, function(o){return o[calc];}, [wpObject.detailProperties.calculationFieldsSortOrder[i]]);
			}
			rows.forEach(function(r, j){ 
							r.dimensionIndex = i;
							r.__key__ += "__.__" + calc;
							r.__rankValue__ = j + 1;
							
							r['__y0__'] = total;
							total += Math.abs(r[calc]);
							r['__stackValue__'] = total;
							r['__stackHeight__'] = Math.abs(r[calc]);
							return r;
						});
			
			if(wpObject.detailProperties.serieStyle === 'stacked' || wpObject.detailProperties.serieStyle === 'ranking'){
				y[i] = d3.scaleLinear().range([0, plotHeight]);
			} else {
				y[i] = d3.scaleLinear().range([plotHeight, 0]);
			}
			linearScale(y[i], rows, wpObject.detailProperties.parallel.linearAxis[i], i);
			
			dataset.node = _.concat(dataset.node,rows);
		})
	}

	let links = _.groupBy(dataset.node, 'serieIndex');
	
	serieDomain.forEach(function(s,i){
		links[i].forEach(function(l,j){
			if(links[i][j] && links[i][j+1]){
				dataset.link.push({'source' : links[i][j],'target' : links[i][j+1], '__key__' : links[i][j].__key__ + '__.__' + links[i][j+1].__key__});
			}
		})
	})
	
	wpObject.contextualProperties.d3viz.axis.dimension.domain = dimensionDomain;
	
	wpObject.contextualProperties.d3viz.axis.dimension.axis = 'x';
	wpObject.contextualProperties.d3viz.axis.measure.axis = 'y';
	x = d3.scalePoint()
			.padding((wpObject.detailProperties.parallel.dimensionPadding ? wpObject.detailProperties.parallel.dimensionPadding : 0))
			.range([0, plotWidth])
			.domain(dimensionDomain);
		
	dataset.node.forEach(function(n,i){
		n.__index__ = i;
		n.x = x(dimensionDomain[n.dimensionIndex]);
		if(wpObject.detailProperties.chartSubtype === 'parallel'){
			switch(wpObject.detailProperties.serieStyle){
				case 'stacked' :
					n.y0 = y[n.dimensionIndex](n['__stackValue__']);
					n.y = y[n.dimensionIndex](n['__y0__']);
					break;
				case 'ranking' :
					n.y = y[n.dimensionIndex](n['__rankValue__']);
					n.y0 = y[n.dimensionIndex](n['__y0__']);
					break;
				default :
					n.y = y[n.dimensionIndex](n[dimensionDomain[n.dimensionIndex]]);
			}
			n.__height__ = y[n.dimensionIndex](n['__stackHeight__']);
		} else if(wpObject.detailProperties.chartSubtype === 'slopegraph'){
			let calcField = wpObject.detailProperties.calculationFields[0];
			switch(wpObject.detailProperties.serieStyle){
				case 'stacked' :
					n.y0 = y[n.dimensionIndex](n['__stackValue__']);
					n.y = y[n.dimensionIndex](n['__y0__']);
					break;
				case 'ranking' :
					n.y = y[n.dimensionIndex](n['__rankValue__']);
					n.y0 = y[n.dimensionIndex](n['__y0__']);
					break;
				default :
					n.y = y[n.dimensionIndex](n[calcField]);
			}			
		}
	})
	
	wpObject.contextualProperties.d3viz.axis.x = x;
	wpObject.contextualProperties.d3viz.axis.y = y;
	
	return dataset;
}

function dotplotDatasetComputing(wpObject){

	let dataset;
	
	let calcFields = wpObject.detailProperties.calculationFields;
	let calcFieldsDatatype = wpObject.detailProperties.calculationFieldsDatatype;
	let calcFieldsFormat = wpObject.detailProperties.calculationFieldsFormat;
	

	if(wpObject.generalProperties.chartType !== 'dotPlot'){
		return false;
	}
	
	dataset = wpObject.contextualProperties.dataOut;
	
	dataset.forEach(function(d,i){			
		d.__key__ = "__.__";
		d.__index__ = i;
		wpObject.detailProperties.serieFields.forEach(function(serie){
			d.__key__ += d[serie] + "__.__";
		});
		
		calcFields.forEach(function(calcF, j){
			if(calcFieldsFormat && calcFieldsFormat[j]){
				dataset[i][calcF] = d3.format(calcFieldsFormat[j])(d[calcF]);
				if(calcFieldsDatatype[j] === 'percentage'){
					dataset[i][calcF] = Number(dataset[i][calcF].replace('%','')/100);
				} else {
					dataset[i][calcF] = Number(dataset[i][calcF]);
				}
			}
		})
	})
		
	return dataset;
	
}

function barchartDatasetComputing(wpObject, action){

	let dataset = {'node' : [], 'link' : []};

	if(wpObject.generalProperties.chartType !== 'barchart'){
		return false;
	}


	let calcFields = wpObject.detailProperties.calculationFields;
	let calcFieldsDatatype = wpObject.detailProperties.calculationFieldsDatatype;
	let calcFieldsFormat = wpObject.detailProperties.calculationFieldsFormat;
	let calcFieldsIndex = wpObject.detailProperties.currentCalculationFieldsIndex;
	
	let bandwidth = wpObject.contextualProperties.d3viz.barchart.bandwidth;
	let step = wpObject.contextualProperties.d3viz.barchart.step;
			
	dataset.node = wpObject.contextualProperties.dataOut;
	
	dataset.node.forEach(function(d,i){
		d.__key__ = "__.__";
		d.__index__ = i;
		wpObject.detailProperties.dimensionFields.forEach(function(dim){
			d.__key__ += d[dim] + "__.__";
		});
		d.benchmarkData = false;

		if(d.order && d.order[0]){
			bandwidth -= bandwidth*d.order[0]*wpObject.detailProperties.XYChart.barBandwithReduction;
		}
		d.bandwidth = bandwidth;
		d.step = step;
		
		if(wpObject.detailProperties.multiCalculationFields && wpObject.detailProperties.multiCalculationFields.active && wpObject.detailProperties.multiCalculationFields.mode === 'range'){
			calcFields.forEach(function(calcField,j){
				if(calcFieldsFormat && calcFieldsFormat[j]){
					dataset.node[i][calcFields[j]] = d3.format(calcFieldsFormat[j])(d[calcFields[j]]);
					if(calcFieldsDatatype[calcFieldsIndex] === 'percentage'){
						dataset.node[i][calcFields[j]] = Number(dataset.node[i][calcFields[j]].replace('%','')/100);
					} else {
						dataset.node[i][calcFields[j]] = Number(dataset.node[i][calcFields[j]]);
					}
				}
			})			
		} else {
			if(calcFieldsFormat && calcFieldsFormat[calcFieldsIndex]){
				dataset.node[i][calcFields[calcFieldsIndex]] = d3.format(calcFieldsFormat[calcFieldsIndex])(d[calcFields[calcFieldsIndex]]);
				if(calcFieldsDatatype[calcFieldsIndex] === 'percentage'){
					dataset.node[i][calcFields[calcFieldsIndex]] = Number(dataset.node[i][calcFields[calcFieldsIndex]].replace('%','')/100);
				} else {
					dataset.node[i][calcFields[calcFieldsIndex]] = Number(dataset.node[i][calcFields[calcFieldsIndex]]);
				}
			}
		}
	})
	
	if(wpObject.detailProperties.multiDimensionStyle === 'stacked'){
		
		let stackPlotData = [];
		let cols = {};
		let stackData;
		let stackAxis;
		
		if(wpObject.generalProperties.orientation === 'vertical'){
			stackAxis = 'x';
		} else {
			stackAxis = 'y';
		}
		
		if(wpObject.detailProperties.XYChart.stackOrder === 'stackOrderAscendingSeries' || wpObject.detailProperties.XYChart.stackOrder === 'stackOrderDescendingSeries'){
			let dims = wpObject.contextualProperties.d3viz.axis.dimension.domain[0];
			let order = (wpObject.detailProperties.XYChart.stackOrder === 'stackOrderAscendingSeries' ? 'asc' : 'desc');
			let resultSerie2 = _.chain(dataset.node).orderBy(calcFields[calcFieldsIndex],order).groupBy( wpObject.detailProperties.dimensionFields[0]).value();
			
			dims.forEach(function(k,i){
				let total = 0;
				resultSerie2[k].forEach(function(r,j){
					r.__start__ = total;
					total += r[calcFields[calcFieldsIndex]];
					r.__end__ = total;
				})
				resultSerie2[k].forEach(function(r,j){
					if(total > 0 && wpObject.detailProperties.XYChart.stackOffset === 'stackOffsetExpand'){
						r.__start__ = r.__start__ / total;
						r.__end__ = r.__end__ / total;
						r.__pct__ = r[calcFields[calcFieldsIndex]] / total;							
					}
					r.__total__ = total;
					stackPlotData.push(r);
				})
			})
			stackData = _.groupBy(stackPlotData,'serieIndex');
			dataset.node.forEach(function(d,i){
				let sIndex = d.serieIndex;
				//let xIndex = d.dimensionIndex;
				let xIndex = _.findIndex(stackData[sIndex], function(o) { return o.dimensionIndex === d.dimensionIndex; });
				if(stackData[sIndex] && stackData[sIndex][xIndex] && stackData[sIndex][xIndex]['__end__']){
					d['__stackValue__'] = stackData[sIndex][xIndex]['__end__'];
					d['__' + stackAxis + '0__'] = stackData[sIndex][xIndex]['__start__'];
					d['__stackHeight__'] = stackData[sIndex][xIndex]['__end__'] - stackData[sIndex][xIndex]['__start__'];
				} else {
					console.log('dataset error');
				}
			})
			
			if(wpObject.detailProperties.XYChart.barchartArea && wpObject.detailProperties.XYChart.barchartArea.active){
				let series = wpObject.contextualProperties.d3viz.axis.dimension.domain[1];
				let linkSerie = _.groupBy(dataset.node, wpObject.detailProperties.dimensionFields[1]);
				dataset.link = [];
				series.forEach(function(s,i){
					linkSerie[s].forEach(function(d,j){
						if(linkSerie[s][j] && linkSerie[s][j+1]){
							dataset.link.push({'source' : linkSerie[s][j], 'target' : linkSerie[s][j+1]});
						}
					})
				})
			}
		} else {
			let keys = wpObject.contextualProperties.d3viz.axis.dimension.domain[1];
			//let resultSerie = _.groupBy(dataset.node, wpObject.detailProperties.dimensionFields[1]);
			
			let rows = wpObject.contextualProperties.d3viz.axis.dimension.domain[0]
			let matrix = [];

			keys.forEach(function(k){
				cols[k] = null;
			});
			
			rows.forEach(function(r,i){
				matrix[i] = _.cloneDeep(cols);
				matrix[i].row = r;
			})
			
			dataset.node.forEach(function(d,i){
				matrix[d.dimensionIndex][d[wpObject.detailProperties.dimensionFields[1]]] = d[calcFields[calcFieldsIndex]];
			})
			
			//console.log(matrix);
			
			let stackOrder = ( d3[wpObject.detailProperties.XYChart.stackOrder] ? d3[wpObject.detailProperties.XYChart.stackOrder] : d3.stackOrderNone);
			let stackOffset = ( d3[wpObject.detailProperties.XYChart.stackOffset] ? d3[wpObject.detailProperties.XYChart.stackOffset] : d3.stackOffsetNone);
			
			let stackGenerator = d3.stack()
						.keys(keys)
						.order(stackOrder)
						.offset(stackOffset);
						
			stackData = stackGenerator(matrix);
						
			dataset.node.forEach(function(d,i){
				let sIndex = d.serieIndex;
				let xIndex = d.dimensionIndex;
				d['__stackValue__'] = stackData[sIndex][xIndex][1];
				d['__' + stackAxis + '0__'] = stackData[sIndex][xIndex][0];
				d['__stackHeight__'] = stackData[sIndex][xIndex][1] - stackData[sIndex][xIndex][0];
			})
		}
		setAxisScales(wpObject, action);
	}

	if(dataset.link){
		dataset.link.forEach(function(l,i){
			l.__key__ = l.source.__key__ + '__.__' + l.target.__key__;
		})
		wpObject.contextualProperties.dataOutLink = dataset.link;
	}

	return dataset;
	
}

function hierarchicalDatasetComputing(wpObject){

	let hierarchicalData, dataset = {'node' : [], 'link' : []};

	let margin = wpObject.generalProperties.margin,
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		xPos, yPos, x, y;
		
	hierarchicalData = wpObject.contextualProperties.dataOut;

	//axis scale shortcut
	x = wpObject.contextualProperties.d3viz.axis.x;
	y = wpObject.contextualProperties.d3viz.axis.y;
	
	let valuesExtent, depthExtent, nodeSizeScale, linkSizeScale, xTranslate, yTranslate;

	if(wpObject.generalProperties.chartType === 'forceSimulation'){
		dataset.node = hierarchicalData.descendants();
		dataset.link = hierarchicalData.links();
		valuesExtent = d3.extent(dataset.node, function(d){ 
											let value = d.value;
											if(wpObject.detailProperties.forceSimulation.negativeValueMapping === 'abs' && d.value < 0){
												value = Math.abs(value);
											} else if(wpObject.detailProperties.forceSimulation.negativeValueMapping === 'zero'  && d.value < 0){
												value = 0;
											}
											d.__adjustedValue__ = value;
											return value;
								});
		depthExtent = d3.extent(dataset.node, function(d){ return d.depth;});
		nodeSizeScale = d3.scaleLinear().domain(valuesExtent).range(wpObject.detailProperties.forceSimulation.nodeSize);
		linkSizeScale = d3.scaleLinear().domain(depthExtent).range(wpObject.detailProperties.forceSimulation.linkSize);
	} else if(wpObject.generalProperties.chartType === 'sunburst'){
		wpObject.contextualProperties.d3viz.sunburst.root = hierarchicalData;
		dataset.node = wpObject.contextualProperties.d3viz.sunburst.partitionFn(hierarchicalData).descendants();
		wpObject.contextualProperties.d3viz.sunburst.focus = hierarchicalData;
	} else if(wpObject.generalProperties.chartType === 'circlePack'){
		let size = d3.min([plotWidth,plotHeight]) - wpObject.detailProperties.circlePack.circlePackPadding;
		
		wpObject.contextualProperties.d3viz.circlePack.root = hierarchicalData;
		wpObject.contextualProperties.d3viz.circlePack.focus = hierarchicalData;
		wpObject.contextualProperties.d3viz.circlePack.diameter = size;			
		wpObject.contextualProperties.d3viz.circlePack.cpLayout.size([size,size]);
		wpObject.contextualProperties.d3viz.circlePack.xPos = plotWidth / 2 + wpObject.detailProperties.circlePack.circlePackPadding/2;
		wpObject.contextualProperties.d3viz.circlePack.yPos = plotHeight / 2+ wpObject.detailProperties.circlePack.circlePackPadding/2;			
		dataset.node = wpObject.contextualProperties.d3viz.circlePack.cpLayout(hierarchicalData).descendants();
		xTranslate = wpObject.contextualProperties.d3viz.circlePack.xPos - hierarchicalData.x;
		yTranslate = wpObject.contextualProperties.d3viz.circlePack.yPos - hierarchicalData.y;
		wpObject.contextualProperties.d3viz.circlePack.view = [wpObject.contextualProperties.d3viz.circlePack.xPos, wpObject.contextualProperties.d3viz.circlePack.yPos, hierarchicalData.r * 2];
	}
	
	let serieIndex = 0;
	let decalage = 1;
	if(!wpObject.detailProperties[wpObject.generalProperties.chartType].rootNode){
		decalage = 0;
	}
	dataset.node.forEach(function(d,i){
		d.__key__ = d.data.key;
		d.__index__ = i;
		if(d.ancestors().length > 0){
			d.ancestors().forEach(function(a){
				if(a.depth > 0){
					d.__key__ += '__.__' + a.data.key;
				}
			})
		}
		d[wpObject.detailProperties.calculationFields[0]] = d.value;
		d.__dimensionValue__ = d.data.key;
		d.__dimensionFields__ = wpObject.detailProperties.dimensionFields[d.depth-decalage];
		if(d.depth === 0 || d.depth === 1){
			if(d.serieIndex || d.serieIndex === 0){
			} else {
				d.serieIndex = serieIndex;
				serieIndex += 1;
			}
			if(!wpObject.detailProperties[wpObject.generalProperties.chartType].rootNode){
				if(d.depth === 0){
					d[wpObject.detailProperties.dimensionFields[0]] = d.data.key;
				} else {
					d[wpObject.detailProperties.dimensionFields[1]] = d.data.key;
					d[wpObject.detailProperties.dimensionFields[0]] = d.parent[wpObject.detailProperties.dimensionFields[0]];
				}
			} else {
				if(d.depth === 1){
					d[wpObject.detailProperties.dimensionFields[decalage]] = d.data.key;
				}
			}
		} else if(d.depth > 1){
			d.serieIndex = d.parent.serieIndex;
			if(wpObject.detailProperties.dimensionFields[d.depth-decalage]){
				d[wpObject.detailProperties.dimensionFields[d.depth-decalage]] = d.data.key;
			}
			if(wpObject.detailProperties.dimensionFields[d.depth-decalage-1]){
				d[wpObject.detailProperties.dimensionFields[d.depth-decalage-1]] = d.parent[wpObject.detailProperties.dimensionFields[d.depth-decalage-1]];
			}
			if(wpObject.detailProperties.dimensionFields[d.depth-decalage-2]){
				d[wpObject.detailProperties.dimensionFields[d.depth-decalage-2]] = d.parent[wpObject.detailProperties.dimensionFields[d.depth-decalage-2]];
			}
			if(wpObject.detailProperties.dimensionFields[d.depth-decalage-3]){
				d[wpObject.detailProperties.dimensionFields[d.depth-decalage-3]] = d.parent[wpObject.detailProperties.dimensionFields[d.depth-decalage-3]];
			}
			if(wpObject.detailProperties.dimensionFields[d.depth-decalage-4]){
				d[wpObject.detailProperties.dimensionFields[d.depth-decalage-4]] = d.parent[wpObject.detailProperties.dimensionFields[d.depth-decalage-4]];
			}
		}
		if(wpObject.generalProperties.chartType === 'forceSimulation'){
			d.__size__ = nodeSizeScale(d.__adjustedValue__);
			d.__linkSize__ = linkSizeScale(d.depth);
		}
		if(wpObject.generalProperties.chartType === 'circlePack'){
			d.__size__ = d.r;
			d.x = d.x + xTranslate;
			d.y = d.y + yTranslate;
		}
	})		
	
	if(wpObject.generalProperties.chartType === 'forceSimulation'){
		dataset.link.forEach(function(l,i){
			l.__key__ = l.source.__key__ + '__.__' + l.target.__key__;
		})
		
		let fsProperties = wpObject.detailProperties.forceSimulation;
		
		if(wpObject.contextualProperties.d3viz.forceSimulation.forceLayout === null){
			wpObject.contextualProperties.d3viz.forceSimulation.forceLayout = d3.forceSimulation();
			
			wpObject.contextualProperties.d3viz.forceSimulation.forceLayout 
				.force("forceX", d3.forceX().strength(.1).x(plotWidth/2))
				.force("forceY", d3.forceY().strength(.1).y(plotHeight/2))
				.force("charge",d3.forceManyBody().strength(fsProperties.chargeStrength))
				.force("collide",d3.forceCollide().radius(function(d){
						return d.__size__ + 10;
						}))
				.force("center",d3.forceCenter().x(plotWidth/2 + margin.left).y(plotHeight/2 + margin.top));				
		} else {
			wpObject.contextualProperties.d3viz.forceSimulation.forceLayout.alphaTarget(0.3).restart();
		}
			
		wpObject.contextualProperties.d3viz.forceSimulation.forceLayout
			.nodes(dataset.node)
			.force("link", d3.forceLink(dataset.link)
					.distance(function(d){ 
						return (d.source.__linkSize__ ? d.source.__linkSize__ : 100);
					})
					.strength(1))
			.on("tick", function(){
				let nodes = wpObject.contextualProperties.d3viz.dom.shapes;
				let links = wpObject.contextualProperties.d3viz.dom.links.selectAll('.link');
				let labels = wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll('.marker');
				if(links){
					links.attr("x1", function(d) { return d.source.x; })
						  .attr("y1", function(d) { return d.source.y; })
						  .attr("x2", function(d) { return d.target.x; })
						  .attr("y2", function(d) { return d.target.y; });
				}
				if(nodes){
					nodes.attr("transform", function(d) { return "translate(" + d.x + "," + d.y + ")"; });
				}
				if(labels){
					labels.attr("transform", function(d) { return "translate(" + d.x + "," + d.y + ")"; });
				}
			});
		
		wpObject.contextualProperties.d3viz.forceSimulation.xPos = margin.left + plotWidth / 2;
		wpObject.contextualProperties.d3viz.forceSimulation.yPos = margin.top + plotHeight / 2;
	} else if(wpObject.generalProperties.chartType === 'circlePack'){
	} else if(wpObject.generalProperties.chartType === 'sunburst'){
		wpObject.contextualProperties.d3viz.sunburst.arcLayout
			.startAngle(d => x(d.x0))
			.endAngle(d => x(d.x1))
			.innerRadius(function(d){
				if(!d.parent){
					return 0;
				} else if(wpObject.contextualProperties.d3viz.sunburst.focus.parent && wpObject.contextualProperties.d3viz.sunburst.focus.parent === d){					
					return 0;
				} else {
					return Math.max(0, y(d.y0));
				}
				//return Math.max(0, y(d.y0));
			})
			.outerRadius(d => Math.max(0, y(d.y1)));
		
		wpObject.contextualProperties.d3viz.sunburst.middleArcLine = d => {
			const halfPi = Math.PI/2;
			const angles = [x(d.x0) - halfPi, x(d.x1) - halfPi];
			const r = Math.max(0, (y(d.y0) + y(d.y1)) / 2);

			const middleAngle = (angles[1] + angles[0]) / 2;
			const invertDirection = middleAngle > 0 && middleAngle < Math.PI; // On lower quadrants write text ccw
			if (invertDirection) { angles.reverse(); }

			const path = d3.path();
			path.arc(0, 0, r, angles[0], angles[1], invertDirection);
			return path.toString();
		};

		wpObject.contextualProperties.d3viz.sunburst.textFits = d => {
			const CHAR_SPACE = 6;

			if(!d){
				return false;
			}
			if(wpObject.contextualProperties.d3viz.sunburst.focus && d.depth < wpObject.contextualProperties.d3viz.sunburst.focus.depth){
				return false;
			}
			const deltaAngle = x(d.x1) - x(d.x0);
			const r = Math.max(0, (y(d.y0) + y(d.y1)) / 2);
			const perimeter = r * deltaAngle;

			return d.data.key.length * CHAR_SPACE < perimeter;
		};
	
		switch(wpObject.detailProperties.sunburst.hPosition){
			case 'left' :
			case 'leftViz' :
				xPos = wpObject.contextualProperties.d3viz.sunburst.outerRadius;
				break;
			case 'leftPlot' :
				xPos = margin.left + wpObject.contextualProperties.d3viz.sunburst.outerRadius;
				break;
			case 'center' :
			case 'centerPlot' :
				xPos = plotWidth/2;
				break;
			case 'centerViz' :
				xPos = vizWidth/2 - wpObject.contextualProperties.d3viz.sunburst.outerRadius/2;
				break;
			case 'right' :
				xPos = plotWidth - wpObject.contextualProperties.d3viz.sunburst.outerRadius;
				break;
		}
		switch(wpObject.detailProperties.sunburst.vPosition){
			case 'top' :
				yPos = wpObject.contextualProperties.d3viz.sunburst.outerRadius;
				break;
			case 'center' :
			case 'centerPlot' :
				yPos = plotHeight/2;
				break;
			case 'centerViz' :
				yPos = vizHeight/2 - wpObject.contextualProperties.d3viz.sunburst.outerRadius/2;
				break;
			case 'right' :
				yPos = plotHeight - wpObject.contextualProperties.d3viz.sunburst.outerRadius;
				break;
		}
		
		wpObject.contextualProperties.d3viz.sunburst.xPos = xPos + wpObject.detailProperties.sunburst.hPadding;
		wpObject.contextualProperties.d3viz.sunburst.yPos = yPos + wpObject.detailProperties.sunburst.vPadding;
	}

	if(dataset.link){
		wpObject.contextualProperties.dataOutLink = dataset.link;
	}
	
	return dataset;
}

function spiderDatasetComputing(wpObject){

	let serieDomain, serieField,
		dimensionDomain, dimensionField, calculateDomain, calculationField,
		dataScope, radius, maxValue, angleSlice, 
		x, y = [], minExtendFactor = 1, maxExtendFactor = 1, 
		data = wpObject.contextualProperties.dataOut;
		

	let margin = wpObject.generalProperties.margin,
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom;
		
	if(wpObject.generalProperties.chartType !== 'spider'){
		return false;
	}

	dimensionField = wpObject.detailProperties.dimensionFields[0];
	calculationField = wpObject.detailProperties.calculationFields[0];
	
	wpObject.contextualProperties.d3viz.axis.dimension.domain = [];
	wpObject.contextualProperties.d3viz.axis.measure.domain = [];

	//series
	let dataSeries;	
	if(wpObject.detailProperties.serieFields && wpObject.detailProperties.serieFields[0]){
		serieField = wpObject.detailProperties.serieFields[0];
		serieDomain = _.chain(data).map(serieField).uniq().value();
		dataSeries = _.groupBy(data, d => d[serieField]);
	} else {
		dataSeries = [];
		dataSeries[0] = ["__All__", data];
	}
	
	//dimension axis
	dataScope = _.chain(data).map(dimensionField).uniq().value();
	dataScope = _.orderBy(dataScope, function(o){return o;}, [wpObject.detailProperties.dimensionFieldsSortOrder[0]]);
	wpObject.contextualProperties.d3viz.axis.dimension.domain = dataScope;
	
	//measure axis
	if(wpObject.detailProperties.spider.linearAxisMinMaxExtendFactor && wpObject.detailProperties.spider.linearAxisMinMaxExtendFactor.length === 2){
		minExtendFactor = wpObject.detailProperties.spider.linearAxisMinMaxExtendFactor[0];
		maxExtendFactor = wpObject.detailProperties.spider.linearAxisMinMaxExtendFactor[1];
	}
	
	if(wpObject.detailProperties.spider.linearAxisMinMax){
		calculateDomain = wpObject.detailProperties.spider.linearAxisMinMax;
	} else {
		calculateDomain =  d3.extent(data, function(d){
			return d[calculationField];
		});
		//check if includeOrigin
		if(wpObject.detailProperties.spider.includeOrigin){
			calculateDomain[0] = d3.min([0,calculateDomain[0]]);
		}
	}
	wpObject.contextualProperties.d3viz.axis.measure.domain = calculateDomain;
	
	
	radius = wpObject.contextualProperties.d3viz.spider.radius =  Math.min(plotWidth/2, plotHeight/2);
	angleSlice = wpObject.contextualProperties.d3viz.spider.angleSlice = Math.PI * 2 / wpObject.contextualProperties.d3viz.axis.dimension.domain.length;
	
	//scale setup
	wpObject.contextualProperties.d3viz.spider.rScale = d3.scaleLinear()
		.range([0, radius])
		.domain(calculateDomain);
		
	let curveModel = d3[wpObject.detailProperties.spider.linearGridlineStyle];
	wpObject.contextualProperties.d3viz.spider.lineLayout
		.curve(curveModel)
		.radius(function(d) { return wpObject.contextualProperties.d3viz.spider.rScale(d[calculationField]); })
		.angle(function(d,i) {	return i*wpObject.contextualProperties.d3viz.spider.angleSlice; });


	//data preparation
	data.forEach(function(d,i){			
		d.__key__ = (d[serieField] ? d[serieField] : "__All__") + "__.__";
		d.__index__ = i;
		d.serieIndex = (serieDomain && serieField ? serieDomain.indexOf(d[serieField]) : 0);
		wpObject.detailProperties.dimensionFields.forEach(function(dim){
			d.__key__ += d[dim] + "__.__";
		});
	})
	
	let dataset = [];
	dataSeries.forEach(function(d,i){
		dataset[i] = {
				serieIndex : i,
				__key__ : "__.__" + d[0] + "__.__",
				x : plotWidth/2,
				y : plotHeight/2,
				values : d[1]				
		};
	})
	
	return dataset;
}

function calculationEngineHierarchy(wpObject){
	
	let result = d3.nest(),
		dataset;

	
	//data filtering first
	if(wpObject.detailProperties.dataFiltering && wpObject.detailProperties.dataFiltering.active){
		dataset = dataFiltering(wpObject);
	} else {
		dataset = _.cloneDeep(wpObject.contextualProperties.dataIn);
	}
	
	
	//build dimension fields
	wpObject.contextualProperties.d3viz.dom['check'] = "l";
	wpObject.detailProperties.dimensionFields.forEach(function(dim,i){
		result = result.key(function(d) { return d[dim];});
	});
	
	//build calculation fields
	result.rollup(function(d) {
		let calcs = {};
		wpObject.detailProperties.calculationFields.forEach(function(calc,i){
			switch(calc){
				case '__count__' :
					calcs[calc] = d3.sum(d, function(e) { return 1; });
					break;
				default :
					calcs[calc] = d3.sum(d, function(e) { return e[calc]; });
					break;
			}
		})
		
		return calcs;
	});
	
	result = result.entries(dataset);

	let calcFieldsIndex = wpObject.detailProperties.currentCalculationFieldsIndex;
	let calcFields = wpObject.detailProperties.calculationFields;
	
	if(wpObject.detailProperties[wpObject.generalProperties.chartType].rootNode || result.length > 1){		
		result = {key : wpObject.detailProperties[wpObject.generalProperties.chartType].rootNodeLabel, 'values' : result};
	} else if(result.length === 1){
		result = result[0];
	}
	
	result = d3.hierarchy(result, function children(d) {return d.values;});

	result.sum(
		d => (d.value && d.value[calcFields[calcFieldsIndex]] ? d.value[calcFields[calcFieldsIndex]] : null)
	);
		
	return result;
	
}

function calculationEngineParallel(wpObject){

	let result = d3.nest(),
		dataset, resultset = [],
		serieFields = wpObject.detailProperties.serieFields,
		dimensionFields = wpObject.detailProperties.dimensionFields,
		calculationFields = wpObject.detailProperties.calculationFields;
	
	function flatten(rows) {
		let nodes = [],
			rowHeaders = {};
		
		rowHeaders[serieFields[0]] = null;
		if(dimensionFields && dimensionFields[0]){
			rowHeaders[dimensionFields[0]] = null;
		}
 		calculationFields.forEach(function(c,i){
			rowHeaders[c] = null;
		});

		rows.forEach(function(r,i){
			let colvalues,
			row = _.clone(rowHeaders);
		
			row['rowId'] = i;
			
			//flatten dimension fields
			colvalues = r.key.split("__.__");
			
			row[serieFields[0]] = colvalues[0];
			if(dimensionFields && dimensionFields[0]){
				row[dimensionFields[0]] = colvalues[1];
			}

			//flatten calculation fields
			calculationFields.forEach(function(c,i){
				if(r.value[c]){
					row[c] = r.value[c];
				}
			});
			nodes.push(row);
		})

		return nodes;
	}

	//data filtering first
	wpObject.contextualProperties.d3viz.dom['check'] = "l";
	if(wpObject.detailProperties.dataFiltering && wpObject.detailProperties.dataFiltering.active){
		dataset = dataFiltering(wpObject);
	} else {
		dataset = _.cloneDeep(wpObject.contextualProperties.dataIn);
	}

	
	//serie field
	result.key(function(d) { 
		let key = d[serieFields[0]];
		if(wpObject.detailProperties.chartSubtype === 'slopegraph'){
			key += ('__.__'  + d[dimensionFields[0]]);
		}
		return key;
	});
		
	//build calculation fields
	result.rollup(function(d) {
		let calcs = {};
			wpObject.detailProperties.calculationFields.forEach(function(calc,i){
			switch(calc){
				case '__count__' :
					calcs[calc] = d3.sum(d, function(e) { return 1; });
					break;
				default :
					calcs[calc] = d3.sum(d, function(e) { return e[calc]; });
					break;
			}
			});
		return calcs;
	});
	resultset = _.concat(resultset,result.entries(dataset));	
	
	result = flatten(resultset);
	
	return result;
}

function calculationEngine(wpObject, action){
	
	let result = d3.nest(),
		dataset,
		dimensionFields = wpObject.detailProperties.dimensionFields,
		calculationFields = wpObject.detailProperties.calculationFields;

	function flatten(rows) {
		let nodes = [],
			rowHeaders = {};
		
		dimensionFields.forEach(function(c){
			if( typeof c === 'string'){
				rowHeaders[c] = null;
			} else {
				rowHeaders[c.id] = null;
			}
		});
		calculationFields.forEach(function(c,i){
			rowHeaders[c] = null;
		});

		rows.forEach(function(r,i){
			let colname, colvalues,
			row = _.clone(rowHeaders);
		
			row['rowId'] = i;
			
			//flatten dimension fields
			colvalues = r.key.split("__.__");
					
			colvalues.forEach(function(c,i){
				colname = dimensionFields[i];
				row[colname] = c;
			});

			//flatten calculation fields
			calculationFields.forEach(function(c,i){
				row[c] = r.value[c];
			});
			nodes.push(row);
		})

		return nodes;
	}

	//data filtering first	
	wpObject.contextualProperties.d3viz.dom['check'] = "l";
	if(action === 'init' && wpObject.detailProperties.dataFiltering && wpObject.detailProperties.dataFiltering.active && wpObject.detailProperties.XYChart && wpObject.detailProperties.XYChart.linearAxisMinMaxOnDataset){
		dataset = _.cloneDeep(wpObject.contextualProperties.dataIn);
	} else {
		if(wpObject.detailProperties.dataFiltering && wpObject.detailProperties.dataFiltering.active){
			dataset = dataFiltering(wpObject);
		} else {
			dataset = _.cloneDeep(wpObject.contextualProperties.dataIn);
		}
	}
	
	//build dimension fields
	result.key(function(d) {
		let key;
		wpObject.detailProperties.dimensionFields.forEach(function(dim,i){
			if(i > 0){
				key += ('__.__'  + d[dim]);
			} else {
				key = d[dim];
			}
		});
		
		return key;
	});
	
	//build calculation fields
	let calcsCum = [];
	wpObject.detailProperties.calculationFields.forEach(function(calc,i){
		calcsCum[i] = 0;
	})
	
	result.rollup(function(d) {
		let calcs = {};		
		//wpObject.detailProperties.calculationFields.forEach(function(calc,i){			
		wpObject.detailProperties.calculationFieldsFormula.forEach(function(calc,i){	
			let field = wpObject.detailProperties.calculationFields[i];
			switch(calc){
				case '__count__' :
					calcs[field] = d3.sum(d, function(e) { return 1; });
					break;
				case '__cumSum__' :
					let calcTmp = d3.sum(d, function(e) {return e[field];});
					calcsCum[i] += calcTmp;
					calcs[field] = calcsCum[i];
					break;
				default :
					calcs[field] = d3.sum(d, function(e) {return e[field];});
					break;
			}
		})
		
		return calcs;
	});
		
	
	result = result.entries(dataset);
	
	let flatResult = flatten(result);

	return flatResult;
	
}


/*******************************************/
/***     	chart elements drawing 		***/
/*****************************************/

function drawWidget(wpObject, action, onlyDataPreparation){

	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		data, link, x, y, x2, y2, shapes, linkNodes, bandwidth, step, pieRadius, xPos = 0, yPos = 0;

	

	//reset promises
	wpObject.contextualProperties.promises = [];
	
	//////////////////
	// adjust margin
	//////////////////
		
	if(plotWidth < wpObject.generalProperties.minPlotSize.width){
		if(wpObject.generalProperties.minMargin){
			margin.top = wpObject.generalProperties.minMargin.top;
			margin.bottom = wpObject.generalProperties.minMargin.bottom;
			margin.left = wpObject.generalProperties.minMargin.left;
			margin.right = wpObject.generalProperties.minMargin.right;
		} else {
			margin.left = 25;
			margin.right = 25;
		}
		plotWidth = vizWidth - margin.left - margin.right;
	}
	
	//////////////////
	// add widget containers
	//////////////////
	
	let viz, svgDefs, backgroundViz, backgroundPlot, gridline, plotLink, plot,  foregroundPlot, axis, title, caption, foregroundTotal, foregroundViz;
	
	if(action === null || action === ""){
		action = 'init';
	}
	
	if(action === 'init'){
		d3.selectAll("#" + wpObject.contextualProperties.tagId + " svg").remove();
		d3.selectAll("#" + wpObject.contextualProperties.tagId + " div").remove();
	
		if(wpObject.generalProperties.backgroundColor){
			d3.select("#" + wpObject.contextualProperties.tagId)
				.style("background-color",wpObject.generalProperties.backgroundColor);
		}
		
		viz = wpObject.contextualProperties.d3viz.dom.viz = d3.select("#" + wpObject.contextualProperties.tagId).append("svg")
					.attr("id", "viz_" + wpObject.contextualProperties.tagId)
					.attr("width", "100%")
					.attr("height", "100%")
					.style("overflow",(wpObject.generalProperties.svgOverflow ? wpObject.generalProperties.svgOverflow : null));
		
		wpObject.contextualProperties.d3viz.dom.foregroundHtmlPlot = d3.select("#" + wpObject.contextualProperties.tagId).append("div")
																														.attr("class","foregroundHtmlPlot");
																														
		wpObject.contextualProperties.d3viz.dom.foregroundHtmlViz = d3.select("#" + wpObject.contextualProperties.tagId).append("div")
																														.attr("class","foregroundHtmlViz");
																														
		d3.select(window).on("resize." + wpObject.contextualProperties.tagId, function(){
			let	container = d3.select("#" + wpObject.contextualProperties.tagId);
	
			if(container && container.node()){
				redrawWidget(wpObject, 'resize');
			} else {
				d3.select(window).on("resize." + wpObject.contextualProperties.tagId, null);
			}
		}, false);
		
		//DEFS
		svgDefs = wpObject.contextualProperties.d3viz.dom.svgDefs = viz.append("defs");
		
		//clip Path for the plot area
		svgDefs.append("clipPath")
			.attr("id", 'clipArea_' + wpObject.contextualProperties.tagId)
			.append("rect")
			.attr("class", "rectClipArea")
			.attr("width", plotWidth)
			.attr("height", plotHeight);
		
		//shadow filter
		let filterShadow1 = svgDefs.append("filter")
				.attr("id", 'filterShadow1_' + wpObject.contextualProperties.tagId);
		
		filterShadow1.append("feGaussianBlur")
				.attr('class','filter1')
				.attr('in','SourceAlpha')
				.attr('result','blur')
				.attr('stdDeviation',4);
				
		filterShadow1.append("feOffset")
				.attr('dx',-4)
				.attr('dy',-4);
				
		filterShadow1.append("feFlood")
				.attr('flood-color','grey');
				
		filterShadow1.append("feComposite")
				.attr('in2','blur')
				.attr('operator','in');
				
		let feM1 = filterShadow1.append("feMerge");
		feM1.append("feMergeNode");
		
		feM1.append("feMergeNode")
			.attr('in','SourceGraphic');
				
				
		let filterShadow2 = svgDefs.append("filter")
				.attr("id", 'filterShadow2_' + wpObject.contextualProperties.tagId);

		filterShadow2.append("feGaussianBlur")
				.attr('class','filter1')
				.attr('in','SourceAlpha')
				.attr('result','blur')
				.attr('stdDeviation',10);
				
		filterShadow2.append("feOffset")
				.attr('dx',-4)
				.attr('dy',-4);
				
		filterShadow2.append("feFlood")
				.attr('flood-color','grey');
				
		filterShadow2.append("feComposite")
				.attr('in2','blur')
				.attr('operator','in');
				
		let feM2 = filterShadow2.append("feMerge");
		feM2.append("feMergeNode");
		
		feM2.append("feMergeNode")
			.attr('in','SourceGraphic');


		wpObject.contextualProperties.d3viz.dom.backgroundViz = viz.append("g")
			.attr("class","backgroundViz");

		wpObject.contextualProperties.d3viz.dom.backgroundPlot = viz.append("g")
			.attr("class","backgroundPlot")
			.attr("transform","translate(" + margin.left + "," + margin.top + ")");

		if(wpObject.generalProperties.chartType !== 'pie'){
			wpObject.contextualProperties.d3viz.dom.gridline = viz.append("g")
				.attr("class","gridline");
		}
		wpObject.contextualProperties.d3viz.dom.plotLink = viz.append("g")
			.attr("class","plotLink")
			.style('clip-path',(wpObject.generalProperties.activeClipPath ? 'url(#clipArea_' + wpObject.contextualProperties.tagId + ')' : ''))
			.attr("transform","translate(" + margin.left + "," + margin.top + ")");
			
		wpObject.contextualProperties.d3viz.dom.plot = viz.append("g")
			.attr("class","plot")		
			.style('clip-path',(wpObject.generalProperties.activeClipPath ? 'url(#clipArea_' + wpObject.contextualProperties.tagId + ')' : ''))
			.attr("transform","translate(" + margin.left + "," + margin.top + ")");		
			
		wpObject.contextualProperties.d3viz.dom.foregroundPlot = viz.append("g")
			.attr("class","foregroundPlot")
			.style('clip-path',(wpObject.generalProperties.activeClipPath ? 'url(#clipArea_' + wpObject.contextualProperties.tagId + ')' : ''))
			.attr("transform","translate(" + margin.left + "," + margin.top + ")");


		if(wpObject.generalProperties.chartType === 'linechart' 
			|| wpObject.generalProperties.chartType === 'barchart'
			|| wpObject.generalProperties.chartType === 'dotPlot'
			|| wpObject.generalProperties.chartType === 'parallel'
			|| wpObject.generalProperties.chartType === 'spider'){
			axis = wpObject.contextualProperties.d3viz.dom.axis = viz.append("g")
				.attr("class","axis");
		}
		
		
		//////////////////
		// set title && caption && total container
		//////////////////

		wpObject.contextualProperties.d3viz.dom.title = viz.append("g")
			.attr("class","title");

		wpObject.contextualProperties.d3viz.dom.caption = viz.append("g")
			.attr("class","caption");
		
		wpObject.contextualProperties.d3viz.dom.tooltipMsg = viz.append("g")
			.attr("class","tooltipMsg");
			
		wpObject.contextualProperties.d3viz.dom.foregroundTotal = viz.append("g")
			.attr("class","foregroundTotal");
			
		wpObject.contextualProperties.d3viz.dom.legend = viz.append("g")
			.attr("class","legend");
			
		wpObject.contextualProperties.d3viz.dom.foregroundViz = viz.append("g")
			.attr("class","foregroundViz");
	} else {
		viz = wpObject.contextualProperties.d3viz.dom.viz;
		svgDefs = wpObject.contextualProperties.d3viz.dom.svgDefs;
	}
	
	backgroundViz = wpObject.contextualProperties.d3viz.dom.backgroundViz;
	backgroundPlot = wpObject.contextualProperties.d3viz.dom.backgroundPlot;
	if(wpObject.generalProperties.chartType !== 'pie'){
		gridline = wpObject.contextualProperties.d3viz.dom.gridline;
		axis = wpObject.contextualProperties.d3viz.dom.axis;
	}
	plotLink = wpObject.contextualProperties.d3viz.dom.plotLink;
	plot = wpObject.contextualProperties.d3viz.dom.plot;
	foregroundPlot = wpObject.contextualProperties.d3viz.dom.foregroundPlot;
	wpObject.contextualProperties.d3viz.dom['check'] += "c";
	title = wpObject.contextualProperties.d3viz.dom.title;
	caption = wpObject.contextualProperties.d3viz.dom.caption;
	foregroundTotal = wpObject.contextualProperties.d3viz.dom.foregroundTotal;
	foregroundViz = wpObject.contextualProperties.d3viz.dom.foregroundViz;
	
	plotLink.attr("transform","translate(" + margin.left + "," + margin.top + ")");
	plot.attr("transform","translate(" + margin.left + "," + margin.top + ")");
	foregroundPlot.attr("transform","translate(" + margin.left + "," + margin.top + ")");
	backgroundPlot.attr("transform","translate(" + margin.left + "," + margin.top + ")");	


	//////////////////
	// set axis scales
	//////////////////
	
	if(wpObject.generalProperties.chartType === 'linechart' 
		|| wpObject.generalProperties.chartType === 'barchart' 
		|| wpObject.generalProperties.chartType === 'dotPlot' 
		|| wpObject.generalProperties.chartType === 'sunburst'
		|| wpObject.generalProperties.chartType === 'spider'){
		setAxisScales(wpObject, action);
	}

	
	//////////////////
	// dataset sorting
	//////////////////

	if(wpObject.generalProperties.chartType === 'linechart' ||  wpObject.generalProperties.chartType === 'barchart' ||  wpObject.generalProperties.chartType === 'spider'){
		//pour le moment ne marche pas sur les piechart
		datasetSorting(wpObject);
	}
	
	///////////////////////////////////////////////
	// data adjustment & preparation for rendering
	//////////////////////////////////////////////
	
	if(wpObject.generalProperties.chartType === 'kpi'){
											
		wpObject.contextualProperties.dataOut.forEach(function(row,i){
			row.serieIndex = 0;
			row.__label__ = row.__key__ = row[wpObject.detailProperties.dimensionFields[0]];			
			row.__value__ = row[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]];
		})
		
		data = wpObject.contextualProperties.dataOut;
	} else if(wpObject.generalProperties.chartType === 'pie'){
		
		setPieData(wpObject);
		
		pieRadius = (plotWidth > plotHeight ? plotHeight : plotWidth)/2;
		wpObject.contextualProperties.d3viz.pie.pieRadius = pieRadius;
		wpObject.contextualProperties.d3viz.pie.outerRadius = pieRadius*wpObject.detailProperties.pieChart.outerRadius;
		wpObject.contextualProperties.d3viz.pie.innerRadius = pieRadius*wpObject.detailProperties.pieChart.innerRadius;
		wpObject.contextualProperties.d3viz.pie.arcLayout.outerRadius(wpObject.contextualProperties.d3viz.pie.outerRadius)
			.innerRadius(wpObject.contextualProperties.d3viz.pie.innerRadius)
			.cornerRadius(wpObject.detailProperties.pieChart.cornerRadius)
			.padAngle(wpObject.detailProperties.pieChart.padAngle);
			
		data = wpObject.contextualProperties.dataOut = wpObject.contextualProperties.d3viz.pie.pieData;
		
		switch(wpObject.detailProperties.pieChart.hPosition){
			case 'left' :
			case 'leftViz' :
				xPos = wpObject.contextualProperties.d3viz.pie.outerRadius;
				break;
			case 'leftPlot' :
				xPos = margin.left + wpObject.contextualProperties.d3viz.pie.outerRadius;
				break;
			case 'center' :
			case 'centerPlot' :
				xPos = plotWidth/2;
				break;
			case 'centerViz' :
				xPos = vizWidth/2 - wpObject.contextualProperties.d3viz.pie.outerRadius/2;
				break;
			case 'right' :
				xPos = plotWidth - wpObject.contextualProperties.d3viz.pie.outerRadius;
				break;
		}
		switch(wpObject.detailProperties.pieChart.vPosition){
			case 'top' :
				yPos = wpObject.contextualProperties.d3viz.pie.outerRadius;
				break;
			case 'center' :
			case 'centerPlot' :
				yPos = plotHeight/2;
				break;
			case 'centerViz' :
				yPos = vizHeight/2 - wpObject.contextualProperties.d3viz.pie.outerRadius/2;
				break;
			case 'right' :
				yPos = plotHeight - wpObject.contextualProperties.d3viz.pie.outerRadius;
				break;
		}
		wpObject.contextualProperties.d3viz.pie.xPos = xPos + wpObject.detailProperties.pieChart.hPadding;
		wpObject.contextualProperties.d3viz.pie.yPos = yPos + wpObject.detailProperties.pieChart.vPadding;
		
		//add pie background for gauge
		if(wpObject.detailProperties.pieChart.pieType === 'gauge'){
			
			let bckArc = d3.arc()
							.startAngle(deg2rad(wpObject.detailProperties.pieChart.startAngle))
							.endAngle(deg2rad(wpObject.detailProperties.pieChart.endAngle))
							.cornerRadius(wpObject.detailProperties.pieChart.cornerRadius)
							.innerRadius(wpObject.contextualProperties.d3viz.pie.innerRadius)
							.outerRadius(wpObject.contextualProperties.d3viz.pie.outerRadius);
			
			plot.append('g')				
				.attr("transform", "translate(" + wpObject.contextualProperties.d3viz.pie.xPos + ", " + wpObject.contextualProperties.d3viz.pie.yPos + ")")
				.attr("class","pie pieBckgnd")
				.append("path")				
				.style("fill", "#ddd")
				.attr("d", bckArc);
				
			//add texture to background
			//TODO
		}
	} else if(wpObject.generalProperties.chartType === 'linechart'){
		data = linechartDatasetComputing(wpObject);					
	} else if(wpObject.generalProperties.chartType === 'barchart'){
		let dataset = barchartDatasetComputing(wpObject, action);
		data = dataset.node;
		link = dataset.link;
	} else if(wpObject.generalProperties.chartType === 'dotPlot'){
		data = dotplotDatasetComputing(wpObject);
	} else if(wpObject.generalProperties.chartType === 'sunburst' || wpObject.generalProperties.chartType === 'forceSimulation' || wpObject.generalProperties.chartType === 'circlePack'){
		let dataset = hierarchicalDatasetComputing(wpObject);
		data = dataset.node;
		link = dataset.link;
	} else if(wpObject.generalProperties.chartType === 'parallel'){		
		let dataset = parallelDatasetComputing(wpObject);
		data = dataset.node;
		link = dataset.link;
	} else {
		data = spiderDatasetComputing(wpObject);
	}

	
	//////////////////
	// dataset adjust Percentage
	//////////////////
	
	if(wpObject.detailProperties.calculationFieldsAdjustPct){
		dataAdjustPct(wpObject);

		if(wpObject.generalProperties.chartType === 'linechart' ||  wpObject.generalProperties.chartType === 'barchart' ||  wpObject.generalProperties.chartType === 'sunburst'){
			setAxisScales(wpObject, action);
		}
	}

	//dataPicto
	if(wpObject.detailProperties.dataPicto && wpObject.detailProperties.dataPicto.items.length >0){
		dataPicto(wpObject);
	}
	
	//highlight rules
	if(wpObject.detailProperties.dataHighlight && wpObject.detailProperties.dataHighlight.rules.length > 0 && wpObject.detailProperties.dataHighlight.applyOnAdjustedValue === true){
		dataHighlight(wpObject, data);
	}
	
	//axis scale shortcut
	if(wpObject.generalProperties.chartType === 'linechart' 
		|| wpObject.generalProperties.chartType === 'barchart'
		|| wpObject.generalProperties.chartType === 'dotPlot'
		|| wpObject.generalProperties.chartType === 'sunburst'){
		x = wpObject.contextualProperties.d3viz.axis.x;
		x2 = wpObject.contextualProperties.d3viz.axis.x2;
		y = wpObject.contextualProperties.d3viz.axis.y;
		y2 = wpObject.contextualProperties.d3viz.axis.y2;
	}


	//////////////////
	// set axis scales
	//////////////////
	
	setColorScales(wpObject, data);	
	setTextureScales(wpObject);
	
	let color = wpObject.contextualProperties.d3viz.axis.color;
	let colorGradient = wpObject.contextualProperties.d3viz.axis.colorGradient;
	let areaColorGradient = wpObject.contextualProperties.d3viz.axis.areaColorGradient;
	let highlightAreaColorGradient = wpObject.contextualProperties.d3viz.highlightArea.colorGradient;
	let texture = wpObject.contextualProperties.d3viz.axis.texture;
	let defaultColor = wpObject.detailProperties.defaultColor;

	//////////////////////////////////////////////////////////////
	// si le param onlyDataPreparation = true, on quitte içi, sinon on draw le chart
	/////////////////////////////////////////////////////////	
	
	if(onlyDataPreparation){
		return true;
	}
	
	
	// draw title
	drawTitle(wpObject);
	
	
	//////////////////
	// draw axis
	//////////////////
	
	if(wpObject.generalProperties.chartType === 'linechart' 
		|| wpObject.generalProperties.chartType === 'barchart'
		|| wpObject.generalProperties.chartType === 'dotPlot'){
		drawAxis(wpObject, action);
	} else if(wpObject.generalProperties.chartType === 'parallel'){
		drawParallelAxis(wpObject);
	} else if(wpObject.generalProperties.chartType === 'spider'){
		drawSpiderAxis(wpObject);
	}
	
	
	//////////////////
	// colors
	//////////////////
	
	data.forEach(function(d,i){		
		d.benchmarkData = false;
		d.index = i;
		
		//shapeColor
		if(wpObject.detailProperties.styles && wpObject.detailProperties.styles.colors){
			setShapeColor(wpObject, d);
		} else {
			let shapeColor = getColor(d.serieIndex, d.index, color, defaultColor);
			if(texture[i]){
				shapeColor = texture[i].url();
				d.texture = true;
			} else if(colorGradient && colorGradient[i]){
				shapeColor = "url(#" + colorGradient[i].url + ")";
				d.gradient = true;
			}
			if(wpObject.generalProperties.chartType === 'sunburst' && wpObject.detailProperties.sunburst.depthColorDecreaseMode){
				shapeColor = adjustHierarchyColor(d, wpObject.detailProperties.sunburst, shapeColor);
			}
			if(wpObject.generalProperties.chartType === 'forceSimulation' && wpObject.detailProperties.forceSimulation.depthColorDecreaseMode){
				shapeColor = adjustHierarchyColor(d, wpObject.detailProperties.forceSimulation, shapeColor);
			}
			if(wpObject.generalProperties.chartType === 'circlePack' && wpObject.detailProperties.circlePack.depthColorDecreaseMode){
				shapeColor = adjustHierarchyColor(d, wpObject.detailProperties.circlePack, shapeColor);
			}
			if(d.__highlightRule__ && d.__highlightRule__.color){
				shapeColor = d.__highlightRule__.color;
			}
			d.shapeColor = shapeColor;
		}
	})
		
	//////////////////
	// draw viz
	//////////////////
	
	function shapePosition(d){
		let xPos, yPos;
		if(wpObject.generalProperties.chartType === 'barchart'){
			if(wpObject.generalProperties.orientation === 'horizontal'){
				if(wpObject.detailProperties.XYChart.barchartArea && wpObject.detailProperties.XYChart.barchartArea.active){
					d.x = (x(d[wpObject.detailProperties.dimensionFields[0]]) + (x2 ? x2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
					d.y = y(d.__end__);
				} else {
					d.x = (x(d[wpObject.detailProperties.dimensionFields[0]]) + (x2 ? x2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
					if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'stacked'){
						d.y = plotHeight;
					} else {
						d.y = y(wpObject.contextualProperties.d3viz.axis.measure.domain[0][0]);
					}
				}
			} else {
				if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle == 'stacked'){
					d.x = x(wpObject.contextualProperties.d3viz.axis.measure.domain[0][0]);
				} else {
					d.x = x(wpObject.contextualProperties.d3viz.axis.measure.domain[0][0]);
				}
				d.y = (y(d[wpObject.detailProperties.dimensionFields[0]]) + (y2 ? y2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
			}
			xPos = d.x;
			yPos = d.y;
		} else if(wpObject.generalProperties.chartType === 'dotPlot'){
			xPos = d.x = x(d[wpObject.detailProperties.calculationFields[0]]);
			yPos = d.y = y(d[wpObject.detailProperties.calculationFields[1]]);
		} else if(wpObject.generalProperties.chartType === 'linechart'){
			xPos = d.x = 0;
			yPos = d.y = 0;
		} else if(wpObject.generalProperties.chartType === 'pie'){
			xPos = d.x = wpObject.contextualProperties.d3viz.pie.xPos;
			yPos = d.y = wpObject.contextualProperties.d3viz.pie.yPos;
		} else if(wpObject.generalProperties.chartType === 'kpi'){
			xPos = d.x = 0;
			yPos = d.y = 0;
		} else if(wpObject.generalProperties.chartType === 'sunburst'){
			xPos = d.x = wpObject.contextualProperties.d3viz.sunburst.xPos;
			yPos = d.y = wpObject.contextualProperties.d3viz.sunburst.yPos;
		} else if(wpObject.generalProperties.chartType === 'parallel'){
			let y = wpObject.contextualProperties.d3viz.axis.y[d.dimensionIndex];
			xPos = d.x;
			yPos = (y(wpObject.contextualProperties.d3viz.axis.measure.domain[d.dimensionIndex][1]) + y(wpObject.contextualProperties.d3viz.axis.measure.domain[d.dimensionIndex][0]))/2;
		} else if(wpObject.generalProperties.chartType === 'circlePack'){
			let view = wpObject.contextualProperties.d3viz.circlePack.view;
			let k = wpObject.contextualProperties.d3viz.circlePack.diameter / view[2];
			xPos = d.x = (d.x - view[0]) * k + wpObject.contextualProperties.d3viz.circlePack.xPos;
			yPos = d.y = (d.y - view[1]) * k + wpObject.contextualProperties.d3viz.circlePack.yPos;
		} else {
			xPos = d.x;
			yPos = d.y;
		}
		
		return "translate(" + xPos + "," + yPos + ")";
	};


	let countShape = data.length;
	let labelShapes;
	
	if(action === 'init' || action === 'updateData'){
		wpObject.contextualProperties.d3viz.dom['check'] += "h";
		shapes = plot.selectAll(".shapes").data(data,function(d){ return d.__key__;});
		
		//remove shapes
		let animation = wpObject.detailProperties.animation;
		let del_t = d3.transition()						
						.duration((animation.active && animation.duration > 0 ? 600 : 0));
		shapes
		.exit()
		.attr('class','delShapes')		
		.each(function(d){
			let shape = d3.select(this);
			let shapeRemove;
			if(wpObject.generalProperties.chartType === 'dotPlot'){
				if(animation.active && animation.duration > 0){
					shapeRemove = shape.select('circle')
								.transition(del_t);
				} else {
					shapeRemove = shape;
				}
				shapeRemove.attr('r',0);
			} else if(wpObject.generalProperties.chartType === 'barchart'){				
				if(animation.active && animation.duration > 0){
					shapeRemove = shape.transition(del_t);
				} else {
					shapeRemove = shape;
				}
				shapeRemove
					.attr("transform", function(d){
						if(wpObject.generalProperties.orientation === 'horizontal'){
							xPos = d.x;
							yPos = plotHeight;
						} else {
							xPos = d.x;
							yPos = d.y;
						}
						return "translate(" + xPos + "," + yPos + ")";
					});
				
				if(animation.active && animation.duration > 0){
					shapeRemove = shape.select('.shape').transition(del_t);
				} else {
					shapeRemove = shape.select('.shape');
				}
				shapeRemove
					.attr('d',function(d){
						if(wpObject.generalProperties.orientation === 'horizontal'){
							return drawBar(wpObject, d, d.bandwidth, 0, 0);
						} else {
							return drawBar(wpObject, d, 0, d.bandwidth, 0);
						}
					});
			}
		})
		.transition(del_t)
		.on('end', function(){
			d3.select(this).remove();
		});
		
		
		labelShapes = foregroundPlot.selectAll(".marker").data(data,function(d){ return d.__key__;});
		labelShapes.exit().remove();
		
		if(wpObject.generalProperties.chartType === 'forceSimulation' || wpObject.generalProperties.chartType === 'parallel'){
			linkNodes = plotLink.selectAll(".links").data(link,function(d){ return d.__key__;});
			linkNodes.exit().remove();
		} else if(wpObject.generalProperties.chartType === 'barchart' && wpObject.detailProperties.XYChart.barchartArea && wpObject.detailProperties.XYChart.barchartArea.active){
			linkNodes = plotLink.selectAll(".links").data(link,function(d){ return d.__key__;});
			linkNodes.exit().remove();
		}
	} else {
		shapes = plot.selectAll(".shapes");
		labelShapes = foregroundPlot.selectAll(".marker");
		linkNodes = plotLink.selectAll(".links");
	}
	
	if(action === 'init' || shapes.enter().size() > 0){
		
		if(wpObject.generalProperties.chartType === 'forceSimulation'){
			linkNodes
				.enter()
				.append("g")
				.attr("class", "links")
				.append("line")
					.attr("class", "link")
					.attr("x1", function(d) { return d.source.x; })
					.attr("y1", function(d) { return d.source.y; })
					.attr("x2", function(d) { return d.target.x; })
					.attr("y2", function(d) { return d.target.y; })
					.style("opacity", 0)
					.style("stroke",function(d){
						d.__stroke__ = (wpObject.detailProperties.forceSimulation.linkStroke ? wpObject.detailProperties.forceSimulation.linkStroke : 'black');
						return d.__stroke__;
					})
					.style("stroke-width",function(d){
						d.__strokeWidth__ = (wpObject.detailProperties.forceSimulation.linkStrokeWidth ? wpObject.detailProperties.forceSimulation.linkStrokeWidth : 1);
						return d.__strokeWidth__;
					});
			
			linkNodes = plotLink.selectAll(".links");
			wpObject.contextualProperties.d3viz.dom.links = linkNodes;
		} else if(wpObject.generalProperties.chartType === 'parallel'){
			
			let links = linkNodes
				.enter()
				.append("g")
				.attr("class", "links");
			
			links
				.append("path")
				.attr("class", "link")
				.attr("d", function(d){
					let y = wpObject.contextualProperties.d3viz.axis.y[d.source.dimensionIndex];
					let decalageStart = 0;
					let decalageEnd = 0;
					let nodePadding = wpObject.detailProperties.parallel.nodePadding/2;
					let shape;

					if(d.source.dimensionIndex === 0){
						decalageStart = wpObject.detailProperties.parallel.nodeWidth;
					}
					if(d.target.dimensionIndex > 0){
						decalageEnd = wpObject.detailProperties.parallel.nodeWidth;
					}
					let avgY = (y(wpObject.contextualProperties.d3viz.axis.measure.domain[d.source.dimensionIndex][1]) + y(wpObject.contextualProperties.d3viz.axis.measure.domain[d.source.dimensionIndex][0]))/2;
					if(wpObject.detailProperties.parallel.nodeShape === 'circle'){						
						shape = "M" + d.source.x + "," + avgY
								+ " L" + d.target.x + "," + avgY;
					} else {
						switch(wpObject.detailProperties.parallel.linkStyle){
							case 'line' :
							case 'angle' :
								shape = "M" + (d.source.x + decalageStart) + "," + d.source.y
									+ " V" + d.source.y
									+ " L" + (d.target.x - decalageStart) + "," + d.target.y
									+ " V" +  d.target.y
									+ " Z";
								break;
							case 'curve' :
								shape = "M" + (d.source.x + decalageStart) + "," + (d.source.y + d.source.__height__)
									+ " V" + (d.source.y + d.source.__height__ - nodePadding*2)
									+ " C" + (d.source.x + d.target.x)/2 + "," + ((d.source.y + nodePadding))
									+  " " + (d.source.x + d.target.x)/2 + "," + (d.target.y  - nodePadding*2)
									+  " " + (d.target.x - decalageEnd) + "," + (d.target.y  - nodePadding*2)
									+ " V" +  d.target.y
									+ " C" + (d.source.x + d.target.x)/2 + "," + d.target.y
									+  " " + (d.source.x + d.target.x)/2 + "," + (d.source.y)
									+  " " + (d.source.x + decalageStart) + "," + (d.source.y + d.source.__height__) 
									+ " Z";						
								break;
						}
					}
					return shape;
				});
			links.style("stroke",(wpObject.detailProperties.parallel && wpObject.detailProperties.parallel.linkStroke ? wpObject.detailProperties.parallel.linkStroke : 'black'));
			linkNodes = plotLink.selectAll(".links");
			wpObject.contextualProperties.d3viz.dom.links = linkNodes;
		} else if(wpObject.generalProperties.chartType === 'barchart' && wpObject.detailProperties.XYChart.barchartArea && wpObject.detailProperties.XYChart.barchartArea.active){
			linkNodes
				.enter()
				.append("g")
				.attr("transform", function(d){
					return shapePosition(d.source);
				})
				.attr("class", "links")
				.append("path")
				.attr("class", "link")
				.attr("d", function(d){
					shapePosition(d.target);
					let decalage = 0;
					let areaShape;
					let stackPadding = (wpObject.detailProperties.multiDimensionStyle === 'stacked' && wpObject.detailProperties.XYChart.stackPadding ? wpObject.detailProperties.XYChart.stackPadding : 0);
					switch(wpObject.detailProperties.XYChart.barchartArea.areaLinkStyle){
						case 'line' : 
							areaShape = "M" + + d.source.bandwidth + ",0" 
									+ " v" + (y.range()[0] - y(d.source.__stackHeight__))
									+ " L" + (x(d.target[wpObject.detailProperties.dimensionFields[0]])- d.source.x) + "," + (d.target.y - d.source.y + y.range()[0] - y(d.target.__stackHeight__))
									+ " v" + -(y.range()[0] - y(d.target.__stackHeight__))
									+ " Z";
							break;
						case 'curve' :
							let sourceX = d.source.bandwidth;
							let sourceY = 0;
							let sourceH = y.range()[0] - y(d.source.__stackHeight__);
							let targetH = y.range()[0] - y(d.target.__stackHeight__);
							let targetX = (x(d.target[wpObject.detailProperties.dimensionFields[0]])- d.source.x);
							let targetY = (d.target.y - d.source.y + y.range()[0] - y(d.target.__stackHeight__));
							areaShape = "M" + sourceX + "," + (sourceH - stackPadding)
								+ " C" + (sourceX + targetX)/2 + "," + ((sourceY) + sourceH)
								+  " " + (sourceX + targetX)/2 + "," + (targetY - stackPadding)
								+  " " + (targetX) + "," + (targetY - stackPadding)
								+ " C" + (sourceX + targetX)/2 + "," + (targetY - targetH)
								+  " " + (sourceX + targetX)/2 + "," + (sourceY + stackPadding)
								+  " " + (sourceX ) + "," + sourceY
								+ " Z";	
					}
					return areaShape;
					})
				.style('opacity',0)
				.style('fill', 'lightgrey');
				
			linkNodes = plotLink.selectAll(".links");
			wpObject.contextualProperties.d3viz.dom.links = linkNodes;
		}
		
		shapes
			.enter()
			.append("g")
			.attr("transform", function(d){
				return shapePosition(d);
			})
			.attr("data-key", function(d){return d.__key__;})
			.attr("class", function(d,i){
				let shapeClass = "shapes ";
				let shapeType;
				if(wpObject.generalProperties.chartType === 'barchart'){
					shapeType = "bar";
				} else if(wpObject.generalProperties.chartType === 'linechart'){
					shapeType = "line";
				} else {
					shapeType = wpObject.generalProperties.chartType;
				} 
				
				if(d.__highlightRule__){
					shapeClass += d.__highlightRule__.class;
				}
				d.__index__ = i;
				d.__classIndex__ = shapeType + "_" + d.serieIndex + '_' + i;
				d.__shapeClasses__ = shapeType + " " + shapeType + "_" + i + " " + d.__classIndex__ + " " + shapeClass;
				d.__shapeTypeClass__ = shapeType;
				
				return d.__shapeClasses__;
			})
			.attr("data-dimension", function(d){
				let value = '/';
				if(wpObject.generalProperties.chartType === 'linechart'){
					value += d.key + '/';
				} else if(wpObject.generalProperties.chartType === 'dotPlot'){
					value += d.__key__ + '/';
				} else if(wpObject.generalProperties.chartType === 'sunburst'){
					if(wpObject.detailProperties.dimensionFields){
						
					}
				} else {
					if(wpObject.detailProperties.dimensionFields){
						wpObject.detailProperties.dimensionFields.forEach(function(dim){
							value += d[dim] + '/';
						});
					}
				}
				return value;
			})
			.each(function(d,i){
				let shape = d3.select(this);
				
				//test if 'bullet' data
				if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'bullet'
					&& d[wpObject.detailProperties.dimensionFields[1]] === wpObject.contextualProperties.d3viz.axis.dimension.domain[1][1]){
					d.benchmarkData = true;
					
					d.benchmarkLineColor = wpObject.detailProperties.XYChart.benchmarkLineColor;
					//search comparator value
					let field = wpObject.detailProperties.dimensionFields[0];
					let subset = data.filter(function(r){
									return r[field]===d[field] && r.order[0] === 0;
								});
					if(subset.length === 1 && subset[0][wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]] < d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]){
						d.benchmarkLineColor = wpObject.detailProperties.XYChart.benchmarkLineAltColor;
					}
				}
				
				if(d.benchmarkData === false){
					//draw & styling area shapes
					if(wpObject.generalProperties.chartType === 'linechart' && wpObject.detailProperties.XYChart.linechartArea){
						let restrictionflag = false;
						if(wpObject.detailProperties.XYChart.areaRestrictionColumn){						
							wpObject.detailProperties.XYChart.areaRestrictionColumn.forEach(function(c,i){
								if(_.has(d, c) && (wpObject.detailProperties.XYChart.areaRestrictionColumnToValue[i] || wpObject.detailProperties.XYChart.areaRestrictionColumnToValue[i] === 0)){
									if(d[c] !== wpObject.detailProperties.XYChart.areaRestrictionColumnToValue[i]){
										restrictionflag = true;
									}
								}
							})
						}
						if(restrictionflag === false){
							d.areaShape = true;
							shape
								.append("path")
								.attr("class", "shape-area")
								.attr("d", function(d){
									let newValues = _.cloneDeep(d.values);
									let val = 0;
									if(wpObject.detailProperties.animation.style === 'alt1'){
										val = (wpObject.contextualProperties.d3viz.axis.measure.domain[0][1] - wpObject.contextualProperties.d3viz.axis.measure.domain[0][0])/2;
									}
									newValues.forEach(function(n){
										n[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]] = val;
									});
									return drawAreachart(wpObject, newValues);
								});
							let areaColor = wpObject.detailProperties.XYChart.areaDefaultColor;
							if(areaColorGradient && areaColorGradient[i]){
								areaColor = "url(#" + areaColorGradient[i].url + ")";
							}
							shape.selectAll('.shape-area')
								.style("fill", areaColor)
								.style("opacity", wpObject.detailProperties.XYChart.areaDefaultOpacity);
						}
					} 
					
					if(wpObject.generalProperties.chartType === 'barchart' && wpObject.detailProperties.tooltip && wpObject.detailProperties.tooltip.active && wpObject.detailProperties.tooltip.detectionArea === 'categoricalAxis'){
						//draw highlightArea
						let highlightAreaProps = wpObject.detailProperties.highlightArea;
						let highlightColor = highlightAreaProps.fill;
						if(highlightAreaColorGradient && highlightAreaColorGradient[i]){
							highlightColor = "url(#" + highlightAreaColorGradient[i].url + ")";
						} else if(highlightAreaProps.defaultGradient){
							highlightColor = "url(#" + highlightAreaColorGradient[0].url + ")";
						}
						shape
							.append("path")
							.attr("class", "shape-highlightArea")
							.style("opacity", 0)
							.style("stroke", highlightAreaProps.strokeColor)
							.style("stroke-width", highlightAreaProps.strokeWidth)
							.style("fill", highlightColor)
							.style("shape-rendering","crispedges")
							.attr("d", function(d){
								if(wpObject.generalProperties.chartType === 'barchart'){
									if(wpObject.generalProperties.orientation === 'horizontal'){
										return drawHighlightArea(wpObject, d, d.bandwidth, (y.range()[0]-y.range()[1]),0, 10);
									} else {
										return drawHighlightArea(wpObject, d, (x.range()[1]-x.range()[0]), d.bandwidth,0, 10);
									}
								}
							});
					}
					
					//draw shapes
					if(wpObject.generalProperties.chartType === 'kpi'){
						if(d.__picto__){
							let p = d.__picto__;
							let pictoContainer = shape
									.insert('g')
									.attr('class','picto');
						
							if(d.__highlightRule__ && d.__highlightRule__.dataPictoItem){
								p = d.__highlightRule__.dataPictoItem;
							}
							
							let picto = pictoContainer
											.appendHTML(p.data);
											
							let pictoScale = (p.scale ? p.scale : 1);
							let pictoWidth = pictoScale * p.width;
							let pictoHeight = pictoScale * p.height;

							picto
								.attr("width", pictoWidth)
								.attr("height", pictoHeight)
								.attr("viewBox","0 0 " + pictoWidth + " " + pictoHeight);
								
							pictoContainer.select('g')
								.attr("transform", "translate(0,0) scale(" + pictoScale + ")");
								
							if(p.fill){
								picto.selectAll('path').style('fill',p.fill);
								picto.selectAll('rect').style('fill',p.fill);
							}
							if(p.stroke){
								picto.selectAll('path').style('stroke',p.stroke);
								picto.selectAll('rect').style('stroke',p.stroke);
							}

							let size = d3DomElementSize(pictoContainer);
							xPos = getHorizontalPosition(wpObject, size, p);
							yPos = getVerticalPosition(wpObject, size, p);
							
							pictoContainer
								.attr("transform", "translate(" + xPos + ", " + yPos + ")");
						}
					} else if(wpObject.generalProperties.chartType === 'circlePack'){
						shape
							.append("circle")
							.attr("class", "shape")
							.attr("r", 0);
					} else if(wpObject.generalProperties.chartType === 'forceSimulation'){						
						shape
							.append("circle")
							.attr("class", "shape")
							.attr("r",function(d){ return d.__size__;})
							.call(d3.drag()
								.on("start", function(d){ dragstarted(d, wpObject)})
								.on("drag", dragged)
								.on("end", function(d){ dragended(d, wpObject)})
							);
					} else if(wpObject.generalProperties.chartType === 'parallel'){
						switch(wpObject.detailProperties.parallel.nodeShape){
							case 'rectangle' :
								shape
									.append("path")
									.attr("class", "shape")
									.attr("d",function(d){
										return drawBar(wpObject, d, wpObject.detailProperties.parallel.nodeWidth, d.__height__, wpObject.detailProperties.parallel.nodeRadius);
									});
								break;
							case 'circle' :
/* 								shape
									.append("circle")
									.attr("class", "shape")
									.attr("r",function(d){ return wpObject.detailProperties.parallel.nodeWidth;}); */
									
								shape
									.append("path")
									.attr("class", "shape")
									.attr("d", function(d){ return drawCirclePath(wpObject, d, 0)});	
								break;
						}
					} else if(wpObject.generalProperties.chartType === 'dotPlot'){
						let dotProperties = wpObject.detailProperties.XYChart;
						shape
							.append("path")
							.attr("class", "shape")
							.attr("d", function(d){ return drawCirclePath(wpObject, d, 0)})
							.style("fill", d.shapeColor)
							.style("fill-opacity", dotProperties.nodeFillOpacity)
							.style("stroke", dotProperties.nodeStroke)
							.style("stroke-opacity", dotProperties.nodeStrokeOpacity)
							.style("stroke-width", dotProperties.nodeStrokeWidth);
								
					} else {
						shape
							.append("path")
							.attr("class", "shape")
							.attr("d", function(d){
								if(wpObject.generalProperties.chartType === 'barchart'){
									if(wpObject.generalProperties.orientation === 'horizontal'){
										return drawBar(wpObject, d, d.bandwidth, 0, 0);
									} else {
										return drawBar(wpObject, d, 0, d.bandwidth, 0);
									}
								} else if(wpObject.generalProperties.chartType === 'linechart'){
									let newValues = _.cloneDeep(d.values);
									let val = 0;
									if(wpObject.detailProperties.animation.style === 'alt1'){
										val = (wpObject.contextualProperties.d3viz.axis.measure.domain[0][1] + wpObject.contextualProperties.d3viz.axis.measure.domain[0][0])/2;
									}
									newValues.forEach(function(n){
										n[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]] = val;
									});
									return drawLinechart(wpObject, newValues);
								} else if(wpObject.generalProperties.chartType === 'pie'){
									let dInit = {'startAngle' : d.startAngle, 'endAngle' : d.startAngle};
									d.initEndAngle = d.startAngle;
									return wpObject.contextualProperties.d3viz.pie.arcLayout(dInit);
								} else if(wpObject.generalProperties.chartType === 'sunburst'){
									let dInit = _.cloneDeep(d);
									dInit.x1 = dInit.x0;
									return wpObject.contextualProperties.d3viz.sunburst.arcLayout(dInit);
								} else if(wpObject.generalProperties.chartType === 'spider'){
									let newValues = _.cloneDeep(d.values);
									let val = 0;
									newValues.forEach(function(n){
										n[wpObject.detailProperties.calculationFields[0]] = val;
									});
									return wpObject.contextualProperties.d3viz.spider.lineLayout(newValues);
								}
							});
						
						
						if(wpObject.generalProperties.chartType === 'sunburst'){
							shape
								.append('path')
								.attr('class', 'hidden-arc')
								//.attr('id', (_, i) => `hiddenArc${i}`)
								.attr('id', 'hiddenArc'+i)
								.attr('d', wpObject.contextualProperties.d3viz.sunburst.middleArcLine)
								.style('fill', 'none')
								.style('stroke', 'none');
						}
					}
					//on laisse le styling du forceSimulation içi car on ne passe dans updateShapes
					if(wpObject.generalProperties.chartType === 'forceSimulation'){
						let fsProperties = wpObject.detailProperties.forceSimulation;
						shape.selectAll('.shape')
							.style("opacity",0)
							.style("fill", d.shapeColor)
							.style("stroke", fsProperties.stroke)
							.style("stroke-width", fsProperties.strokeWidth)
					}
				} else {
					//shape
					d.__strokeWidth__ = wpObject.detailProperties.XYChart.benchmarkLineWidth;
					shape
						.append("path")
						.attr("class", "shape")
						.attr("d", function(d){
							if(wpObject.generalProperties.orientation === 'horizontal'){
								return drawLine(wpObject, d, d.bandwidth, 0);
							} else {
								return drawLine(wpObject, d, 0, d.bandwidth);
							}
						})
						.style("stroke", function(d){ return d.benchmarkLineColor;})
						.style("stroke-width", d.__strokeWidth__)
						.style("stroke-dasharray", wpObject.detailProperties.XYChart.benchmarkLineDashArray);
				}
			});

		shapes = plot.selectAll(".shapes");
		wpObject.contextualProperties.d3viz.dom.shapes = shapes;
		
		//used to position properly piechart outside label 
		let tmpPieLabelIndex = 1;
		
		//labels & markers
		//foregroundPlot.selectAll("g").remove();
		labelShapes
			.enter()
			.append("g")
			.attr("transform", function(d){			
				return shapePosition(d);
			})
			.attr("class", function(d,i){
				let shapeClass = 'marker';
				
				if(d.__highlightRule__){
					shapeClass += ' ' + d.__highlightRule__.class;
				}
				
				return shapeClass;
			})
			.each(function(d,i){
				let labelShape = d3.select(this);
				
				//label
				if(wpObject.generalProperties.chartType !== 'linechart' && wpObject.generalProperties.chartType !== 'spider'){
					//check restriction
					let restrictionflag = false;
					if(wpObject.detailProperties.label.restrictionColumn){
						restrictionflag = true;
						wpObject.detailProperties.label.restrictionColumn.forEach(function(c,i){
							if(_.has(d, c) && (wpObject.detailProperties.label.restrictionColumnToValue[i] || wpObject.detailProperties.label.restrictionColumnToValue[i] === 0)){
								if(d[c] === wpObject.detailProperties.label.restrictionColumnToValue[i]){
									restrictionflag = false;
								}
							}
						})
					}
					if(restrictionflag === true){
						return true;
					}
					
					let gLabel = labelShape
						.insert('g')
						.attr('class','glabel');
							
					let txtLabel = gLabel.insert("text")
							.attr('class','label');
					
					//find labelFormat
					let ccfIdx = wpObject.detailProperties.currentCalculationFieldsIndex;
					
					if(wpObject.detailProperties.calculationFieldsFormat && wpObject.detailProperties.calculationFieldsFormat[ccfIdx] && wpObject.detailProperties.calculationFieldsFormat[ccfIdx] !== 'none'){
						d.variableFormat = wpObject.detailProperties.calculationFieldsFormat[ccfIdx];
					}
					
					//draw label content
					if(wpObject.generalProperties.chartType !== 'sunburst'){
						drawLabel(wpObject, d, txtLabel);
					}
					
					if(wpObject.generalProperties.chartType === 'pie'){
						txtLabel
							.attr('x',0)
							.attr('y',0);

						if(wpObject.detailProperties.pieChart.pieType === 'gauge'){
							let labelSize = d3DomElementSize(gLabel);
		
							if(wpObject.detailProperties.pieChart.gaugeLabelUnderline){
								gLabel.insert('line')
									.attr('x2', 0)
									.style('stroke-width', 2)
									.style('stroke', d.shapeColor);
							}
							
							let xPos, ypos, relPos = 0;
							
							if(wpObject.detailProperties.label.relativePosition === 'outside'){
								relPos = pieRadius;
							} else {
								gLabel.select('text').attr('dy', '0.3em');
							}
							switch(wpObject.detailProperties.label.position){
								case 'bottom' :
									xPos = 0;
									yPos = relPos;
									break;
								case 'center' :
									xPos = 0;
									yPos = relPos;
									break;
								case 'right' :
									xPos = relPos;
									yPos = pieRadius/2;
									break;							
							}
							xPos += wpObject.detailProperties.label.hPadding;
							yPos += wpObject.detailProperties.label.vPadding;
							gLabel
								.attr("transform","translate(" + xPos + ", " + yPos + ")");
						} else {
							let centroid;
							let yFactor = 1;
							
							if(wpObject.detailProperties.label.relativePosition === 'inside'){
								centroid = wpObject.contextualProperties.d3viz.pie.arcLayout.centroid(d);
							} else {
								let radius = wpObject.detailProperties.pieChart.outerRadius;
								if(wpObject.detailProperties.label.padding < 0 && wpObject.detailProperties.pieChart.innerRadius > 0){
									radius = wpObject.detailProperties.pieChart.innerRadius;
								}
								let padding = wpObject.detailProperties.label.padding;
								if(!wpObject.detailProperties.pieChart.labelLine && d.__pct__ < 0.06 && d.index%2 === 0){
									padding = wpObject.detailProperties.pieChart.labelAltPadding;
								} else if(wpObject.detailProperties.pieChart.labelLine && d.__pct__ < 0.06 ){
									yFactor += (0.05* tmpPieLabelIndex);									
									tmpPieLabelIndex += 1;
									if(d.index === (countShape - 1)){
										yFactor = 1;
									}
								}
								
								let arcLabel = d3.arc()
												.outerRadius((wpObject.contextualProperties.d3viz.pie.pieRadius + padding) * radius * yFactor)
												.innerRadius((wpObject.contextualProperties.d3viz.pie.pieRadius + padding) * radius * yFactor);
												
								centroid = arcLabel.centroid(d);
								
								if(wpObject.detailProperties.pieChart.labelLine){
									let lineColor;
									if(wpObject.detailProperties.pieChart.labelLineColor === '__shapeColor__' && d.shapeColor){
										lineColor = d.shapeColor;
									} else {
										lineColor = wpObject.detailProperties.pieChart.labelLineColor;
									}
									let polyline = labelShape.insert('polyline')
														.attr('class', 'pieLineLabel')														
														.attr('points', function(d) {
															let arcCentroid = wpObject.contextualProperties.d3viz.pie.arcLayout.centroid(d);
															let pos = arcLabel.centroid(d);
															//pos[0] = 150 * 0.80 * (midAngle(d) < Math.PI || d.index === (countShape - 1)? 1 : -1);
															pos[0] = wpObject.detailProperties.pieChart.labelLineLength * 0.80 * (midAngle(d) < Math.PI ? 1 : -1);
															return [arcCentroid, centroid, pos]
														})
														.style('fill','transparent')
														.style('stroke-width', wpObject.detailProperties.pieChart.labelLineWidth)
														.style('stroke', lineColor);
								}								
							}							
							xPos = centroid[0];
							yPos = centroid[1];
							if(wpObject.detailProperties.label.relativePosition === 'outside' && wpObject.detailProperties.pieChart.labelLine){
								//xPos =  150 * 0.80 * (midAngle(d) < Math.PI || d.index === (countShape - 1) ? 1 : -1);
								xPos =  wpObject.detailProperties.pieChart.labelLineLength * 0.80 * (midAngle(d) < Math.PI ? 1 : -1);
								if(xPos < 0){
									d.__labelPosition__ = "left";
									xPos -= wpObject.detailProperties.pieChart.labelLinePadding;
								} else {
									d.__labelPosition__ = "right";
									xPos += wpObject.detailProperties.pieChart.labelLinePadding;
								}
							} else if(d.index === (countShape - 1)){
								xPos += 5;
							}
							
							gLabel
								.attr("transform","translate(" + xPos + ", " + yPos + ")");
							gLabel.select('text').attr('dy', '0.3em');
						}
					} else if(wpObject.generalProperties.chartType === 'barchart'){
						let xPos = wpObject.detailProperties.label.hPadding;
						let yPos = wpObject.detailProperties.label.vPadding;
						if(wpObject.generalProperties.orientation === 'horizontal'){
							txtLabel
								.attr('x', d.bandwidth / 2);
							
							txtLabel.selectAll('tspan')
								.attr('x', d.bandwidth / 2);
							if(wpObject.generalProperties.chartType === 'barchart' && wpObject.detailProperties.XYChart.barchartArea && wpObject.detailProperties.XYChart.barchartArea.active && d.dimensionIndex === 0){
								xPos = -xPos;
							}
						} else {
							txtLabel
								.attr('dy', '0.35em')
								.attr('y', d.bandwidth / 2 + wpObject.detailProperties.label.vPadding);
						}
						if(wpObject.detailProperties.multiDimensionStyle === 'diverging'){
							xPos = 0;
							yPos = 0;
						}
						gLabel
							.attr("transform","translate(" + xPos + ", " + yPos + ")");
					} else if(wpObject.generalProperties.chartType === 'kpi'){
						let size = d3DomElementSize(gLabel);
						xPos = getHorizontalPosition(wpObject, size, wpObject.detailProperties.label);
						yPos = getVerticalPosition(wpObject, size, wpObject.detailProperties.label);
						
						labelShape
							.attr("transform","translate(" + xPos + ", " + yPos + ")");
					} else if(wpObject.generalProperties.chartType === 'sunburst'){
						
						if(wpObject.detailProperties.label.labelVisibilityCorrection === 'shadow' && wpObject.detailProperties.label.textShadow && wpObject.detailProperties.label.textShadow.active){
							txtLabel
							  .append('textPath')
							  .attr('class','textShadow')
							  .attr('startOffset', '50%')
							  .attr('xlink:href', '#hiddenArc'+i )
							  .text(d => d.data.key)
							  .style('fill', 'none')
							  .style('stroke', wpObject.detailProperties.label.textShadow.shadowColor)
							  .style('stroke-width', wpObject.detailProperties.label.textShadow.shadowWidth)
							  .style('stroke-opacity', wpObject.detailProperties.label.textShadow.shadowOpacity)
							  .style('stroke-linejoin', 'round');
						}
	  
						txtLabel
							.append('textPath')
							.attr('startOffset','50%')
							//.attr('xlink:href', (_, i) => `#hiddenArc${i}` )
							.attr('xlink:href', '#hiddenArc'+i )
							.text(d => d.data.key);
					} else if(wpObject.generalProperties.chartType === 'circlePack'){
						txtLabel.selectAll('tspan')
								.attr('x', 0);
					} else if(wpObject.generalProperties.chartType === 'parallel'){
						let hPad = (d.dimensionIndex === 0 ? - wpObject.detailProperties.label.hPadding : wpObject.detailProperties.label.hPadding);
						txtLabel
							.attr('x', hPad);
					}
				} else if(wpObject.generalProperties.chartType === 'linechart' || wpObject.generalProperties.chartType === 'spider'){
					//linechart label
					if(wpObject.detailProperties.XYChart.linechartLabel && wpObject.detailProperties.XYChart.linechartLabel.visible){
						let lineChartLabelProps = wpObject.detailProperties.XYChart.linechartLabel;
						let maxDimensionIndex = wpObject.contextualProperties.d3viz.axis.dimension.domain[0].length - 1;
						//foregroundViz
						labelShape
							.append('g')
							.attr('class','linechartLabelContainer')
							//.datum(d)
							.each(function(){
								let position = lineChartLabelProps.position;
								let linechartLabelContainer = d3.select(this);
								let linecharLabelTxt;

								if(position === 'start' || position === 'both'){
									let startPoint = d.values[0];
									if(!lineChartLabelProps.text || lineChartLabelProps.text === 'default'){
										linecharLabelTxt = '[key]';
										linecharLabelTxt = mapVariableValue(linecharLabelTxt, d, null, wpObject);
									} else {
										linecharLabelTxt = mapVariableValue(lineChartLabelProps.text, startPoint, null, wpObject);
									}
									linechartLabelContainer.append('g')
										.attr('class','linechartLabelBlock left')
										.attr('transform',function(){
											let xPos = x(startPoint[wpObject.detailProperties.dimensionFields[0]]) - wpObject.detailProperties.XYChart.linechartLabel.padding;
											//let yPos = y(startPoint[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
											let yPos = (y.range()[1] + y.range()[0])/2;
											return "translate(" + xPos + "," + yPos + ")";
										})
										.append('text')
										.attr('class', 'linechartLabel left')
										.attr('dy', (startPoint.dimensionIndex === 0 ? lineChartLabelProps.Dy : '-1em'))
										.attr('text-anchor',(startPoint.dimensionIndex === 0 ? 'end' : 'middle'))
										.append('tspan')
										.text(linecharLabelTxt);
								}
								if(position === 'end' || position === 'both'){
									let endPoint = d.values[d.values.length-1];
									if(!lineChartLabelProps.text || lineChartLabelProps.text === 'default'){
										linecharLabelTxt = '[key]';
										linecharLabelTxt = mapVariableValue(linecharLabelTxt, d, null, wpObject);
									} else {
										linecharLabelTxt = mapVariableValue(lineChartLabelProps.text, endPoint, null, wpObject);
									}
									linechartLabelContainer.append('g')
										.attr('class','linechartLabelBlock right')
										.attr('transform',function(){
											let xPos = x(endPoint[wpObject.detailProperties.dimensionFields[0]]) + wpObject.detailProperties.XYChart.linechartLabel.padding;
											//let yPos = y(endPoint[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
											let yPos = (y.range()[1] + y.range()[0])/2;
											return "translate(" + xPos + "," + yPos + ")";
										})
										.append('text')
										.attr('class', 'linechartLabel right')
										.attr('dy', (endPoint.dimensionIndex === maxDimensionIndex ? lineChartLabelProps.Dy : '-1em'))
										.attr('text-anchor',(endPoint.dimensionIndex === maxDimensionIndex ? 'start' : 'middle'))
										.append('tspan')
										.text(linecharLabelTxt);
								}
								
								linechartLabelContainer.selectAll('.linechartLabel')
									.style('font-family',lineChartLabelProps.fontFamily)
									.style('font-weight',lineChartLabelProps.fontWeight)
									.style('font-size',lineChartLabelProps.fontSize);
								
								d.labelColor = (lineChartLabelProps.color ? lineChartLabelProps.color : (d.shapeColor ? d.shapeColor : '#000000'));
								linechartLabelContainer.selectAll('.linechartLabel')
									.style('fill', d.labelColor);
								
/* 								if(lineChartLabelProps.Dy){
									linechartLabelContainer.selectAll('.linechartLabel')
										.attr('dy', lineChartLabelProps.Dy);
								} */
								//hightlight
								if(lineChartLabelProps.highlight && lineChartLabelProps.highlight.active){
									linechartLabelContainer.selectAll('.linechartLabel')
										.style('cursor','pointer')
										.on('mouseover', function(d){
											//console.log('highlight line');
											let domElem = plot.selectAll("." + d.__classIndex__ + " .shape");
											if(domElem.size() > 0){
												toggleHighlightShape(wpObject, domElem, d, lineChartLabelProps.highlight, true);
												let labelDomElem = linechartLabelContainer.selectAll(" .linechartLabel");
												toggleHighlightLabel(wpObject, labelDomElem, d, lineChartLabelProps.highlightLabel, foregroundPlot, '.linechartLabel', true);
											}
										})
										.on('mouseleave', function(d){
											let domElem = plot.selectAll("." + d.__classIndex__ + " .shape");
											if(domElem.size() > 0){
												toggleHighlightShape(wpObject, domElem, d, lineChartLabelProps.highlight, false);
												let labelDomElem = linechartLabelContainer.selectAll(" .linechartLabel");
												toggleHighlightLabel(wpObject, labelDomElem, d, lineChartLabelProps, foregroundPlot, '.linechartLabel', false);
											}											
										});
								}
							});
					}

					
					let shapeColor = d.shapeColor;
					//marker
					let markerProperties = wpObject.detailProperties.marker;

					let gMarkerContainer = labelShape
						.insert('g')
						.attr('class','gmarker');
					
					let typePointClass = (wpObject.generalProperties.chartType === 'linechart' ? "linechart-point" : "spider-point");
					
					let markerShapes = gMarkerContainer.selectAll("." + typePointClass).data(d.values, function(d){ return d.__key__});
					
					markerShapes.exit().remove();
					
					let countPoints = d.values.length;
					
					markerShapes
						.enter()
						.append("g")
						.attr("class", typePointClass)
						.attr('transform',function(dmarker, idx){
							if(wpObject.generalProperties.chartType === 'linechart'){
								dmarker.x = x(dmarker[wpObject.detailProperties.dimensionFields[0]]);							
								dmarker.y = (y.range()[1] + y.range()[0])/2;
							} else if(wpObject.generalProperties.chartType === 'spider'){
								let rScale = wpObject.contextualProperties.d3viz.spider.rScale;
								let angleSlice = wpObject.contextualProperties.d3viz.spider.angleSlice;
								dmarker.x = rScale(dmarker[wpObject.detailProperties.calculationFields[0]]) * Math.cos(angleSlice*idx - Math.PI/2);
								dmarker.y = rScale(dmarker[wpObject.detailProperties.calculationFields[0]]) * Math.sin(angleSlice*idx - Math.PI/2);
							}
							return "translate(" + dmarker.x + "," + dmarker.y + ")";
						})
						.on('mouseover',function(d){
							if(wpObject.detailProperties.events.mouseover){
								//show marker
								d3.select(this).select('.linechartMarker').style("opacity", 1);
								//show highlightArea
								if(wpObject.detailProperties.highlightArea.active === true){
									toggleHighlightArea(wpObject, this, d, true);
								}
								//show tooltip
								if(wpObject.detailProperties.tooltip.active === true){
									toggleTooltip(wpObject, this, d, true);
								}
							}
						})
						.on('mouseleave',function(d){
							if(wpObject.detailProperties.events.mouseover){
								//hide marker
								d3.select(this).select('.linechartMarker').style("opacity",function(d){ return (d.__visible__ ? markerProperties.opacity : 0)});
								//hide highlightArea
								if(wpObject.detailProperties.highlightArea.active === true){
									toggleHighlightArea(wpObject, this, d, false);
								}
								//hide tooltip
								if(wpObject.detailProperties.tooltip.active === true){
									toggleTooltip(wpObject, this, d, false);
								}
							}
						})
						.each(function(d,i){
							let markerBlock = d3.select(this);
							
							if(wpObject.detailProperties.tooltip.active === true && wpObject.detailProperties.tooltip.detectionArea === 'categoricalAxis'){
								let areaWidth = wpObject.contextualProperties.d3viz.linechart.step;
								
								//draw highlightArea
								let highlightAreaProps = wpObject.detailProperties.highlightArea;
								let highlightColor = highlightAreaProps.fill;
								if(highlightAreaColorGradient && highlightAreaColorGradient[d[highlightAreaProps.attachementColumn]]){
									highlightColor = "url(#" + highlightAreaColorGradient[d[highlightAreaProps.attachementColumn]].url + ")";
								} else if(highlightAreaProps.defaultGradient){
									highlightColor = "url(#" + highlightAreaColorGradient[0].url + ")";
								}
								markerBlock
									.append("path")
									.attr("class", "shape-highlightArea")
									.style("opacity", 0)
									.style("stroke", highlightAreaProps.strokeColor)
									.style("stroke-width", highlightAreaProps.strokeWidth)
									.style("fill", highlightColor)
									.style("shape-rendering","crispedges")
									.attr("transform","translate(-" + areaWidth/2 + ",0)")
									.attr("d", function(d){
										return drawHighlightArea(wpObject, d, areaWidth, y.range()[0] - d.y, 0, 0);
									});
							}
							d.__shapeColor__ = (markerProperties.strokeColor ? markerProperties.strokeColor : shapeColor);
							d.__opacity__ = (d.__visible__ ? markerProperties.opacity : 0);
							
							if(markerProperties.style === 'square'){
								markerBlock
									.append("rect")
									.attr("class", "linechartMarker")
									.attr("x", -markerProperties.r/2)
									.attr("y", -markerProperties.r/2)
									.attr("width", markerProperties.r)
									.attr("height", markerProperties.r);
							} else {
								markerBlock
									.append("circle")
									.attr("class", "linechartMarker")
									.attr("r", markerProperties.r);
							}
							d3.select(this).select('.linechartMarker')
								.style("stroke-width", markerProperties.strokeWidth)
								.style("stroke", d.__shapeColor__)
								.style("fill", markerProperties.fillColor)
								//.style("opacity", function(d){ return (d.__visible__ ? markerProperties.opacity : 0)});
								.style("opacity", d.__opacity__);

						});
					if(wpObject.detailProperties.tooltip.active === true){
						gMarkerContainer.selectAll('.linechart-point').style('cursor', 'pointer');
					}
					
				}
			})
		
		labelShapes = foregroundPlot.selectAll(".marker");
		
		//styling label
		if(labelShapes  && wpObject.generalProperties.chartType !== 'linechart'){
			stylingLabels(wpObject, labelShapes);
		}

	} else {
		shapes = wpObject.contextualProperties.d3viz.dom.shapes = plot.selectAll(".shapes");
		labelShapes = foregroundPlot.selectAll(".marker");
		
		if(action === 'updateData'){
			labelShapes.data(data);
		}
	}
	
	//////////////////
	// chart element events
	/////////////////
	
	if(shapes && wpObject.generalProperties.chartType !== 'linechart' && wpObject.generalProperties.chartType !== 'spider'){
		if(wpObject.detailProperties.events.mouseover || wpObject.detailProperties.events.click){
			shapes.style('cursor', 'pointer');
		}
		shapes
		.on('mouseover',function(d){
			if(wpObject.detailProperties.events.mouseover){
				//show highlightArea
				if(wpObject.detailProperties.highlightArea.active === true){
					toggleHighlightArea(wpObject, this, d, true);
				}
				if(wpObject.detailProperties.tooltip.active === true && d.benchmarkData === false){
					toggleTooltip(wpObject, this, d, true, 'shape');
				}
				if(wpObject.detailProperties.breadcrumb && wpObject.detailProperties.breadcrumb.active === true ){
					toggleBreadcrumb(wpObject, this, d, true);
				}
				if(wpObject.detailProperties.highlight && wpObject.detailProperties.highlight.active === true ){
					toggleHighlightShape(wpObject, this, d, wpObject.detailProperties.highlight, true);
				}
			}
		})
		.on('mouseleave',function(d){
			if(wpObject.detailProperties.events.mouseover){
				if(wpObject.detailProperties.highlightArea.active === true){
					toggleHighlightArea(wpObject, this, d, false);
				}
				if(wpObject.detailProperties.tooltip.active === true){
					toggleTooltip(wpObject, this, d, false);
				}
				if(wpObject.detailProperties.breadcrumb && wpObject.detailProperties.breadcrumb.active === true ){
					toggleBreadcrumb(wpObject, this, d, false);
				}
				if(wpObject.detailProperties.highlight && wpObject.detailProperties.highlight.active === true ){
					toggleHighlightShape(wpObject, this, d, wpObject.detailProperties.highlight, false);
				}
			}
		})
		.on('click',function(d){
			if(wpObject.detailProperties.events.click){
				if(wpObject.generalProperties.chartType === 'sunburst'){
					sunburstZoom(wpObject, d);
				} else if(wpObject.generalProperties.chartType === 'circlePack'){
					circlePackZoom(wpObject, d);
				} else if(wpObject.generalProperties.chartType === 'forceSimulation'){
					forceClick(wpObject, d);
				}
			}
		});
	}

	if(linkNodes){
		if(wpObject.detailProperties.events.mouseover || wpObject.detailProperties.events.click){
			linkNodes.style('cursor', 'pointer');
		}
		linkNodes
		.on('mouseover',function(d){
			if(wpObject.detailProperties.events.mouseover){

				if(wpObject.detailProperties.tooltip.active === true){
					toggleTooltip(wpObject, this, d.target, true , 'link');
				}
				if(wpObject.detailProperties.highlight && wpObject.detailProperties.highlight.active === true ){
					toggleHighlightShape(wpObject, this, d.target, wpObject.detailProperties.highlight, true);
				}
			}
		})
		.on('mouseleave',function(d){
			if(wpObject.detailProperties.events.mouseover){

				if(wpObject.detailProperties.tooltip.active === true){
					toggleTooltip(wpObject, this, d.target, false);
				}

				if(wpObject.detailProperties.highlight && wpObject.detailProperties.highlight.active === true){
					toggleHighlightShape(wpObject, this, d.target, wpObject.detailProperties.highlight, false);
				}
			}
		})
	}
	
	//////////////////
	// draw picto
	//////////////////

	if(wpObject.detailProperties.picto && wpObject.detailProperties.picto.visible && wpObject.detailProperties.picto.items && wpObject.detailProperties.picto.items.length > 0){
		drawPicto(wpObject);
	}

	
	//////////////////
	// draw legend
	//////////////////
		
	drawLegend(wpObject);

	
	//////////////////
	// draw tooltip message
	//////////////////
	
	if(wpObject.detailProperties.tooltip && wpObject.detailProperties.tooltip.message && wpObject.detailProperties.tooltip.message){
		if(wpObject.contextualProperties.d3viz.dom.tooltipMsg.style('display') !== 'none'){
			drawText(wpObject, wpObject.contextualProperties.d3viz.dom.tooltipMsg, wpObject.detailProperties.tooltip.message, null);
		}
	}
	
	//////////////////
	// update shapes
	//////////////////
	
	if(shapes || labelShapes){
		if(wpObject.generalProperties.chartType !== 'forceSimulation'){
			updateShapes(wpObject, shapes);
		} else {
			updateForceSimulationShapes(wpObject, shapes);
		}
	}
	
	/////////////////////
	// draw Reference Lines
	/////////////////////

	drawReferenceLines(wpObject);
	
	/////////////////////
	// draw total calculation
	/////////////////////

	drawTotal(wpObject);
	
	/////////////////////
	// set user action
	/////////////////////
	
	drawUserAction(wpObject);

	
	/////////////////////
	// update annotations
	/////////////////////

//mis en commentaire à cause de react	
/* 	if(typeof beiAnnotations !== 'undefined'){
		if(action === 'init'){
			linkAnnotations(wpObject, beiAnnotations);
		} else if(action === 'updateData'){
			linkAnnotations(wpObject);
		}
	} */
	
	
	
	/////////////////////
	// promises resolve
	/////////////////////
	
	//promises check
	Promise.all(wpObject.contextualProperties.promises).then(endDrawWidget);
	
	function endDrawWidget(){
		console.log('end widget update');
		
		return true;
	}
}

function updateForceSimulationShapes(wpObject, shapes){

	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		panelWidth = plotWidth - padding.left - padding.right,
		panelHeight = plotHeight - padding.top - padding.bottom,
		data = wpObject.contextualProperties.dataOut,
		x, y, x2, y2,
		labelShapes, linkShapes;
		
	let animation = wpObject.detailProperties.animation;
	let upd_t;

	//axis scale shortcut
	if(wpObject.generalProperties.chartType !== 'pie'){
		x = wpObject.contextualProperties.d3viz.axis.x;
		x2 = wpObject.contextualProperties.d3viz.axis.x2;
		y = wpObject.contextualProperties.d3viz.axis.y;
		y2 = wpObject.contextualProperties.d3viz.axis.y2;
	}

	labelShapes = wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll(".marker");
	
	
	//links
	linkShapes = wpObject.contextualProperties.d3viz.dom.plot.selectAll(".links");

	//links
	linkShapes = wpObject.contextualProperties.d3viz.dom.plot.selectAll(".links");
	if(wpObject.generalProperties.chartType === 'forceSimulation'){
		if(animation.active && animation.duration > 0){
			upd_t = d3.transition()
						.ease(d3[animation.ease])
						.duration(animation.duration);
			linkShapes = linkShapes.transition(upd_t);
		}
		linkShapes
			.each(function(d){
				let link = d3.select(this).select('.link')
				let delayFactor = 0;
				switch(animation.incrementationBy){
					case 'index' :
						delayFactor = d.i;
						break;
					case 'serie' :
					case 'serieIndex' :
						delayFactor = d.serieIndex;
						break;
					case 'dimension' :
						delayFactor = d.dimensionIndex;
						break;
					case 'depth' :
						delayFactor = d.source.depth;
						break;
				}
				upd_t = d3.transition()
								.delay(animation.delay + animation.incrementalDelay*delayFactor)
								.ease(d3[animation.ease])
								.duration(animation.duration);
					
				link = link.transition(upd_t);
				
				link
					.style('opacity', function(d){
							d.__opacity__ = (wpObject.detailProperties.forceSimulation.linkOpacity ? wpObject.detailProperties.forceSimulation.linkOpacity : 1);
							return d.__opacity__;
					})
			});

	}
	
	if(shapes){	
		shapes
			.each(function(d, i){
				var shape = d3.select(this);
				if(animation.active && animation.duration > 0){
					let delayFactor = 0;
					switch(animation.incrementationBy){
						case 'index' :
							delayFactor = i;
							break;
						case 'serie' :
						case 'serieIndex' :
							delayFactor = d.serieIndex;
							break;
						case 'dimension' :
							delayFactor = d.dimensionIndex;
							break;
						case 'depth' :
							delayFactor = d.depth;
							break;
					}
					upd_t = d3.transition()
									.delay(animation.delay + animation.incrementalDelay*delayFactor)
									.ease(d3[animation.ease])
									.duration(animation.duration);
	
					shape = shape.transition(upd_t);
					
					shape.select('.shape')
						.style('opacity', function(d){
							d.__opacity__ = (wpObject.detailProperties.forceSimulation.nodeOpacity ? wpObject.detailProperties.forceSimulation.nodeOpacity : 1);
							return d.__opacity__;
						})
				}	
			})
	}
	
}

function updateShapes(wpObject, shapes){

	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		panelWidth = plotWidth - padding.left - padding.right,
		panelHeight = plotHeight - padding.top - padding.bottom,
		data = wpObject.contextualProperties.dataOut,
		x, y, x2, y2,
		labelShapes, linkShapes;
		
	let animation = wpObject.detailProperties.animation,
		upd_t;
	
			
	//axis scale shortcut
	if(wpObject.generalProperties.chartType !== 'pie'){
		x = wpObject.contextualProperties.d3viz.axis.x;
		x2 = wpObject.contextualProperties.d3viz.axis.x2;
		y = wpObject.contextualProperties.d3viz.axis.y;
		y2 = wpObject.contextualProperties.d3viz.axis.y2;
	}

	labelShapes = wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll(".marker");
	
	
	//links
	linkShapes = wpObject.contextualProperties.d3viz.dom.plotLink.selectAll(".links");
	if(wpObject.generalProperties.chartType === 'forceSimulation'){
		if(animation.active && animation.duration > 0){
			upd_t = d3.transition()
						.ease(d3[animation.ease])
						.duration(animation.duration);
			linkShapes = linkShapes.transition(upd_t);
		}
		linkShapes.selectAll('.link')
			.style('opacity', function(d){
				d.__opacity__ = (wpObject.detailProperties.forceSimulation.linkOpacity ? wpObject.detailProperties.forceSimulation.linkOpacity : 1);
				return d.__opacity__;
			})
	} else if(wpObject.generalProperties.chartType === 'parallel'){
		if(animation.active && animation.duration > 0){
			upd_t = d3.transition()
						.ease(d3[animation.ease])
						.duration(animation.duration);
		}
		linkShapes
			.each(function(d){
				let link, shape;

				link = d3.select(this).select('path');
				link = link.transition(upd_t);
				link
					.attr("d", function(d){
						let y = wpObject.contextualProperties.d3viz.axis.y[d.source.dimensionIndex];
						let decalageStart = 0;
						let decalageEnd = 0;
						let nodePadding = wpObject.detailProperties.parallel.nodePadding/2;
						if(d.source.dimensionIndex === 0){
							decalageStart = wpObject.detailProperties.parallel.nodeWidth;
						}
						if(d.target.dimensionIndex > 0){
							decalageEnd = wpObject.detailProperties.parallel.nodeWidth;
						}
						if(wpObject.detailProperties.parallel.nodeShape === 'circle'){
							switch(wpObject.detailProperties.parallel.linkStyle){
								case 'line' :
									shape = "M" + d.source.x + "," + d.source.y
										+ " L" + d.target.x + "," + d.target.y;
									break;
								case 'angle' :
									break;
								case 'curve' :
									shape = "M" + d.source.x + "," + d.source.y
										+ " C" + (d.source.x + d.target.x)/2 + "," + d.source.y
										+  " " + (d.source.x + d.target.x)/2 + "," + d.target.y
										+  " " + d.target.x + "," + d.target.y
										+ " L" + d.target.x + "," + d.target.y;
									break;
							}
						} else {
							switch(wpObject.detailProperties.parallel.linkStyle){
								case 'line' :
									shape = "M" + (d.source.x + decalageStart) + "," + (d.source.y)
										+ " V" + (d.source.y + d.source.__height__ - nodePadding*2)
										+ " L" + (d.target.x - decalageEnd) + "," + (d.target.y + d.target.__height__ - nodePadding*2)
										+ " V" + d.target.y
										+ " Z";
									break;
								case 'angle' :
									let linkWidth = d.target.x - d.source.x + (decalageStart + decalageEnd)*2;
									shape = "M" + (d.source.x + decalageStart) + "," + (d.source.y)
										+ " V" + (d.source.y + d.source.__height__ - nodePadding*2)
										+ " H" + linkWidth/3
										+ " L" + 2*linkWidth/3 + "," + (d.target.y - nodePadding + d.target.__height__)
										+ " L" + (d.target.x - decalageEnd) + "," + (d.target.y + d.target.__height__ - nodePadding*2)
										+ " V" + d.target.y
										+ " L" + 2*linkWidth/3 + "," + d.target.y
										+ " L" + linkWidth/3 + "," + d.source.y
										+ " Z";
									break;
								case 'curve' :
									shape = "M" + (d.source.x + decalageStart) + "," + (d.source.y)
										+ " V" + (d.source.y + d.source.__height__ - nodePadding*2)
										+ " C" + (d.source.x + d.target.x)/2 + "," + ((d.source.y + nodePadding) + d.source.__height__)
										+  " " + (d.source.x + d.target.x)/2 + "," + (d.target.y + d.target.__height__ - nodePadding*2)
										+  " " + (d.target.x - decalageEnd) + "," + (d.target.y + d.target.__height__ - nodePadding*2)
										+ " V" +  d.target.y
										+ " C" + (d.source.x + d.target.x)/2 + "," + d.target.y
										+  " " + (d.source.x + d.target.x)/2 + "," + (d.source.y)
										+  " " + (d.source.x + decalageStart) + "," + (d.source.y)
										+ " Z";			
									break;
							}
						}
						return shape;
					});
				
				link
					.style('fill', function(d){ 
						d.shapeColor = (wpObject.detailProperties.parallel.linkFill ? wpObject.detailProperties.parallel.linkFill : d.source.shapeColor);
						return d.shapeColor;
					})
					.style('stroke', wpObject.detailProperties.parallel.linkStroke)
					.style('stroke-width', wpObject.detailProperties.parallel.linkStrokeWidth)
					.style('stroke-dashArray', wpObject.detailProperties.parallel.linkStrokeDashArray)
					.style('opacity', function(d){ 
						d.__opacity__ = wpObject.detailProperties.parallel.linkOpacity;
						return d.__opacity__;
					});
			});

	} else if(wpObject.generalProperties.chartType === 'barchart' && wpObject.detailProperties.XYChart.barchartArea && wpObject.detailProperties.XYChart.barchartArea.active){
		if(animation.active && animation.duration > 0){
			upd_t = d3.transition()
						.delay(animation.duration);
			linkShapes = linkShapes.transition(upd_t);
		}
		let stackPadding = (wpObject.detailProperties.multiDimensionStyle === 'stacked' && wpObject.detailProperties.XYChart.stackPadding ? wpObject.detailProperties.XYChart.stackPadding : 0);
		linkShapes
			.attr('transform',function(d){
				d.source.x = (x(d.source[wpObject.detailProperties.dimensionFields[0]]) + (x2 ? x2(d.source[wpObject.detailProperties.dimensionFields[1]]) : 0));
				d.source.y = y(d.source.__end__);
				d.target.x = (x(d.target[wpObject.detailProperties.dimensionFields[0]]) + (x2 ? x2(d.target[wpObject.detailProperties.dimensionFields[1]]) : 0));
				d.target.y = y(d.target.__end__);
				return "translate(" + (d.source.x) + "," + d.source.y + ")";
			})

		linkShapes.selectAll('path')
			.attr("d", function(d){

				let areaShape;
				switch(wpObject.detailProperties.XYChart.barchartArea.areaLinkStyle){
					case 'line' :
						areaShape = "M" + d.source.bandwidth + ",0" 
								+ " v" + (y.range()[0] - y(d.source.__stackHeight__) - stackPadding) 
								+ " L" + (x(d.target[wpObject.detailProperties.dimensionFields[0]])- d.source.x) + "," + (d.target.y - d.source.y + y.range()[0] - y(d.target.__stackHeight__) - stackPadding)
								+ " v" + -(y.range()[0] - y(d.target.__stackHeight__) - stackPadding)
								+ " Z";
						break;
					case 'curve' :
						let decalage = 0;
						let nodePadding = 0;
						let sourceX = d.source.bandwidth;
						let sourceY = 0;
						let sourceH = y.range()[0] - y(d.source.__stackHeight__);
						let targetH = y.range()[0] - y(d.target.__stackHeight__);
						let targetX = (x(d.target[wpObject.detailProperties.dimensionFields[0]])- d.source.x);
						let targetY = (d.target.y - d.source.y + y.range()[0] - y(d.target.__stackHeight__));
						areaShape = "M" + sourceX + ",0"
							+ " v" + (sourceH - stackPadding)
							+ " C" + (sourceX + targetX)/2 + "," + ((sourceY) + sourceH)
							+  " " + (sourceX + targetX)/2 + "," + (targetY - stackPadding)
							+  " " + (targetX) + "," + (targetY - stackPadding)
							+ " v" +  -(targetH - stackPadding)
							+ " C" + (sourceX + targetX)/2 + "," + (targetY - targetH)
							+  " " + (sourceX + targetX)/2 + "," + (sourceY + stackPadding)
							+  " " + (sourceX ) + "," + sourceY
							+ " Z";	
				}
				return areaShape;
			})
			.style('opacity', function(d){
				d.__opacity__ = (wpObject.detailProperties.XYChart.barchartArea.areaDefaultOpacity ? wpObject.detailProperties.XYChart.barchartArea.areaDefaultOpacity : 1);
				return d.__opacity__;
			})
			.style('fill', function(d){ 
				d.shapeColor = (d.source.shapeColor ? d.source.shapeColor : 'lightgrey');
				return d.shapeColor;
			});
	}
	
	if(shapes){		
		stylingShapes(wpObject, shapes);
		
		let cntShapes = shapes.size();
		shapes
			.each(function(d, i){
				var shape = d3.select(this);
				if(animation.active && animation.duration > 0){
					if(wpObject.generalProperties.chartType === 'pie'){
						upd_t = d3.transition()										
										.ease(d3[animation.ease])
										.duration(animation.duration);
					} else {
						let delayFactor = 0;
						switch(animation.incrementationBy){
							case 'index' :
								delayFactor = i;
								break;
							case 'serie' :
							case 'serieIndex' :
								delayFactor = d.serieIndex;
								break;
							case 'dimension' :
								delayFactor = d.dimensionIndex;
								break;
							case 'depth' :
								delayFactor = d.depth;
								break;
						}
						upd_t = d3.transition()
										.delay(animation.delay + animation.incrementalDelay*delayFactor)
										.ease(d3[animation.ease])
										.duration(animation.duration);
					}
					shape = shape.transition(upd_t);
					if(i === (cntShapes-1)){
						let shapeTransformPromise = new Promise((resolve, reject) => {
							shape.on("end", resolve) ;
						});
						wpObject.contextualProperties.promises.push(shapeTransformPromise);
					}
				}
				
				shape.attr("transform", function(d){
					if(wpObject.generalProperties.chartType === 'barchart'){
						if(!d.benchmarkData || d.benchmarkData === false){
							if(wpObject.generalProperties.orientation === 'horizontal'){
								d.x = (x(d[wpObject.detailProperties.dimensionFields[0]]) + (x2 ? x2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
								if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'stacked'){
									d.y = y(d['__stackValue__']);									
								} else if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'split'){
									d.y = y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]) - ((d.serieIndex * (y.range()[0] - y.range()[1])) + d.serieIndex*wpObject.detailProperties.splitPadding);
								} else {
									d.y = y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
								}
							} else {
								if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle == 'stacked'){
									d.x = x(d['__x0__']);
								} else if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'split'){
									d.x = x(x.domain()[0]) + ((d.serieIndex * (x.range()[1] - x.range()[0])) + d.serieIndex*wpObject.detailProperties.splitPadding);
								} else if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'grouped'){
									d.x = x(x.domain()[0]);
								} else {
									d.x = x(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
								}
								d.y = (y(d[wpObject.detailProperties.dimensionFields[0]]) + (y2 ? y2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
								let bandwidth = wpObject.contextualProperties.d3viz.barchart.bandwidth;
								if(d.order && d.order[0]){
									d.y += bandwidth*d.order[0]*wpObject.detailProperties.XYChart.barBandwithReduction/2;
								}
							}
						} else {
							if(wpObject.generalProperties.orientation === 'horizontal'){
								d.x = x(d[wpObject.detailProperties.dimensionFields[0]]);
								d.y = y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
							} else {
								d.x = x(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
								d.y = y(d[wpObject.detailProperties.dimensionFields[0]]);
							}
						}
						
						if(d.__highlightRule__){
							let axis = wpObject.contextualProperties.d3viz.dom.axis;
							let labels = axis.selectAll(".categoricalAxis .tick text").filter(function(c){ 
											return c === d[wpObject.detailProperties.dimensionFields[0]];
											});
							if(labels.size() > 0){
								labels.attr('class', d.__highlightRule__.class);
								if(d.__highlightRule__.categoricalAxis){
									if(d.__highlightRule__.categoricalAxis.color){
										labels.style('fill',d.__highlightRule__.categoricalAxis.color);
									}
									if(d.__highlightRule__.categoricalAxis.fontWeight){
										labels.style('font-weight',d.__highlightRule__.categoricalAxis.fontWeight);
									}
								}
							}
						}
					} else if(wpObject.generalProperties.chartType === 'pie'){
						d.x = wpObject.contextualProperties.d3viz.pie.xPos;
						d.y = wpObject.contextualProperties.d3viz.pie.yPos;
					} else if(wpObject.generalProperties.chartType === 'sunburst'){
						d.x = wpObject.contextualProperties.d3viz.sunburst.xPos;
						d.y = wpObject.contextualProperties.d3viz.sunburst.yPos;
					} else if(wpObject.generalProperties.chartType === 'dotPlot'){
						d.x = x(d[wpObject.detailProperties.calculationFields[0]]);
						d.y = y(d[wpObject.detailProperties.calculationFields[1]]);
					} else if(wpObject.generalProperties.chartType === 'circlePack'){
						let view = wpObject.contextualProperties.d3viz.circlePack.view;
						let k = wpObject.contextualProperties.d3viz.circlePack.diameter / view[2];
						d.x = (d.x - view[0]) * k + wpObject.contextualProperties.d3viz.circlePack.xPos;
						d.y = (d.y - view[1]) * k + wpObject.contextualProperties.d3viz.circlePack.yPos;
					}
					
					if(d.x === undefined || d.y === undefined){
						console.log('error in shape data coordinate');
					}
					return "translate(" + d.x + "," + d.y + ")";
				})
				
				//shape update
				shape = d3.select(this).select('.shape');
				
				if(animation.active && wpObject.detailProperties.animation.duration > 0){
					shape = shape.transition(upd_t);
					if(i === (cntShapes-1)){
						let shapeMorphPromise = new Promise((resolve, reject) => {
							shape.on("end", resolve) ;
						});
						wpObject.contextualProperties.promises.push(shapeMorphPromise);
					}
				}
				
				
				if(!d.benchmarkData || d.benchmarkData === false){
					if(wpObject.generalProperties.chartType === 'barchart'){
						let stackPadding = (wpObject.detailProperties.multiDimensionStyle === 'stacked' && wpObject.detailProperties.XYChart.stackPadding ? wpObject.detailProperties.XYChart.stackPadding : 0);
						shape
							.attr("d", function(d){						
								let barRadius = wpObject.detailProperties.XYChart.barRadius;								
								if(wpObject.generalProperties.orientation === 'horizontal'){
									if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'stacked'){
										d.height = plotHeight - y(d.__stackHeight__);
									} else {
										d.height = plotHeight - (y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]));
									}
									if(d.height === 0 && wpObject.detailProperties.XYChart.barZeroValue  && wpObject.detailProperties.XYChart.barZeroValue.show){
										d.height = wpObject.detailProperties.XYChart.barZeroValue.size;
									}
									d.width = d.bandwidth;									
									return drawBar(wpObject, d, d.bandwidth, d.height - stackPadding, barRadius);
								} else {
									d.height = d.bandwidth;
									
									if(wpObject.detailProperties.multiCalculationFields && wpObject.detailProperties.multiCalculationFields.active && wpObject.detailProperties.multiCalculationFields.mode === 'range'){
										d.width = Math.abs(x(d[wpObject.detailProperties.calculationFields[1]])-x(d[wpObject.detailProperties.calculationFields[0]]));
									} else {
										d.width = x(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]) - x(0);
									}
									return drawBar(wpObject, d, d.width - stackPadding, d.bandwidth, barRadius);
								}
							});
						
						let shapehighlightArea = d3.select(this).select('.shape-highlightArea');
						
						shapehighlightArea
							.attr("d", function(d){
								if(wpObject.generalProperties.chartType === 'barchart'){
									if(wpObject.generalProperties.orientation === 'horizontal'){
										return drawHighlightArea(wpObject, d, d.bandwidth, (y.range()[0]-y.range()[1]),(y.range()[0]-d.height), 10);
									} else {
										return drawHighlightArea(wpObject, d, (x.range()[1]-x.range()[0]), d.bandwidth,0, 10);
									}
								} 							
							});
					} else if(wpObject.generalProperties.chartType === 'dotPlot'){
						shape
							/* .attr("r", function(d){
								let value = 5;
								value = wpObject.contextualProperties.d3viz.dotPlot.sizeAxis(d[wpObject.detailProperties.calculationFields[0]]);
								return value;
							}) */
							.attr("d", function(d){ 
								let r = 5;
								d.r = r = wpObject.contextualProperties.d3viz.dotPlot.sizeAxis(d[wpObject.detailProperties.calculationFields[0]]);								
								return drawCirclePath(wpObject, d, r)
							});
					} else if(wpObject.generalProperties.chartType === 'linechart'){
						if(d.areaShape){
							let area = drawAreachart(wpObject, d.values);
							let shapeArea = d3.select(this).select('.shape-area');
							if(animation.active && wpObject.detailProperties.animation.duration > 0){
								shapeArea = shapeArea.transition(upd_t);
							}
							shapeArea
								.attr("d", area);
						}
						
						let line = drawLinechart(wpObject, d.values);
						shape
							.attr("d", line);
					} else if(wpObject.generalProperties.chartType === 'spider'){
						shape
							.attr("d", wpObject.contextualProperties.d3viz.spider.lineLayout(d.values));
								
					} else if(wpObject.generalProperties.chartType === 'pie'){
						if(animation.active && wpObject.detailProperties.animation.duration > 0){
							shape
								.attrTween("d",arcTween(d, wpObject.contextualProperties.d3viz.pie.arcLayout, d.startAngle, d.endAngle, "endAngle"));
						} else {
							shape
								.attr("d", wpObject.contextualProperties.d3viz.pie.arcLayout(d));
						}
					} else if(wpObject.generalProperties.chartType === 'sunburst'){
						if(animation.active && wpObject.detailProperties.animation.duration > 0){
							shape.attrTween("d",arcTween(d, wpObject.contextualProperties.d3viz.sunburst.arcLayout, d.x0, d.x1, "x1"));
						} else {
							shape.attr("d", wpObject.contextualProperties.d3viz.sunburst.arcLayout(d));
						}
						
						let hiddenShape = d3.select(this).select('.hidden-arc');
						hiddenShape.attr('d', wpObject.contextualProperties.d3viz.sunburst.middleArcLine(d));
					} else if(wpObject.generalProperties.chartType === 'circlePack'){
						if(animation.active && wpObject.detailProperties.animation.duration > 0){
							shape
								.attr("r",function(d){ return d.__size__;});
						} else {
							shape
								.attr("r",function(d){ return d.__size__;});
						}
					} else if(wpObject.generalProperties.chartType === 'parallel'){
						if(wpObject.detailProperties.parallel.nodeShape === 'rectangle'){
							let nodePadding = wpObject.detailProperties.parallel.nodePadding;
							shape
								.attr("d",function(d){
									return drawBar(wpObject, d, wpObject.detailProperties.parallel.nodeWidth, d.__height__ - nodePadding, wpObject.detailProperties.parallel.nodeRadius);
								});
						} else if(wpObject.detailProperties.parallel.nodeShape === 'circle'){
							shape
								.attr("d",function(d){
									return drawCirclePath(wpObject, d, wpObject.detailProperties.parallel.nodeWidth);
								});
						}
					}
				}
			
			});

	}
	
	//styling label
	if(labelShapes  && wpObject.generalProperties.chartType !== 'linechart'){
		stylingLabels(wpObject, labelShapes);
	}
	
	labelShapes
		.each(function(d, i){
			let glabel = d3.select(this);
			let animateLabel;
			if(animation.active && animation.duration > 0 && wpObject.generalProperties.chartType !== 'kpi'){
				if(wpObject.generalProperties.chartType === 'pie'){
					upd_t = d3.transition()
									.ease(d3[animation.ease])
									.duration(animation.duration);
				} else {
					let delayFactor = 0;
					switch(animation.incrementationBy){
						case 'index' :
							delayFactor = i;
							break;
						case 'serie' :
						case 'serieIndex' :
							delayFactor = d.serieIndex;
							break;
						case 'dimension' :
							delayFactor = d.dimensionIndex;
							break;
					}
					upd_t = d3.transition()
									.delay(animation.delay + animation.incrementalDelay*delayFactor)
									.ease(d3[animation.ease])
									.duration(animation.duration);
				}
				animateLabel = glabel.transition(upd_t);
			} else {
				animateLabel = glabel;
			}
			animateLabel.attr("transform", function(d){
				if(wpObject.generalProperties.chartType === 'barchart'){
					if(d.benchmarkData === false){
						if(wpObject.generalProperties.orientation === 'horizontal'){
							if(wpObject.detailProperties.label.position === 'top'){
								d.x = (x(d[wpObject.detailProperties.dimensionFields[0]]) + (x2 ? x2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
								if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'stacked'){
									d.y = y(d['__stackValue__']);
								} else if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'split'){
									d.y = y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]) - ((d.serieIndex * (y.range()[0] - y.range()[1])) + d.serieIndex*wpObject.detailProperties.splitPadding);
								} else {
									d.y = y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
								}
							} else if(wpObject.detailProperties.label.position === 'topViz'){
								d.x = (x(d[wpObject.detailProperties.dimensionFields[0]]) + (x2 ? x2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
								d.y = 0;
							} else if(wpObject.detailProperties.label.position === 'center'){
								if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'stacked'){
									d.x = (x(d[wpObject.detailProperties.dimensionFields[0]]) + (x2 ? x2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
									d.y = y(d['__stackValue__']) + (y.range()[0] - y(d['__stackHeight__']))/2;
								} else {
								}
							}
						} else {
							if(wpObject.detailProperties.multiDimensionStyle !== 'diverging'){
								if(wpObject.detailProperties.label.position === 'top' || wpObject.detailProperties.label.position === 'right'){
									if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle == 'stacked'){
										d.x = x(d['__x0__']);
									} else if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'split'){
										d.x = x(x.domain()[0]) + ((d.serieIndex * (x.range()[1] - x.range()[0])) + d.serieIndex*wpObject.detailProperties.splitPadding);
									} else if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'grouped'){
										d.x = x(x.domain()[0]);
									} else {
										d.x = x(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
									}
									/* } else {
										d.x = x(wpObject.contextualProperties.d3viz.axis.measure.domain[0][0]) + d.width + 5;
									} */
								} else if(wpObject.detailProperties.label.position === 'topViz'){
									d.x = x(wpObject.contextualProperties.d3viz.axis.measure.domain[0][1]);
								}
							}
							d.y = (y(d[wpObject.detailProperties.dimensionFields[0]]) + (y2 ? y2(d[wpObject.detailProperties.dimensionFields[1]]) : 0));
							let bandwidth = wpObject.contextualProperties.d3viz.barchart.bandwidth;
							if(d.order && d.order[0]){
								d.y += bandwidth*d.order[0]*wpObject.detailProperties.XYChart.barBandwithReduction/2;
							}
						}
					} else {
						if(wpObject.generalProperties.orientation === 'horizontal'){
							d.x = x(d[wpObject.detailProperties.dimensionFields[0]]);
							d.y = y(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
						} else {
							d.x = x(d[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
							d.y = y(d[wpObject.detailProperties.dimensionFields[0]]);
						}
					}
				} else if(wpObject.generalProperties.chartType === 'pie'){
					d.x = wpObject.contextualProperties.d3viz.pie.xPos;
					d.y = wpObject.contextualProperties.d3viz.pie.yPos;
				} else if(wpObject.generalProperties.chartType === 'kpi'){
					let size = d3DomElementSize(glabel);
					d.x = getHorizontalPosition(wpObject, size, wpObject.detailProperties.label);
					d.y = getVerticalPosition(wpObject, size, wpObject.detailProperties.label);
				} else if(wpObject.generalProperties.chartType === 'parallel'){
					if(wpObject.detailProperties.serieStyle === 'stacked'){
						let nodePadding = wpObject.detailProperties.parallel.nodePadding;
						d.y += (d.__height__ - nodePadding) / 2;
					}
				}
				
				if(d.x === undefined || d.y === undefined){
					console.log('error in labelshape data coordinate');
				}
				return "translate(" + d.x + "," + d.y + ")";
			})
			
			//label update
			let label;

			if(wpObject.generalProperties.chartType === 'pie'){
				label = d3.select(this).select('.label-value');				
			} else {
				label = d3.select(this).select('.label');
			}
			//label = d3.select(this).select('.label-value');
			if(animation.active && wpObject.detailProperties.animation.duration > 0){
				upd_t = d3.transition()
									.ease(d3[animation.ease])
									.duration(animation.duration);
				label = label.transition(upd_t)
								.on('end',function(){
									if(wpObject.generalProperties.chartType === 'pie'){
										stylingGaugeLabel(wpObject);
									}
								});
			}
			if(wpObject.generalProperties.chartType === 'pie'){
				if(animation.active && wpObject.detailProperties.animation.duration > 0 && animation.labelValue){
					label.tween('text', function(d) {
						let that = d3.select(this),
							start = 0,
							end = 0,
							variables = getVariables(wpObject.detailProperties.label.text)
							i = [];
						
						variables.forEach(function(v,j){
							end = d[v];
							i[j] = d3.interpolateNumber(start, end);
						});
						
						return function(t) {
								variables.forEach(function(v,j){
									let labelValue = i[j](t);								
									d[v] = labelValue;
								})
								let labelValue = mapVariableValue(wpObject.detailProperties.label.text, d, wpObject.detailProperties.label.variableFormat, wpObject);
								that.text(labelValue);
							};
							
					});
				} else {
					drawLabel(wpObject, d, label, 'updateData');
					stylingGaugeLabel(wpObject);
				}
				//hide label if 0 value
				if(d.startAngle === d.endAngle && wpObject.detailProperties.pieChart.hideZeroLabelValue){
					glabel.attr('display', 'none');
				}
			} else if(wpObject.generalProperties.chartType === 'linechart'  || wpObject.generalProperties.chartType === 'spider'){
				glabel.select(".linechartLabelContainer").data(d);
				let gMarkerContainer = glabel.select('.gmarker');
				
				let typePointClass = (wpObject.generalProperties.chartType === 'linechart' ? "linechart-point" : "spider-point");
				
				let linechartPoint = gMarkerContainer.selectAll("." + typePointClass).data(d.values, function(d){ return d.__key__});
				
				let markerProperties = wpObject.detailProperties.marker;
				
				linechartPoint.exit().remove();

				//copie exact du bout de code qui est dans drawWidget
				//TODO : à optimiser !!!
				let shapeColor = d.shapeColor;
				linechartPoint
					.enter()
					.append("g")
					.attr("class", typePointClass)
					.on('mouseover',function(d){
						if(wpObject.detailProperties.events.mouseover){
							//show marker
							d3.select(this).select('.linechartMarker').style("opacity", 1);
							//show highlightArea
							if(wpObject.detailProperties.highlightArea.active === true){
								toggleHighlightArea(wpObject, this, d, true);
							}
							//show tooltip
							if(wpObject.detailProperties.tooltip.active === true){
								toggleTooltip(wpObject, this, d, true);
							}
						}
					})
					.on('mouseleave',function(d){
						if(wpObject.detailProperties.events.mouseover){
							//hide marker
							d3.select(this).select('.linechartMarker').style("opacity",function(d){ return (d.__visible__ ? markerProperties.opacity : 0)});
							//hide highlightArea
							if(wpObject.detailProperties.highlightArea.active === true){
								toggleHighlightArea(wpObject, this, d, false);
							}
							//hide tooltip
							if(wpObject.detailProperties.tooltip.active === true){
								toggleTooltip(wpObject, this, d, false);
							}
						}
					})
					.each(function(d,i){
						let markerBlock = d3.select(this);
						
						if(wpObject.detailProperties.tooltip.active === true && wpObject.detailProperties.tooltip.detectionArea === 'categoricalAxis'){
							let areaWidth = wpObject.contextualProperties.d3viz.linechart.step;
							
							//draw highlightArea
							let highlightAreaProps = wpObject.detailProperties.highlightArea;
							let highlightColor = highlightAreaProps.fill;
							let highlightAreaColorGradient = wpObject.contextualProperties.d3viz.highlightArea.colorGradient;
							
							if(highlightAreaColorGradient && highlightAreaColorGradient[d[highlightAreaProps.attachementColumn]]){
								highlightColor = "url(#" + highlightAreaColorGradient[d[highlightAreaProps.attachementColumn]].url + ")";
							} else if(highlightAreaProps.defaultGradient){
								highlightColor = "url(#" + highlightAreaColorGradient[0].url + ")";
							}
							markerBlock
								.append("path")
								.attr("class", "shape-highlightArea")
								.style("opacity", 0)
								.style("stroke", highlightAreaProps.strokeColor)
								.style("stroke-width", highlightAreaProps.strokeWidth)
								.style("fill", highlightColor)
								.style("shape-rendering","crispedges")
								.attr("transform","translate(-" + areaWidth/2 + ",0)")
								.attr("d", function(d){
									return drawHighlightArea(wpObject, d, areaWidth, y.range()[0] - d.y, 0, 0);
								});
						}
						d.__shapeColor__ = (markerProperties.strokeColor ? markerProperties.strokeColor : shapeColor);
						d.__opacity__ = (d.__visible__ ? markerProperties.opacity : 0);

						if(markerProperties.style === 'square'){
							markerBlock
								.append("rect")
								.attr("class", "linechartMarker")
								.attr("x", -markerProperties.r/2)
								.attr("y", -markerProperties.r/2)
								.attr("width", markerProperties.r)
								.attr("height", markerProperties.r);
						} else {
							markerBlock
								.append("circle")
								.attr("class", "linechartMarker")
								.attr("r", markerProperties.r);
						}
						
						d3.select(this).select('.linechartMarker')
							.style("stroke-width", markerProperties.strokeWidth)
							.style("stroke", d.__shapeColor__)
							.style("fill", markerProperties.fillColor)
							.style("opacity", d.__opacity__);

					});
				
				linechartPoint = gMarkerContainer.selectAll("." + typePointClass)
				linechartPoint
					.attr('transform',function(dmarker, idx){
						if(wpObject.generalProperties.chartType === 'linechart'){
							dmarker.x = x(dmarker[wpObject.detailProperties.dimensionFields[0]]);
							dmarker.y = (y.range()[1] + y.range()[0])/2;
						} else if(wpObject.generalProperties.chartType === 'spider'){
							let rScale = wpObject.contextualProperties.d3viz.spider.rScale;
							let angleSlice = wpObject.contextualProperties.d3viz.spider.angleSlice;
							dmarker.x = rScale(dmarker[wpObject.detailProperties.calculationFields[0]]) * Math.cos(angleSlice*idx - Math.PI/2);
							dmarker.y = rScale(dmarker[wpObject.detailProperties.calculationFields[0]]) * Math.sin(angleSlice*idx - Math.PI/2);
							}
						return "translate(" + dmarker.x + "," + dmarker.y + ")";
					})				
				
				if(wpObject.detailProperties.tooltip.active === true){
					glabel.selectAll('.linechart-point').style('cursor', 'pointer');
				}
				linechartPoint = gMarkerContainer.selectAll(".linechart-point");
					
				if(animation.active && animation.duration > 0){
						let delayFactor = 0;
						switch(animation.incrementationBy){
							case 'index' :
								delayFactor = i;
								break;
							case 'serie' :
							case 'serieIndex' :
								delayFactor = d.serieIndex;
								break;
							case 'dimension' :
								delayFactor = d.dimensionIndex;
								break;
						}
						upd_t = d3.transition()
										.delay(animation.delay + animation.incrementalDelay*delayFactor)
										.ease(d3[animation.ease])
										.duration(animation.duration);

					linechartPoint = linechartPoint.transition(upd_t);
				}				
				
				linechartPoint
					.attr('transform',function(dmarker, idx){
						dmarker.x = x(dmarker[wpObject.detailProperties.dimensionFields[0]]);
						dmarker.y = y(dmarker[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
						if(dmarker.x === undefined || dmarker.y === undefined){
							console.log('error in linechart .marker data coordinate');
						}
						return "translate(" + dmarker.x + "," + dmarker.y + ")";
					})
					.each(function(d,i){
						let circle = d3.select(this).select('circle');
						d.__opacity__ = (d.__visible__ ? markerProperties.opacity : 0);
						d.__shapeColor__ = (markerProperties.strokeColor ? markerProperties.strokeColor : shapeColor);
						
						circle.style("opacity",d.__opacity__)
							.style("stroke", d.__shapeColor__);
						
						let shapeArea = d3.select(this).select('.shape-highlightArea');
						let areaWidth = wpObject.contextualProperties.d3viz.linechart.step;
						shapeArea
							.attr("d", function(d){
									return drawHighlightArea(wpObject, d, areaWidth, y.range()[0] - d.y, 0, 0);
								});
					});
			} else {
				if(label.size() > 0){
					//draw label content
					drawLabel(wpObject, d, label, 'updateData');
					if(wpObject.generalProperties.chartType === 'barchart'){
						label
							.attr('x', function(d){
								let xpos;
								if(wpObject.generalProperties.orientation === 'horizontal'){
									xpos = d.bandwidth / 2;
								} else {
									if(wpObject.detailProperties.label.relativePosition === 'outside'){
										xpos = wpObject.detailProperties.label.hPadding ;
									} else {
										if(wpObject.detailProperties.multiDimensionStyle === 'diverging' && d.serieIndex === 0){
											xpos = -wpObject.detailProperties.label.hPadding ;
										} else {
											xpos = wpObject.detailProperties.label.hPadding ;
										}
									}
								}
								return xpos;
							})
							.attr('y', function(d){
							let ypos;
							if(wpObject.generalProperties.orientation === 'vertical'){
								if(wpObject.detailProperties.multiDimensionStyle === 'diverging'){
									ypos = wpObject.detailProperties.label.vPadding;
								} else {
									ypos = d.bandwidth / 2 + wpObject.detailProperties.label.vPadding;
								}
							} else {
								if(wpObject.detailProperties.label.relativePosition === 'outside'){
									ypos = - wpObject.detailProperties.label.vPadding;
								} else {									
									ypos = wpObject.detailProperties.label.vPadding;
								}
							}
							return ypos;
						})
					}
					if(animation.active && wpObject.detailProperties.animation.duration > 0 && animation.labelValue){
						let labelValue = label.select('.label-value');
						labelValue.tween('text', function(d) {
							let that = d3.select(this),
								start = 0,
								end = 0,
								variables = getVariables(wpObject.detailProperties.label.text)
								i = [];
							
							variables.forEach(function(v,j){
								end = d[v];
								i[j] = d3.interpolateNumber(start, end);
							});
							
							return function(t) {
									variables.forEach(function(v,j){
										let labelValue = i[j](t);								
										d[v] = labelValue;
									})
									labelValue = mapVariableValue(wpObject.detailProperties.label.text, d, wpObject.detailProperties.label.variableFormat, wpObject);
									that.text(labelValue);
								};
								
						});
					} else {
						drawLabel(wpObject, d, label, 'updateData');
						stylingGaugeLabel(wpObject);						
					}
					
				}
			}			
		});

	if(labelShapes  && wpObject.generalProperties.chartType !== 'linechart'){
		stylingLabels(wpObject, labelShapes);
	}
	
	//lineChartLabel
	if(wpObject.generalProperties.chartType === 'linechart' && wpObject.detailProperties.XYChart.linechartLabel && wpObject.detailProperties.XYChart.linechartLabel.visible){
		let linechartLabels = wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll(".linechartLabelContainer");
		linechartLabels.each(function(d,i){
			let xPos, yPos, linecharLabelTxt;
			let linechartLabelContainer = d3.select(this);
			let countPoints = d.values.length;
			if(animation.active && animation.duration > 0){
					let delayFactor = 0;
					switch(animation.incrementationBy){
						case 'index' :
							delayFactor = i;
							break;
						case 'serie' :
						case 'serieIndex' :
							delayFactor = d.serieIndex;
							break;
						case 'dimension' :
							delayFactor = d.dimensionIndex;
							break;
					}
					upd_t = d3.transition()
									.delay(animation.delay + animation.incrementalDelay*delayFactor)
									.ease(d3[animation.ease])
									.duration(animation.duration);

				linechartLabelContainer = linechartLabelContainer.transition(upd_t);
			}
			let lineChartLabelProps = wpObject.detailProperties.XYChart.linechartLabel;
			let position = wpObject.detailProperties.XYChart.linechartLabel.position;
			
			if(position === 'start' || position === 'both'){
				let startPoint = d.values[0];
				if(!lineChartLabelProps.text || lineChartLabelProps.text === 'default'){
					linecharLabelTxt = '[key]';
					linecharLabelTxt = mapVariableValue(linecharLabelTxt, d, null, wpObject);
				} else {
					linecharLabelTxt = mapVariableValue(lineChartLabelProps.text, startPoint, null, wpObject);
				}
				linechartLabelContainer.select('.linechartLabelBlock.left')
					.attr('transform',function(){
						xPos = x(startPoint[wpObject.detailProperties.dimensionFields[0]]) - wpObject.detailProperties.XYChart.linechartLabel.padding;
						yPos = y(startPoint[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
						
						if(xPos === undefined || yPos === undefined){
							console.log('error in left linechartLabel data coordinate');
						}
						return "translate(" + xPos + "," + yPos + ")";
					})
					.style('display', (countPoints === 1 ? 'none' : 'inline'));
					
				linechartLabelContainer.select('.linechartLabel.left tspan')
					.text(linecharLabelTxt);
			}
			if(position === 'end' || position === 'both'){
				let endPoint = d.values[d.values.length-1];
				if(!lineChartLabelProps.text || lineChartLabelProps.text === 'default'){
					linecharLabelTxt = '[key]';
					linecharLabelTxt = mapVariableValue(linecharLabelTxt, d, null, wpObject);
				} else {
					linecharLabelTxt = mapVariableValue(lineChartLabelProps.text, endPoint, null, wpObject);
				}
				linechartLabelContainer.select('.linechartLabelBlock.right')
					.attr('transform',function(){
						xPos = x(endPoint[wpObject.detailProperties.dimensionFields[0]]) + wpObject.detailProperties.XYChart.linechartLabel.padding;
						yPos = y(endPoint[wpObject.detailProperties.calculationFields[wpObject.detailProperties.currentCalculationFieldsIndex]]);
						if(xPos === undefined || yPos === undefined){
							console.log('error in right linechartLabel data coordinate');
						}
						return "translate(" + xPos + "," + yPos + ")";
					});
				linechartLabelContainer.select('.linechartLabel.right tspan')
					.text(linecharLabelTxt);
			}
		})
	}

}

function stylingShapes(wpObject, shapes){

	let plot = wpObject.contextualProperties.d3viz.dom.plot;

	plot.selectAll('.shapes')
		.each(function(d,i){
			let shape = d3.select(this).select('.shape');
		
			shape
			.style('fill', function(d){
				let value = (d.shapeColor ? d.shapeColor : '#ffffff');
				switch(wpObject.generalProperties.chartType){
					case 'linechart' :
						value = 'transparent';
						break;
					case 'spider' :
						if(wpObject.detailProperties.spider.area && wpObject.detailProperties.spider.area.visible){
							value = value;
						} else {
							value = 'transparent';
						}
						break;
				}
				
				return value;
			})
			.style('fill-opacity', function(d){
				let value = 1;
				switch(wpObject.generalProperties.chartType){
					case 'spider' :
						if(wpObject.detailProperties.spider.area && wpObject.detailProperties.spider.area.visible){
							value = wpObject.detailProperties.spider.area.opacity;
						} else {
							value = 0;
						}
						break;
				}
				
				return value;
			})
			.style('stroke',function(d){
				switch(wpObject.generalProperties.chartType){
					case 'parallel' :
						d.__stroke__ = (wpObject.detailProperties.parallel.nodeStroke ? wpObject.detailProperties.parallel.nodeStroke : (d.shapeColor ? d.shapeColor : '#000000'));
						break;
					default : 
						d.__stroke__ = (wpObject.detailProperties[wpObject.generalProperties.chartType] && wpObject.detailProperties[wpObject.generalProperties.chartType].stroke ? wpObject.detailProperties[wpObject.generalProperties.chartType].stroke : (d.shapeColor ? d.shapeColor : '#000000'));
				}
				
				return d.__stroke__;
			})
			.style('stroke-width',function(d){			
				let value = 0.5;
				switch(wpObject.generalProperties.chartType){
					case 'linechart' :
						d.__strokeWidth__ = ( d.serieIndex > 0 && wpObject.detailProperties.XYChart.altLineWidth ? wpObject.detailProperties.XYChart.altLineWidth : wpObject.detailProperties.XYChart.lineWidth);
						value = d.__strokeWidth__;
						break;
					case 'spider' :
						d.__strokeWidth__ = wpObject.detailProperties.spider.lineWidth;
						value = d.__strokeWidth__;
						break;
					case 'barchart' :
						d.__strokeWidth__ = (wpObject.detailProperties.XYChart.barStrokeWidth ? wpObject.detailProperties.XYChart.barStrokeWidth : 0.5);
						value = d.__strokeWidth__;
						break;
					case 'sunburst' :
					case 'forceSimulation' :
						d.__strokeWidth__ = (wpObject.detailProperties[wpObject.generalProperties.chartType] && wpObject.detailProperties[wpObject.generalProperties.chartType].strokeWidth ? wpObject.detailProperties[wpObject.generalProperties.chartType].strokeWidth : 0.5);
						value = d.__strokeWidth__;
						break;
					case 'parallel' :
						d.__strokeWidth__ = (wpObject.detailProperties.parallel.nodeStrokeWidth ? wpObject.detailProperties.parallel.nodeStrokeWidth : 0.5);
						value = d.__strokeWidth__;
						break;
				}			
				return value;			
			})
			.style("stroke-dasharray",function(d){
				let value = '0';
				switch(wpObject.generalProperties.chartType){
					case 'linechart' :
						d.__strokeDasharray__ = ( d.serieIndex > 0 && wpObject.detailProperties.XYChart.altLineAltArray ? wpObject.detailProperties.XYChart.altLineAltArray : wpObject.detailProperties.XYChart.lineDashArray);
						value = d.__strokeDasharray__;
						break;
					case 'spider' :
						d.__strokeDasharray__ = wpObject.detailProperties.spider.lineDashArray;
						value = d.__strokeDasharray__;
						break;
				}
				return value;
			});
		});			
}

function drawLabel(wpObject, d, txtContainer, action){

	
	let prefixContainer, valueContainer, suffixContainer,
		labelProperties = wpObject.detailProperties.label;
	
	
	if(action !== 'updateData'){
		//prefix
		prefixContainer = txtContainer	
			.insert("tspan")
			.attr("dx", ( labelProperties.prefixDx ? labelProperties.prefixDx : '0em'))
			.attr("dy", ( labelProperties.prefixDy ? labelProperties.prefixDy : '0em'))
			.attr('class','label-prefix');
	 
		//value
		valueContainer = txtContainer	
			.insert("tspan")
			.attr("dx", ( labelProperties.dx ? labelProperties.dx : '0em'))
			.attr("dy", ( labelProperties.dy ? labelProperties.dy : '0em'))
			.attr('class','label-value');

		//suffix
		suffixContainer = txtContainer	
			.insert("tspan")
			.attr("dx", ( labelProperties.suffixDx ? labelProperties.suffixDx : '0em'))			
			.attr("dy", ( labelProperties.suffixDy ? labelProperties.suffixDy : '0em'))
			.attr('class','label-suffix');	
	} else {
		prefixContainer = txtContainer.select('.label-prefix');
		valueContainer = txtContainer.select('.label-value');
		suffixContainer = txtContainer.select('.label-suffix');
	}
	
	prefixContainer
		.text(function(d){
			let prefix = '';
			
			if(labelProperties.prefixScheme && labelProperties.prefixScheme[d.index] && labelProperties.prefixScheme[d.index] !== 'none'){
				prefix = labelProperties.prefixScheme[d.index];
			} else if(labelProperties.prefix){
				prefix = wpObject.detailProperties.label.prefix;
			}
			if(prefix !== ''){
				prefix = mapVariableValue(prefix, d, labelProperties.variableFormat, wpObject);
			}
			return prefix;
		});
		
	valueContainer
		.text(function(d){
			let labelValue = '',
				ccfIdx = wpObject.detailProperties.currentCalculationFieldsIndex;
			if(!labelProperties.text || labelProperties.text === null || labelProperties.text === 'default'){
				if(wpObject.generalProperties.chartType === 'barchart'){
					if(labelProperties.text === 'default'){
						labelProperties.text = "[" + wpObject.detailProperties.calculationFields[ccfIdx] + "]";
					}
					labelValue = mapVariableValue(labelProperties.text, d, labelProperties.variableFormat, wpObject);
				} else if(wpObject.generalProperties.chartType === 'pie'){
					if(labelProperties.text === 'default'){
						labelProperties.text = "[__value__]";
					}
					labelValue = mapVariableValue(labelProperties.text, d, labelProperties.variableFormat, wpObject);
				} else if(wpObject.generalProperties.chartType === 'circlePack'){
					labelProperties.text = '[key]';
					labelValue = mapVariableValue(labelProperties.text, d.data, labelProperties.variableFormat, wpObject)
				} else if(wpObject.generalProperties.chartType === 'parallel'){
					labelValue = "[" + wpObject.detailProperties.calculationFields[d.dimensionIndex] + "]";
					labelValue = mapVariableValue(labelValue, d, labelProperties.variableFormat, wpObject)
				} else if(wpObject.generalProperties.chartType === 'forceSimulation'){
					labelValue = "[__dimensionValue__]";
					labelValue = mapVariableValue(labelValue, d, labelProperties.variableFormat, wpObject)
				} else {
					labelValue = mapVariableValue(labelProperties.text, d, labelProperties.variableFormat, wpObject);
				}
			} else {
				if(wpObject.generalProperties.chartType === 'circlePack'){
					labelValue =  mapVariableValue(labelProperties.text, d.data, labelProperties.variableFormat, wpObject);
				} else {
					labelValue =  mapVariableValue(labelProperties.text, d, labelProperties.variableFormat, wpObject);
				}
			}
			return labelValue;
		});

	suffixContainer
		.text(function(d){
			let suffix = '';
			
			if(labelProperties.suffixScheme && labelProperties.suffixScheme[d.index] && labelProperties.suffixScheme[d.index] !== 'none'){
				suffix = labelProperties.suffixScheme[d.index];
			} else if(labelProperties.suffix){
				suffix = labelProperties.suffix;
			}
			if(suffix !== ''){
				suffix = mapVariableValue(suffix, d, labelProperties.variableFormat, wpObject);
				let pttrn = /^\s*/;
				let firstChar = suffix.match(pttrn)[0].length;
				if(firstChar > 0){
					suffix = _.repeat('\u00A0', firstChar) + _.trimStart(suffix);
				}
			}
			return suffix;
		});

}

function stylingGaugeLabel(wpObject){

	let gLabel = wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll('.glabel');
	let labelSize = d3DomElementSize(gLabel);

	let decalage = 0;
	
	switch(wpObject.detailProperties.label.textAnchor){
		case 'right' :
			decalage = labelSize.width;
			break;
		case 'middle' :
			decalage = labelSize.width/2;
			break;
	}
	
	if(wpObject.detailProperties.pieChart.gaugeLabelUnderline){
		gLabel.select('line')	
			.attr('x1', 0 - decalage)
			.attr('x2', labelSize.width - decalage)
			.attr('y1',20)
			.attr('y2',20);
	}
}

function stylingLabels(wpObject, shapes){

	let labelStyling = wpObject.detailProperties.label;
	let labels = shapes.selectAll('text.label');
	let labelSuffix = shapes.selectAll('text .label-suffix');
	
	labels
		.style('font-family',labelStyling.fontFamily)
		.style('font-weight',labelStyling.fontWeight)
		.style('text-anchor',function(d){
			let txtAnchor = labelStyling.textAnchor;
			if(wpObject.detailProperties.multiDimensionStyle === 'diverging' && d.serieIndex === 0){
				txtAnchor = labelStyling.altTextAnchor;
			} else if(wpObject.generalProperties.chartType === 'barchart' && wpObject.detailProperties.XYChart.barchartArea && wpObject.detailProperties.XYChart.barchartArea.active && d.dimensionIndex === 0){
				txtAnchor = labelStyling.altTextAnchor;
			} else if(wpObject.generalProperties.chartType === 'pie' && wpObject.detailProperties.label.relativePosition === 'outside' && wpObject.detailProperties.pieChart.pieType !== 'gauge'){
				if(wpObject.detailProperties.pieChart.labelLine === true){
					txtAnchor = (d.__labelPosition__ ? (d.__labelPosition__ === 'left' ? 'end' : 'start') : 'middle');
				} else {
					let avgAngle = ((d.endAngle - d.startAngle) / 2) + d.startAngle;
					if(avgAngle < 1 || avgAngle > 5.3){
						txtAnchor = 'middle';
					} else if(avgAngle > 3.14){
						txtAnchor = 'end';
					} else {
						txtAnchor = 'start';
					}
				}
			} else if(wpObject.generalProperties.chartType === 'parallel'){
				if(d.dimensionIndex === 0){
					txtAnchor = labelStyling.altTextAnchor;
				}
			}
			return txtAnchor
			//return (d.order && d.order[0] && d.order[0] > 0 && labelStyling.altTextAnchor ? labelStyling.altTextAnchor : labelStyling.textAnchor);
		})
		.each(function(d,i){
			let label = d3.select(this);
			
			//adjust label position : should be ok in drawWidget but is not working fine
			if(wpObject.generalProperties.chartType === 'parallel'){
				let hPad = (d.dimensionIndex === 0 ? - wpObject.detailProperties.label.hPadding : wpObject.detailProperties.label.hPadding);
				label
					.attr('x', hPad);	
			}
			
			label
				.style('font-size', (d.serieIndex > 0 && labelStyling.altFontSize ? labelStyling.altFontSize : labelStyling.fontSize))
				.style('fill',function(d){
					if(d.texture){
						return '#000000';
					} else {
						if(labelStyling.colorScheme && labelStyling.colorScheme[d.index] && labelStyling.colorScheme[d.index] !== 'none'){
							return labelStyling.colorScheme[d.index];
						} else {
							if(labelStyling.labelVisibilityCorrection === 'contrast'){
								return adjustColorRule('contrast', 1, labelStyling.color, labelStyling.altColor, d.shapeColor);
							} else {
								return labelStyling.color;
							}
						}
					}
				});
			if(d.__highlightRule__ && d.__highlightRule__.label){
				if(d.__highlightRule__.label.fontWeight){
					label.style('font-weight',d.__highlightRule__.label.fontWeight);
				}
				if(d.__highlightRule__.label.color){
					label.style('fill',d.__highlightRule__.label.color);
				}
				if(d.__highlightRule__.label.fontSize){
					label.style('font-size',d.__highlightRule__.label.fontSize);
				}
			}
		});

	//suffix formatting
	if(labelSuffix){
		if(labelStyling.suffixFontSize){
			labelSuffix
				.style('font-size', labelStyling.suffixFontSize);
		}
		if(labelStyling.suffixFontWeight){
			labelSuffix
				.style('font-weight', labelStyling.suffixFontWeight);
		}
		
		if(labelStyling.suffixFontSize){
			labelSuffix
				.each(function(d,i){
					let suffix = d3.select(this);
					suffix
						.style('font-size', labelStyling.suffixFontSize)
						.style('fill',function(d){
							if(labelStyling.suffixColorScheme && labelStyling.suffixColorScheme[d.index] && labelStyling.suffixColorScheme[d.index] !== 'none'){
								return labelStyling.suffixColorScheme[d.index];
							} else if(labelStyling.suffixColor){
								return labelStyling.suffixColor;
							} else {
								if(labelStyling.labelVisibilityCorrection === 'contrast'){
									return adjustColorRule('contrast', 1, labelStyling.color, labelStyling.altColor, d.shapeColor);
								} else {
									return labelStyling.color;
								}
							}	
						});
					if(d.__highlightRule__ && d.__highlightRule__.label){
						if(d.__highlightRule__.label.suffixFontWeight){
							suffix.style('font-weight',d.__highlightRule__.label.suffixFontWeight);
						}
						if(d.__highlightRule__.label.color){
							suffix.style('fill',d.__highlightRule__.label.color);
						}
						if(d.__highlightRule__.label.suffixFontSize){
							suffix.style('font-size',d.__highlightRule__.label.suffixFontSize);
						}
					}
				});
		}
	}
	
	labels
		.style('display',function(d){
			if(labelStyling.visible){
				if(d.benchmarkData){
					return (wpObject.detailProperties.XYChart.benchmarkLabelVisible ? 'inline' : 'none')
				} else if(wpObject.generalProperties.chartType === 'sunburst'){
					return (wpObject.contextualProperties.d3viz.sunburst.textFits(d) ? null : 'none');
				} else if(wpObject.generalProperties.chartType === 'circlePack'){
					//return (d.parent === wpObject.contextualProperties.d3viz.circlePack.focus ? "inline" : "none");
					return (d.parent && d.parent.index === wpObject.contextualProperties.d3viz.circlePack.focus.index ? "inline" : "none");
				} else if(wpObject.generalProperties.chartType === 'parallel'){
					if(wpObject.detailProperties.serieStyle === "stacked" || wpObject.detailProperties.serieStyle === "overlay"){
						//TODO : gerer en fonction de la size du label
						if(d.__height__ < 8){
							return 'none';
						} else {
							return 'inline';
						}
					} else {
						return 'inline';
					}
				} else if(wpObject.generalProperties.chartType === 'barchart'){
					if(wpObject.generalProperties.orientation === 'horizontal'){
						if(d.height < 25){
							return 'none';
						} else {
							return 'inline';
						}
					}
				} else {
					return 'inline';
				}
			} else {
				return 'none';
			}
		});
	
}

function formatLabelValue(wpObject, labelValue, format, properties){
	
	if(format){
		if(typeof format === 'string'){
			labelValue = d3.format(format)(labelValue);
		} else if(typeof format === 'object'){
			if(format.datatype === 'date'){
				let dateParse = d3.timeParse(format.formatIn);
				let locale = wpObject.contextualProperties.d3viz.localeFormat;
				let dateFormat = locale.format(format.formatOut);
				labelValue = dateFormat(dateParse(labelValue));
			} else if(format.datatype === 'number'){
				let locale = wpObject.contextualProperties.d3viz.localeNumberFormat;
				let localeFormat = locale.format(format.formatOut);
				labelValue = localeFormat(labelValue);
				//labelValue = d3.format(format.formatOut)(labelValue);
			}
			
			if(format.removeFormatPctSign){
				labelValue = labelValue.replace('%','');
			}
		}		
	}

	return labelValue;	
}

function drawPicto(wpObject){

	wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll('.picto').remove();
	
	wpObject.detailProperties.picto.items.forEach(function(p,i){
		let size, xPos = 0, yPos = 0;
		let pictoContainer = wpObject.contextualProperties.d3viz.dom.foregroundPlot
								.insert('g')
								.attr('class','picto');
					
		let picto = pictoContainer
						.appendHTML(p.data);
						
		let pictoScale = (p.scale ? p.scale : 1);
		let pictoWidth = pictoScale * p.width;
		let pictoHeight = pictoScale * p.height;

		picto
			.attr("width", pictoWidth)
			.attr("height", pictoHeight)
			.attr("viewBox","0 0 " + pictoWidth + " " + pictoHeight);
			
		pictoContainer.select('g')
			.attr("transform", "translate(0,0) scale(" + pictoScale + ")");
			
		if(p.fill){
			picto.selectAll('path').style('fill',p.fill);
			picto.selectAll('rect').style('fill',p.fill);
		}
		if(p.stroke){
			picto.selectAll('path').style('stroke',p.stroke);
			picto.selectAll('rect').style('stroke',p.stroke);
		}

		size = d3DomElementSize(pictoContainer);
		xPos = getHorizontalPosition(wpObject, size, p);
		yPos = getVerticalPosition(wpObject, size, p);
		
		pictoContainer
			.attr("transform", "translate(" + xPos + ", " + yPos + ")");
		
	})

}

function drawTitle(wpObject){
	
	let dataMapping;
	
	if(wpObject.detailProperties.pieChart && wpObject.detailProperties.pieChart.pieType === 'gauge'){
		dataMapping = wpObject.contextualProperties.dataOut[0];
	}
	
	if((wpObject.detailProperties.title.text || wpObject.detailProperties.title.SVG) && wpObject.detailProperties.title.visible){
		drawText(wpObject, wpObject.contextualProperties.d3viz.dom.title, wpObject.detailProperties.title, dataMapping);
	}
	if((wpObject.detailProperties.caption.text || wpObject.detailProperties.caption.SVG) && wpObject.detailProperties.caption.visible){
		drawText(wpObject, wpObject.contextualProperties.d3viz.dom.caption, wpObject.detailProperties.caption, dataMapping);
	}	
}

function drawLegend(wpObject){

	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		panelWidth = plotWidth - padding.left - padding.right,
		panelHeight = plotHeight - padding.top - padding.bottom,
		xPos, yPos, legendTxt, legendColor;
		
	let legendContainer = wpObject.contextualProperties.d3viz.dom.legend;
	let styleColors = wpObject.contextualProperties.d3viz.styles.colors;
				
	//remove content
	legendContainer.selectAll('.legendBlock').remove();
	
	if(wpObject.detailProperties.legend.type && wpObject.detailProperties.legend.type !== 'manual'){
		let data;
		let svgBlock = "<g class='legendBlock'>";
		if(wpObject.detailProperties.legend.type === 'data'){
			data = wpObject.contextualProperties.dataOut;
		} else if(wpObject.detailProperties.legend.type === 'colorScheme'){
			data = styleColors.scale.domain();
		}
		
		data.forEach(function(d,i){
			if(wpObject.detailProperties.legend.type === 'colorScheme'){
				legendColor = styleColors.scale(d);
			} else if(styleColors.dimensionField && styleColors.dimensionField.length > 0){
				legendColor = styleColors.scale(d[styleColors.dimensionField[0]]);
			} else {
				legendColor = styleColors.defaultColor;
			}
	
			svgBlock += "<g class='block'><g class='element'>";
			switch(wpObject.detailProperties.legend.marker){
				case 'square' :
					svgBlock += "<rect width='" + wpObject.detailProperties.legend.markerSize + "' height='" + wpObject.detailProperties.legend.markerSize + "' style='fill:" + legendColor + "'/>";
					break;
				case 'roundedSquare' :
					svgBlock += "<rect width='" + wpObject.detailProperties.legend.markerSize + "' height='" + wpObject.detailProperties.legend.markerSize + "' rx='2' ry='2' style='fill:" + legendColor + "'/>";
					break;
				case 'roundedRectangle' :
					svgBlock += "<rect width='" + wpObject.detailProperties.legend.markerSize + "' height='6' rx='4' ry='4' style='fill:" + legendColor + "'/>";
					break;
				case 'circle' :
					svgBlock += "<circle r='" + wpObject.detailProperties.legend.markerSize + "' style='fill:" + legendColor + "'/>";
					break;
				case 'line' :
					svgBlock += "<line x1='0' x2='" + wpObject.detailProperties.legend.markerSize + "' style='stroke-width:4;stroke:" + legendColor + "'/>";
					break;
				default :
					svgBlock += wpObject.detailProperties.legend.marker;
					break;
			}
			svgBlock += "</g>";
			let txt;
			if(wpObject.detailProperties.legend.type === 'colorScheme'){
				svgBlock += "<g class='element'><text dy='0.7em'><tspan>";
				txt = d;
				//svgBlock += mapVariableValue(txt, d, wpObject.detailProperties.legend.variableFormat, wpObject);
				svgBlock += d;
				svgBlock += "</tspan></text></g>";
			} else if(wpObject.detailProperties.legend.SVG){
				txt = wpObject.detailProperties.legend.SVG;
				svgBlock += mapVariableValue(txt, d, wpObject.detailProperties.legend.variableFormat, wpObject);
			} else {
				svgBlock += "<g class='element'><text dy='0.7em'><tspan>";
				txt = wpObject.detailProperties.legend.text;
				svgBlock += mapVariableValue(txt, d, wpObject.detailProperties.legend.variableFormat, wpObject);
				svgBlock += "</tspan></text></g>";
			}
			svgBlock += "</g>";
		})
		svgBlock += "</g>";
		legendContainer.appendSVG(svgBlock);
		legendTxt = legendContainer.selectAll('text');
	} else if(wpObject.detailProperties.legend.type === 'manual' || !wpObject.detailProperties.legend.type){
		if(wpObject.detailProperties.legend.SVG){
			legendContainer.appendSVG(wpObject.detailProperties.legend.SVG);
			legendTxt = legendContainer.selectAll('text');
		} else if(wpObject.detailProperties.legend.type === 'manual'){
			legendTxt = legendContainer
				.append("text")
				.attr('class','text')
				.attr("dy","0.7em")
				.text(wpObject.detailProperties.legend.text);
		}
	}
	
	if(legendTxt){
		//styling
		legendTxt
			.style('fill', wpObject.detailProperties.legend.color)
 			.style("font-family", wpObject.detailProperties.legend.fontFamily)
			.style("font-size", wpObject.detailProperties.legend.fontSize)
			.style("font-weight", wpObject.detailProperties.legend.fontWeight)
			.style("font-style", wpObject.detailProperties.legend.fontStyle)
			.style("text-anchor", wpObject.detailProperties.legend.textAnchor);
	}
	
	
	//positionning
	legendContainer.select('.legendBlock')
		.attr('transform','translate(0,5)');
		
	let xTranslate = 0, yTranslate = 0;
	let cntBlockPerRow = 0;
	let cntBlockPerCol = 0;
	legendContainer.selectAll('.block')
		.each(function(d,i){
			let block = d3.select(this);
			let xElemTranslate = 0, yElemTranslate = 0;
			cntBlockPerRow += 1;
			block.selectAll('.element')
				.each(function(d,i){
					let element = d3.select(this);
					element.attr('transform','translate(' + xElemTranslate + ',' + yElemTranslate + ')');
					let size = d3DomElementSize(element);
					
					xElemTranslate += size.width + 10;
				});
			
			let size = d3DomElementSize(block);
			
			block.attr('transform','translate(' + xTranslate + ',' + yTranslate + ')');

			if(wpObject.detailProperties.legend.orientation === 'horizontal'){
				xTranslate += (size.width < wpObject.detailProperties.legend.minBlockSize ? wpObject.detailProperties.legend.minBlockSize : size.width) + wpObject.detailProperties.legend.blockPadding;
				if(xTranslate > plotWidth || (wpObject.detailProperties.legend.maxBlockPerRow > 0 && wpObject.detailProperties.legend.maxBlockPerRow === cntBlockPerRow)){
					xTranslate = 0;
					yTranslate += yTranslate + wpObject.detailProperties.legend.multiRowPadding;
					cntBlockPerRow = 0;
				}
			} else {
				yTranslate += size.height + wpObject.detailProperties.legend.blockPadding;
				if(yTranslate > plotHeight || (wpObject.detailProperties.legend.maxBlockPerCol > 0 && wpObject.detailProperties.legend.maxBlockPerCol === cntBlockPerCol)){
					yTranslate = 0;
					xTranslate += xTranslate + wpObject.detailProperties.legend.multiColPadding;
					cntBlockPerCol = 0;
				}
			}			
			
		});
	
	
	//calculate block size for adjustment
	let size = d3DomElementSize(legendContainer);
	
	xPos = getHorizontalPosition(wpObject, size, wpObject.detailProperties.legend, true);
	yPos = getVerticalPosition(wpObject, size, wpObject.detailProperties.legend);

	legendContainer
		.attr("transform","translate(" + xPos + "," + yPos + ")");
			
}

function drawReferenceLines(wpObject){

	//shortcuts
	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom;
	
	let x = wpObject.contextualProperties.d3viz.axis.x;
	let y = wpObject.contextualProperties.d3viz.axis.y;
	
	let foregroundPlot = wpObject.contextualProperties.d3viz.dom.foregroundPlot;	
	let refLinesProp = wpObject.detailProperties.XYChart.referenceLines;
	
	foregroundPlot.selectAll('.refLinesContainer').remove();
	
	if(refLinesProp && refLinesProp.length > 0){
		let refLinesContainer = foregroundPlot.append('g')
								.attr('class','refLinesContainer');
								
			refLinesProp.forEach(function(refProps,i){
				let refLine = refLinesContainer.append('g')
							.attr('class','refLineBlock');
							
				if(wpObject.generalProperties.orientation === 'horizontal'){
					switch(refProps.axis){
						case 'linear' :
							let yPos = y(refProps.values[0]);							
							refLine.attr('transform','translate(0,' + yPos + ')');
							if(refProps.type === 'line'){
								refLine.append('line')
										.attr('x1','5')
										.attr('x2',plotWidth-10)
										.attr('stroke',refProps.color)
										.attr('stroke-width',refProps.width);
										
								refLine.append('text')
										.attr('class','refLineTitle')
										.text(refProps.title.text)
										.attr('x',plotWidth-10-refProps.title.hPadding)
										.attr('y',refProps.title.vPadding)
										.attr('font-family',refProps.title.fontFamily)
										.attr('font-size',refProps.title.fontSize)
										.attr('font-weight',refProps.title.fontWeight)
										.attr('text-anchor',refProps.title.textAnchor)
										.attr('fill',refProps.title.color);
								
								if(refProps.valuesShowOnAxis){
									let ccfIdx = wpObject.detailProperties.currentCalculationFieldsIndex;
									let specificFormat = (wpObject.detailProperties.XYChart.linearAxisLabelFormat ? wpObject.detailProperties.XYChart.linearAxisLabelFormat : wpObject.detailProperties.calculationFieldsFormat[ccfIdx]);
									
									let locale = wpObject.contextualProperties.d3viz.localeNumberFormat;
									let localeFormat = locale.format(specificFormat);
									let axisLabelValue = localeFormat(refProps.values[0]);
									
									axisLabelValue = overrideLocalNumberShortcut(wpObject, axisLabelValue);
									
									refLine.append('text')
										.attr('class','refLineValue')
										.text(axisLabelValue)
										.attr('x',0)
										.attr('y',5)
										.attr('font-family',refProps.title.fontFamily)
										.attr('font-size',refProps.title.fontSize)
										.attr('font-weight',refProps.title.fontWeight)
										.attr('text-anchor',refProps.title.textAnchor)
										.attr('fill',refProps.title.color);
								}
							}
							break;
						case 'categorical' :
							break;
					}
				} else {
					switch(refProps.axis){
						case 'linear' :
							let xPos = x(refProps.values[0]);							
							refLine.attr('transform','translate(' + xPos + ',0)');
							if(refProps.type === 'line'){
								refLine.append('line')
										.attr('y1','5')
										.attr('y2',plotHeight-10)
										.attr('stroke',refProps.color)
										.attr('stroke-width',refProps.width);
										
								refLine.append('text')
										.attr('class','refLineTitle')
										.text(refProps.title.text)
										.attr('x',0)
										.attr('y',refProps.title.vPadding)
										.attr('font-family',refProps.title.fontFamily)
										.attr('font-size',refProps.title.fontSize)
										.attr('font-weight',refProps.title.fontWeight)
										.attr('text-anchor',refProps.title.textAnchor)
										.attr('fill',refProps.title.color);
								
								if(refProps.valuesShowOnAxis){
									let ccfIdx = wpObject.detailProperties.currentCalculationFieldsIndex;
									let specificFormat = (wpObject.detailProperties.XYChart.linearAxisLabelFormat ? wpObject.detailProperties.XYChart.linearAxisLabelFormat : wpObject.detailProperties.calculationFieldsFormat[ccfIdx]);
									
									let locale = wpObject.contextualProperties.d3viz.localeNumberFormat;
									let localeFormat = locale.format(specificFormat);
									let axisLabelValue = localeFormat(refProps.values[0]);
									
									axisLabelValue = overrideLocalNumberShortcut(wpObject, axisLabelValue);
									
									refLine.append('text')
										.attr('class','refLineValue')
										.text(axisLabelValue)
										.attr('x',0)
										.attr('y',plotHeight+5)
										.attr('font-family',refProps.title.fontFamily)
										.attr('font-size',refProps.title.fontSize)
										.attr('font-weight',refProps.title.fontWeight)
										.attr('text-anchor',refProps.title.textAnchor)
										.attr('fill',refProps.title.color);
								}
							}
							break;
						case 'categorical' :
							break;
					}					
				}
			})
	}
	
}

function drawTotal(wpObject){

	let size, xPos = 0, yPos = 0, totalTxt, svgblock,
		totalStyling = wpObject.detailProperties.total,
		foregroundTotal = wpObject.contextualProperties.d3viz.dom.foregroundTotal;
	
	if(wpObject.detailProperties.calculationFieldsTotal){
		foregroundTotal.selectAll('.totalContainer').remove();
		let totalContainer = foregroundTotal
								.append('g')
								.attr('class','totalContainer');
								
		if(totalStyling.SVG){
			svgblock = totalStyling.SVG;
			svgblock = mapVariableValue(svgblock, wpObject.contextualProperties.total);
			totalContainer.appendSVG(svgblock);
			totalTxt = totalContainer.selectAll('text');
		} else {		
			totalTxt = totalContainer
				.append('text');
			
			if(totalStyling.prefix){
				totalTxt
					.append('tspan')
					.attr('class', 'label-prefix')
					.text(totalStyling.prefix)
					.style('font-family', totalStyling.fontFamily)
					.style('font-weight', (totalStyling.prefixFontWeight ? totalStyling.prefixFontWeight : totalStyling.fontWeight))
					.style('font-size', (totalStyling.prefixFontSize ? totalStyling.prefixFontSize : totalStyling.fontSize))			
					.style('fill', (totalStyling.prefixColor ? totalStyling.prefixColor : totalStyling.color));
			}
			
			totalTxt
				.append('tspan')
				.attr('class', 'label-value')
				.text(wpObject.contextualProperties.total[wpObject.detailProperties.calculationFieldsTotal[0]])
				.style('font-family', totalStyling.fontFamily)
				.style('font-weight', totalStyling.fontWeight)
				.style('font-size', totalStyling.fontSize)
				.style('fill', totalStyling.color);
			
			if(totalStyling.suffix){
				totalTxt
					.append('tspan')
					.attr('class', 'label-suffix')
					.text(totalStyling.suffix)
					.style('font-family', totalStyling.fontFamily)
					.style('font-weight', (totalStyling.suffixFontWeight ? totalStyling.suffixFontWeight : totalStyling.fontWeight))
					.style('font-size', (totalStyling.suffixFontSize ? totalStyling.suffixFontSize : totalStyling.fontSize))
					.style('fill', (totalStyling.suffixColor ? totalStyling.suffixColor : totalStyling.color));
			}
		}
		
		
		//styling
		totalTxt
			.style('text-anchor', totalStyling.textAnchor)
			.style('font-family', totalStyling.fontFamily)
			.style('font-weight', totalStyling.fontWeight)
			.style('font-size', totalStyling.fontSize)
			.style('fill', totalStyling.color);
			
		//positionning
		size = d3DomElementSize(totalContainer);
		xPos = getHorizontalPosition(wpObject, size, totalStyling);
		yPos = getVerticalPosition(wpObject, size, totalStyling);
		totalContainer
			.attr("transform","translate(" + xPos + "," + yPos + ")");
	}
}

function drawAxis(wpObject, action){

	//shortcuts
	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		data = wpObject.contextualProperties.dataOut,
		xType, yType;
		
	let x = wpObject.contextualProperties.d3viz.axis.x;
	let y = wpObject.contextualProperties.d3viz.axis.y;
	let axis = wpObject.contextualProperties.d3viz.dom.axis;
	let gridline = wpObject.contextualProperties.d3viz.dom.gridline;
	let gridlineAxis, gridlineAxisDom;
	let axisStyling = wpObject.detailProperties.axis;
	let gridlineStyling = wpObject.detailProperties.gridline;
	let xTicksNumber, yTicksNumber, tickValues;
	
	if(wpObject.generalProperties.chartType === 'dotPlot'){
		if(wpObject.detailProperties.chartSubtype === 'YY'){
			xType = 'linearAxis';
			yType = 'linearAxis';
		} else {
			xType = 'categoricalAxis';
			yType = 'categoricalAxis';
		}
	} else if(wpObject.generalProperties.orientation === 'horizontal'){
		xType = 'categoricalAxis';
		yType = 'linearAxis';
	} else {
		xType = 'linearAxis';
		yType = 'categoricalAxis';
	}
	

	axis.selectAll('.xAxis').remove();
	axis.selectAll('.yAxis').remove();


	if(wpObject.generalProperties.chartType === 'dotPlot'){
		if(wpObject.detailProperties.XYChart.linearAxisTicksNumber){
			if( typeof wpObject.detailProperties.XYChart.linearAxisTicksNumber === 'object' && _.isArray(wpObject.detailProperties.XYChart.linearAxisTicksNumber)){
				xTicksNumber =(wpObject.detailProperties.XYChart.linearAxisTicksNumber[0] ? wpObject.detailProperties.XYChart.linearAxisTicksNumber[0] : null);
				yTicksNumber =(wpObject.detailProperties.XYChart.linearAxisTicksNumber[1] ? wpObject.detailProperties.XYChart.linearAxisTicksNumber[1] : null);
			} else {
				xTicksNumber = yTicksNumber =(wpObject.detailProperties.XYChart.linearAxisTicksNumber ? wpObject.detailProperties.XYChart.linearAxisTicksNumber : null);
			}
		}
	} else {
		xTicksNumber = (wpObject.detailProperties.XYChart[xType + 'TicksNumber'] ? wpObject.detailProperties.XYChart[xType + 'TicksNumber'] : null);
		yTicksNumber = (wpObject.detailProperties.XYChart[yType + 'TicksNumber'] ? wpObject.detailProperties.XYChart[yType + 'TicksNumber'] : null);
	}
	
	//draw axis
	let yAxis = d3.axisLeft()
					.tickSize((wpObject.detailProperties.XYChart[yType + 'TickSize'] || wpObject.detailProperties.XYChart[yType + 'TickSize'] === 0 ? wpObject.detailProperties.XYChart[yType + 'TickSize'] : axisStyling.tickSize))
					.tickPadding((wpObject.detailProperties.XYChart[yType + 'TickPadding'] || wpObject.detailProperties.XYChart[yType + 'TickPadding'] === 0 ? wpObject.detailProperties.XYChart[yType + 'TickPadding'] : axisStyling.tickPadding))
					.ticks(yTicksNumber)					
					.scale(y);
		
	let yAxisDom;

	yAxisDom = axis.append("g")
				.attr("class", "yAxis " + yType)
				.attr("transform", "translate(" + (margin.left + axisStyling.padding) + "," + margin.top + ")")
				.call(yAxis);
	
	let xAxis = d3.axisBottom()
					.tickSize((wpObject.detailProperties.XYChart[xType + 'TickSize'] || wpObject.detailProperties.XYChart[xType + 'TickSize'] === 0 ? wpObject.detailProperties.XYChart[xType + 'TickSize'] : axisStyling.tickSize))
					.tickPadding((wpObject.detailProperties.XYChart[xType + 'TickPadding'] || wpObject.detailProperties.XYChart[xType + 'TickPadding'] === 0 ? wpObject.detailProperties.XYChart[xType + 'TickPadding'] : axisStyling.tickPadding))
					.ticks(xTicksNumber)
					.scale(x);
	
	let xAxisDom;

	xAxisDom = axis.append("g")
				.attr("class", "xAxis " + xType)
				.attr("transform", "translate(" + margin.left + "," + (margin.top + plotHeight - axisStyling.padding) + ")")
				.call(xAxis);
					
	xAxisDom.selectAll('g.tick')				
		.on('mouseover',function(data){
			if(wpObject.detailProperties.events.mouseover){
				if(wpObject.detailProperties.tooltip.active === true && wpObject.detailProperties.tooltip.detectionArea === xType){					
					//linechart
					let shapeSelection = wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll(".linechart-point").filter(function(d, i) { 
						return d[wpObject.detailProperties.dimensionFields[0]] === data; 
					});
					
					if(shapeSelection.size() === 1){
						shapeSelection.select('circle').style("opacity",1);
						//shapeSelection.select('.shape-highlightArea').style("opacity", 1);
						//show highlightArea
						if(wpObject.detailProperties.highlightArea.active === true){
							toggleHighlightArea(wpObject, shapeSelection.node(), data, true);
						}
						toggleTooltip(wpObject, shapeSelection.node(), shapeSelection.datum(), true);
					}
				}
			}
		})
		.on('mouseleave',function(data){
			if(wpObject.detailProperties.events.mouseover){
				if(wpObject.detailProperties.tooltip.active === true && wpObject.detailProperties.tooltip.detectionArea === xType){
					let shapeSelection = wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll(".linechart-point").filter(function(d, i) { return d[wpObject.detailProperties.dimensionFields[0]] === data; });
					if(shapeSelection.size() === 1){
						toggleTooltip(wpObject, this, data, false);
						//linechart
						wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll(".linechart-point").select('circle').style("opacity",0);
						wpObject.contextualProperties.d3viz.dom.foregroundPlot.selectAll(".linechart-point").select('.shape-highlightArea').style("opacity",0);
						if(wpObject.detailProperties.highlightArea.active === true){
								toggleHighlightArea(wpObject, shapeSelection.node(), data, false);
						}
					}
				}
			}
		});

	
	if(wpObject.detailProperties.multiDimensionStyle === 'diverging'){
		if(wpObject.generalProperties.orientation === 'horizontal'){
			xAxisDom
				.attr("transform", "translate(" + margin.left + "," + (margin.top + plotHeight/2 - axisStyling.padding) + ")");
		} else {
			yAxisDom
				.attr("transform", "translate(" + (margin.left  + plotWidth/2 + axisStyling.padding) + "," + (margin.top) + ")")
		}
	}
	
	
	//axis title
	stylingAxis(wpObject, 'x', xType);
	stylingAxis(wpObject, 'y', yType);

	//axis gridline
	gridline.selectAll('.xGridlineAxis').remove();
	gridline.selectAll('.yGridlineAxis').remove();
	
	if(wpObject.detailProperties.XYChart.linearGridline){
		if(wpObject.generalProperties.chartType === 'dotPlot'){
			let xGridline,yGridline, xGridlineTicksNumber, yGridlineTicksNumber;
			if( typeof wpObject.detailProperties.XYChart.linearGridline === 'object' && _.isArray(wpObject.detailProperties.XYChart.linearGridline)){
				xGridline = wpObject.detailProperties.XYChart.linearGridline[0];
				yGridline = wpObject.detailProperties.XYChart.linearGridline[1];
				xGridlineTicksNumber = (wpObject.detailProperties.XYChart.linearGridlineNumber[0] ? wpObject.detailProperties.XYChart.linearGridlineNumber[0] : (wpObject.detailProperties.XYChart.linearAxisTicksNumber[0] ? wpObject.detailProperties.XYChart.linearAxisTicksNumber[0] : null));
				yGridlineTicksNumber = (wpObject.detailProperties.XYChart.linearGridlineNumber[1] ? wpObject.detailProperties.XYChart.linearGridlineNumber[1] : (wpObject.detailProperties.XYChart.linearAxisTicksNumber[1] ? wpObject.detailProperties.XYChart.linearAxisTicksNumber[1] : null));
			} else {
				xGridline = yGridline = wpObject.detailProperties.XYChart.linearGridline;
				xGridlineTicksNumber = yGridlineTicksNumber = (wpObject.detailProperties.XYChart.linearGridlineNumber ? wpObject.detailProperties.XYChart.linearGridlineNumber : (wpObject.detailProperties.XYChart.linearAxisTicksNumber ? wpObject.detailProperties.XYChart.linearAxisTicksNumber : null));
			}
			
			gridlineAxis = d3.axisLeft()
							.tickSize(-(plotWidth + gridlineStyling.padding + axisStyling.padding))
							.ticks(yGridlineTicksNumber)
							.scale(y);
							
			gridlineAxisDom = gridline.append("g")
							.attr("class", "yGridlineAxis  gridlineAxis")
							.attr("transform", "translate(" + margin.left + "," + margin.top + ")")
							.call(gridlineAxis);
							
			gridlineAxis = d3.axisBottom()
							.tickSize(plotHeight)
							.ticks(xGridlineTicksNumber)
							.scale(x);
							
			gridlineAxisDom = gridline.append("g")
							.attr("class", "xGridlineAxis  gridlineAxis")
							.attr("transform", "translate(" + margin.left + "," + margin.top + ")")
							.call(gridlineAxis);
		} else if(wpObject.generalProperties.orientation === 'horizontal'){
			gridlineAxis = d3.axisLeft()
							.tickSize(-(plotWidth + gridlineStyling.padding + axisStyling.padding))
							.ticks((wpObject.detailProperties.XYChart.linearAxisTicksNumber ? wpObject.detailProperties.XYChart.linearAxisTicksNumber : null))
							.scale(y);
							
			gridlineAxisDom = gridline.append("g")
							.attr("class", "yGridlineAxis  gridlineAxis")
							.attr("transform", "translate(" + margin.left + "," + margin.top + ")")
							.call(gridlineAxis);		
		} else {
			gridlineAxis = d3.axisBottom()
							.tickSize(plotHeight)
							.ticks((wpObject.detailProperties.XYChart.linearAxisTicksNumber ? wpObject.detailProperties.XYChart.linearAxisTicksNumber : null))
							.scale(x);
							
			gridlineAxisDom = gridline.append("g")
							.attr("class", "xGridlineAxis  gridlineAxis")
							.attr("transform", "translate(" + margin.left + "," + margin.top + ")")
							.call(gridlineAxis);		
		}
	}
	
	if(wpObject.detailProperties.XYChart.categoricalGridline){
		let centering = 0;
		if(wpObject.generalProperties.orientation === 'horizontal'){
			if(wpObject.detailProperties.XYChart.categoricalGridlineCentering){
				centering = x.step()/2;
			}
			gridlineAxis = d3.axisBottom()
							.tickSize(plotHeight)
							.scale(x);
							
			gridlineAxisDom = gridline.append("g")
							.attr("class", "yGridlineAxis  gridlineAxis")
							.attr("transform", "translate(" + Math.floor(margin.left + centering) + "," + Math.floor(margin.top) + ")")
							.call(gridlineAxis);
		} else {
			if(wpObject.detailProperties.XYChart.categoricalGridlineCentering){
				centering = y.step()/2;
			}
			gridlineAxis = d3.axisLeft()
							.tickSize(-(plotWidth - gridlineStyling.padding - axisStyling.padding))
							.scale(y);
							
			gridlineAxisDom = gridline.append("g")
							.attr("class", "xGridlineAxis gridlineAxis")
							.attr("transform", "translate(" + Math.floor(margin.left + gridlineStyling.padding + axisStyling.padding) + "," + Math.floor(margin.top + centering) + ")")
							.call(gridlineAxis);
		}		
	}

	
	//gridline styling
	gridlineAxisDom = gridline.selectAll('.gridlineAxis');
	
	//gridlineAxisDom.style('opacity', gridlineStyling.opacity);

	if(!gridlineStyling.showExtend){
		//hide first gridline
		gridlineAxisDom.selectAll('.tick:last-of-type line')
			.style('display','none');
	}
			
	gridlineAxisDom.selectAll('.tick line')
			.style('shape-rendering','auto')
			.style('stroke-dasharray',gridlineStyling.dashArray)
			.style('stroke', gridlineStyling.color)
			.style('stroke-width',gridlineStyling.width)
			.style('stroke-opacity',gridlineStyling.opacity);
	
	gridlineAxisDom.selectAll('.tick text')
		.style('display','none');
	
	gridlineAxisDom.selectAll('.domain')
		.style('display','none');
			
}

function drawParallelAxis(wpObject){

	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		panelWidth = plotWidth - padding.left - padding.right,
		panelHeight = plotHeight - padding.top - padding.bottom,
		data = wpObject.contextualProperties.dataOut,
		xType, yType, yPos;
		
	let x = wpObject.contextualProperties.d3viz.axis.x;
	let y = wpObject.contextualProperties.d3viz.axis.y;
	let axis = wpObject.contextualProperties.d3viz.dom.axis;
	
	axis.selectAll(".yAxis").remove();
	
	if(wpObject.detailProperties.chartSubtype === 'parallel'){
		wpObject.contextualProperties.d3viz.axis.dimension.domain.forEach(function(domain,i){
			let yAxisDom = axis.append("g")
					.attr("class", "yAxis yAxis_" + domain)
					.attr("transform", "translate(" + (margin.left + x(domain)) + "," + margin.top + ")")
			//title
			let titleProperties = wpObject.detailProperties.parallel.linearAxis[i].title;
			if(titleProperties.active && titleProperties.text){
				yPos = titleProperties.vPadding;
				yAxisDom
					.append('g')
					.attr('class', 'titleContainer')
					.attr("transform", "translate(0," + yPos + ")")
					.append('text')
					.attr('class', 'title')
					.attr('transform', (titleProperties.rotate ? "rotate(" + titleProperties.rotate + ")" : "rotate(0)"))
					.append('tspan')
					.style('text-anchor', titleProperties.textAnchor)
					.text(titleProperties.text);
			
				yAxisDom.selectAll('.titleContainer text')
					.style('fill', titleProperties.color)
					.style('font-size', titleProperties.fontSize)
					.style('font-weight',titleProperties.fontWeight);
			}
		})
	} else if(wpObject.detailProperties.chartSubtype === 'slopegraph'){
		wpObject.contextualProperties.d3viz.axis.dimension.domain.forEach(function(domain,i){
			let yAxisDom = axis.append("g")
					.attr("class", "yAxis yAxis_" + domain)
					.attr("transform", "translate(" + (margin.left + x(domain)) + "," + margin.top + ")")
			//title
			let titleProperties = wpObject.detailProperties.parallel.slopeLinearAxis.title;
			let titleTxt = titleProperties.text;
			if(titleTxt === null){
				titleTxt = domain;
			}
			if(titleProperties.active && titleTxt){				
				yPos = titleProperties.vPadding;
				yAxisDom
					.append('g')
					.attr('class', 'titleContainer')
					.attr("transform", "translate(0," + yPos + ")")
					.append('text')
					.attr('class', 'title')
					.attr('transform', (titleProperties.rotate ? "rotate(" + titleProperties.rotate + ")" : "rotate(0)"))
					.append('tspan')
					.style('text-anchor', titleProperties.textAnchor)
					.text(titleTxt);
			
				yAxisDom.selectAll('.titleContainer text')
					.style('fill', titleProperties.color)
					.style('font-size', titleProperties.fontSize)
					.style('font-weight',titleProperties.fontWeight);
			}
		})
	}
	
}

function drawSpiderAxis(wpObject){


	let axis = wpObject.contextualProperties.d3viz.dom.axis;
	let gridline = wpObject.contextualProperties.d3viz.dom.gridline;
	let levels = wpObject.detailProperties.spider.linearGridlineNumber;
	let maxValue = wpObject.contextualProperties.d3viz.axis.measure.domain[1];
	let radius = wpObject.contextualProperties.d3viz.spider.radius;
	let rScale = wpObject.contextualProperties.d3viz.spider.rScale;
	let angleSlice = wpObject.contextualProperties.d3viz.spider.angleSlice;
	let labelFactor = 1.25;
	let dimensionDomain = wpObject.contextualProperties.d3viz.axis.dimension.domain;
	let spiderAxis;

	let margin = wpObject.generalProperties.margin,
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom;	
	
	
	//Draw the background circles
	gridline.selectAll('.spiderGridLine').remove();
	
	let spiderGridLine = gridline.append('g').attr('class','spiderGridLine');
	
	spiderGridLine.selectAll(".levels")
	   .data(d3.range(1,(levels+1)).reverse())
	   .enter()
		.append("circle")
		.attr("class", "gridCircle")
		.attr("r", function(d, i){return radius/levels*d;})
		.style("stroke", wpObject.detailProperties.gridline.color)
		.style('stroke-dasharray',wpObject.detailProperties.gridline.dashArray)
		.style('stroke-width',wpObject.detailProperties.gridline.width)
		.style('stroke-opacity',wpObject.detailProperties.gridline.opacity)
		.style("fill", wpObject.detailProperties.gridline.color)
		.style("fill-opacity", wpObject.detailProperties.gridline.fillOpacity);
		//.style("filter" , "url(#glow)");

	//Text indicating at what % each level is
	spiderGridLine.selectAll(".axisLabel")
	   .data(d3.range(1,(levels+1)).reverse())
	   .enter().append("text")
	   .attr("class", "axisLabel")
	   .attr("x", 4)
	   .attr("y", function(d){return -d*radius/levels;})
	   .attr("dy", "0.4em")
	   .style("font-size", "10px")
	   .attr("fill", "#737373")
	   .text(function(d,i) {
			return (maxValue * d/levels); 
	   });

	
	spiderGridLine.attr('transform', 'translate('+ (margin.left+plotWidth/2)  +',' + (margin.top+plotHeight/2) + ')');
	
	if(!wpObject.detailProperties.spider.linearGridline){
		spiderGridLine.attr('display','none');
	}
	
	/////////////////////////////////////////////////////////
	//////////////////// Draw the axes //////////////////////
	/////////////////////////////////////////////////////////
	
 	axis.selectAll('.spiderAxis').remove();
	
	if(wpObject.detailProperties.spider.linearAxisPosition === 'background'){
		spiderAxis = gridline.append('g');
	} else {
		spiderAxis = axis.append('g');
	}
	
	spiderAxis
		.attr('class','spiderGridLine')
		.attr('transform', 'translate('+ (margin.left+plotWidth/2)  +',' + (margin.top+plotHeight/2) + ')');
						
	//Create the straight lines radiating outward from the center
	let axisData = spiderAxis.selectAll(".axis")
		.data(dimensionDomain)
		.enter()
		.append("g")
		.attr("class", "axis");
		
		
	//Append the lines	
	axisData.append("line")
		.attr("x1", 0)
		.attr("y1", 0)
		.attr("x2", function(d, i){ return rScale(maxValue*1.1) * Math.cos(angleSlice*i - Math.PI/2); })
		.attr("y2", function(d, i){ return rScale(maxValue*1.1) * Math.sin(angleSlice*i - Math.PI/2); })
		.attr("class", " line")
		.style("stroke", wpObject.detailProperties.axis.color)
		.style("stroke-width", wpObject.detailProperties.axis.lineWidth);

	//Append the labels at each axis
 	axisData.append("text")
		.attr("class", "axis-label")
		.style("font-size", "11px")
		.attr("text-anchor", "middle")
		.style("fill", wpObject.detailProperties.axis.labelColor)
		.attr("dy", "0.35em")
		.attr("x", function(d, i){ return rScale(maxValue * labelFactor) * Math.cos(angleSlice*i - Math.PI/2); })
		.attr("y", function(d, i){ return rScale(maxValue * labelFactor) * Math.sin(angleSlice*i - Math.PI/2); })
		.text(function(d){return d})
		.style('font-family',wpObject.detailProperties.axis.fontFamily)
		.style('font-size',wpObject.detailProperties.axis.fontSize)
		.style('font-weight', wpObject.detailProperties.axis.fontWeight);
		//.call(wrap, cfg.wrapWidth);

	if(!wpObject.detailProperties.spider.linearAxis){
		axisData.selectAll('.line').attr('display','none');
	}
	
	if(!wpObject.detailProperties.spider.linearAxisLabel){
		axisData.selectAll('.axis-label').attr('display','none');
	}
}

function stylingAxis(wpObject, position, axisType, action){

	//shortcuts
	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom;
		
	let axis = wpObject.contextualProperties.d3viz.dom.axis;
	let gridline = wpObject.contextualProperties.d3viz.dom.gridline;
	let gridlineAxis, gridlineAxisDom;
	let axisStyling = wpObject.detailProperties.axis;
	
	//axis title
	if(wpObject.detailProperties.XYChart[axisType + 'Title']){
		let xPos = 0, yPos = 0, dy, titleTxt;

		if(position === 'x'){
			xPos = (axisStyling.titleRelPosition === 'external' ? plotWidth : (axisStyling.titleRelPosition === 'internal' ? 0 : plotWidth/2));
			yPos = (axisStyling.titlePosition === 'inside' ? 0 : margin.bottom - axisStyling.titlePadding);
			dy = (axisStyling.titlePosition === 'inside' ? '1em' : '-0.7em');
		} else {
			yPos = (axisStyling.titleRelPosition === 'external' ? 0 : (axisStyling.titleRelPosition === 'internal' ? plotHeight : plotHeight/2));
			xPos = (axisStyling.titlePosition === 'inside' ? 5 : -margin.left  + axisStyling.titlePadding);
			dy = (axisStyling.titlePosition === 'inside' ? '-0.7em' : '1em');
		}
		
		if(wpObject.generalProperties.chartType === 'dotPlot'){
			titleTxt = (typeof wpObject.detailProperties.XYChart[axisType + 'Title'] === 'object' ? (position === 'x' ? wpObject.detailProperties.XYChart[axisType + 'Title'][0] : wpObject.detailProperties.XYChart[axisType + 'Title'][1]): wpObject.detailProperties.XYChart[axisType + 'Title']);
		} else {
			titleTxt = wpObject.detailProperties.XYChart[axisType + 'Title'];
		}
		
		axis.selectAll('.' + position + 'Axis.' + axisType + ' .titleContainer').remove();
		
		axis.selectAll('.' + position + 'Axis.' + axisType)
			.append('g')
			.attr('class', 'titleContainer')
			.attr("transform", "translate(" + xPos + "," + yPos + ")")
			.style('display',(axisStyling.title ? 'inline' : 'none'))
			.append('text')
			.attr('dy', dy)
			.attr('class', 'title')
			.attr('transform', (position === 'y' ? 'rotate(270)' : 'rotate(0)'))
			.append('tspan')
			.style('text-anchor', (axisStyling.titleRelPosition === 'external' ? 'end' : (axisStyling.titleRelPosition === 'internal' ? 'start' : 'middle')))
			.text(titleTxt);
			
		axis.selectAll('.' + position + 'Axis.' + axisType + ' .titleContainer text')
			.style('fill', axisStyling.labelColor)
			.style('font-size', axisStyling.titleFontSize)
			.style('font-weight',axisStyling.titleFontWeight);
	}
	
	axis.selectAll('.' + position + 'Axis.' + axisType + ' .domain')
			.style('stroke-width',axisStyling.lineWidth)
			.style('stroke',axisStyling.color);

	axis.selectAll('.' + position + 'Axis.' + axisType + ' .tick line')
			.style('stroke',axisStyling.color);
	
	axis.selectAll('.' + position + 'Axis.' + axisType + ' .tick text')
		.style('font-family',axisStyling.fontFamily)
		.style('font-size',(wpObject.detailProperties.XYChart[axisType + 'FontSize'] ? wpObject.detailProperties.XYChart[axisType + 'FontSize'] : axisStyling.fontSize))
		.style('font-weight', (wpObject.detailProperties.XYChart[axisType + 'FontWeight'] ? wpObject.detailProperties.XYChart[axisType + 'FontWeight'] : axisStyling.fontWeight))
		.style('fill',axisStyling.labelColor);
		
	//axis label text-anchor
	if(wpObject.detailProperties.XYChart[axisType + 'LabelTextAnchor']){
		axis.selectAll('.' + position + 'Axis.' + axisType + ' .tick text')
			.style('text-anchor',wpObject.detailProperties.XYChart[axisType + 'LabelTextAnchor']);
	}

	//axis label formatting
	let labels = axis.selectAll('.' + position + 'Axis.' + axisType + ' .tick text');
	let cntLabels = labels.size();
	labels
		.each(function(d,i){
			let axisLabel = d3.select(this);
			
			if(axisType === 'categoricalAxis'){
				if(wpObject.detailProperties.XYChart.categoricalAxisLabelTextWrapWidth){
					let dy = parseFloat(axisLabel.attr("dy"));
					//axisLabel.attr('alignment-baseline','middle');
					if(wpObject.detailProperties.dimensionFieldsDatatype){
						if(wpObject.detailProperties.dimensionFieldsDatatype[0] === 'date'){
							let dateParse = d3.timeParse(wpObject.detailProperties.dimensionFieldsFormat[0]);
							let locale = wpObject.contextualProperties.d3viz.localeFormat;
							if(wpObject.detailProperties.XYChart.categoricalAxisLabelFormat){
								let dateFormat = locale.format(wpObject.detailProperties.XYChart.categoricalAxisLabelFormat);
								axisLabel.text(dateFormat(dateParse(d)));
							} else {
								let dateFormat = locale.format('%b %Y');
								let dateFormatSimple = locale.format('%b');
								let month = d3.timeFormat('%m')(dateParse(d));
								if(i === 0 || i === (cntLabels-1) || month === '01'){
									axisLabel.text(dateFormat(dateParse(d)));
								} else {
									axisLabel.text(dateFormatSimple(dateParse(d)));
								}
							}
						} else if(wpObject.detailProperties.dimensionFieldsDatatype[0] === 'number'){
							let specificFormat = (wpObject.detailProperties.XYChart.categoricalAxisLabelFormat ? wpObject.detailProperties.XYChart.categoricalAxisLabelFormat : wpObject.detailProperties.dimensionFieldsFormat[0]);
							
							let locale = wpObject.contextualProperties.d3viz.localeNumberFormat;
							let localeFormat = locale.format(specificFormat);
							let axisLabelValue = localeFormat(d);
							//TODO : gérer plus proprement l'override de format via une fonction spécifique 
							//axisLabelValue = axisLabelValue.replace(/G/, 'md');
							axisLabelValue = overrideLocalNumberShortcut(wpObject,axisLabelValue);
							axisLabel.text(axisLabelValue);							
						}
					}
					
					let textWidth = wpObject.detailProperties.XYChart.categoricalAxisLabelTextWrapWidth;
					if(wpObject.generalProperties.chartType === 'barchart' && wpObject.detailProperties.XYChart.categoricalAxisLabelTextWrapWidth === 'bandwidth'){
						textWidth = wpObject.contextualProperties.d3viz.barchart.bandwidth;
					}
					let lineNumber = textWrap(axisLabel, textWidth, wpObject.detailProperties.XYChart.categoricalAxisLabelTextWrapLineHeight, dy);
					//axisLabel.select(".textLine0").attr("dy", dy + 'em');

					if(wpObject.generalProperties.orientation === 'vertical'){
						if(lineNumber > 1){
							axisLabel.select(".textLine0").attr("dy", (- dy*lineNumber) + 'em');
						}
					}
					
					//label shifting
					if(wpObject.detailProperties.XYChart.categoricalAxisLabelTextShift && wpObject.detailProperties.XYChart.categoricalAxisLabelTextShift > 0){
						if(i%2 !== 0){
							let label = axisLabel.selectAll(".textLine");
							label.each(function(d,i){
								let l = d3.select(this);
								let dy = parseFloat(l.attr("dy"));
								l.attr("dy", (dy + wpObject.detailProperties.XYChart.categoricalAxisLabelTextShift) + 'em');
							})
						}
					}
				}
			} else {
				let ccfIdx = wpObject.detailProperties.currentCalculationFieldsIndex;
				let specificFormat = (wpObject.detailProperties.XYChart.linearAxisLabelFormat ? wpObject.detailProperties.XYChart.linearAxisLabelFormat : wpObject.detailProperties.calculationFieldsFormat[ccfIdx]);
				
				let locale = wpObject.contextualProperties.d3viz.localeNumberFormat;
				let localeFormat = locale.format(specificFormat);
				let axisLabelValue = localeFormat(d);
				//TODO : gérer plus proprement l'override de format via une fonction spécifique 
				//axisLabelValue = axisLabelValue.replace(/G/, 'md');
				axisLabelValue = overrideLocalNumberShortcut(wpObject,axisLabelValue);
				axisLabel.text(axisLabelValue);

			}
		});
		
	
	//hide axis elements
	if(!wpObject.detailProperties.XYChart[axisType]){
		axis.selectAll('.' + position + 'Axis.' + axisType + ' .domain')
			.style('display','none');
		
		axis.selectAll('.' + position + 'Axis.' + axisType + ' .tick line')
			.style('display','none');
	}
	
	if(!wpObject.detailProperties.XYChart[axisType + 'Tick']){
		axis.selectAll('.' + position + 'Axis.' + axisType + ' .tick line')
			.style('display','none');
	}
	
	if(!wpObject.detailProperties.XYChart[axisType + 'Label']){
		axis.selectAll('.' + position + 'Axis.' + axisType + ' .tick text')
			.style('display','none');
	}

	//axis label padding
	axis.selectAll('.' + position + 'Axis.' + axisType + ' .tick text')
		.attr("transform", "translate(" + wpObject.detailProperties.XYChart[axisType + 'LabelHPadding'] + "," + wpObject.detailProperties.XYChart[axisType + 'LabelVPadding'] + ")")

		
}


/*******************************************/
/***     chart interactions elements 	***/
/*****************************************/

function toggleWidgetAnnotations(wpObject, domElem, d, show, delay = 0, duration = 0){
	
	let annotationArea = wpObject.contextualProperties.d3viz.dom.foregroundPlot;
	let plot = wpObject.contextualProperties.d3viz.dom.plot;
	let notes_t;
	
	//show/hide all annotations
	if(domElem === null && d === null){
		if(delay || duration){
			notes_t = d3.transition().delay(delay).duration(duration);
		}
		if(show){
			annotationArea.selectAll(".annotationContainer").style('display', 'inline').transition(notes_t).style('opacity',1);
		} else {
			annotationArea.selectAll(".annotationContainer").transition(notes_t).style('display', 'none');
		}
		wpObject.contextualProperties.d3viz.annotation.containerVisible = show;		
		wpObject.detailProperties.annotation.visible = show;
		return true;
	}
	
}

function toggleHighlightArea(wpObject, domElem, d, show){

	let highlightAreaProps = wpObject.detailProperties.highlightArea;
	
	if(show === false){
		d3.select(domElem).select('.shape-highlightArea').style("opacity", 0);
	} else {
		d3.select(domElem).select('.shape-highlightArea').style("opacity", highlightAreaProps.opacity);
	}
}

function toggleHighlightLabel(wpObject, domElem, d, highlightProperties, container, classnames, show){
	
	if(show === false){
		container.selectAll(classnames).style("fill", function(data){ return (data.__shapeColor__ ? data.__shapeColor__ : (data.shapeColor ? data.shapeColor : '#ffffff'))});
 		container.selectAll(classnames)
			.style('fill',function(d){ return d.labelColor})
			.style('opacity',highlightProperties.opacity)
			.style('font-weight',highlightProperties.fontWeight)
			.style('font-size',highlightProperties.fontSize);
	} else {
		if(highlightProperties.noneHighlight && highlightProperties.noneHighlight.opacity){
			container.selectAll(classnames).style("opacity", highlightProperties.noneHighlight.opacity);
		}
		if(highlightProperties.opacity){
			domElem.style("opacity", highlightProperties.opacity);
		}
		if(highlightProperties.color){
			domElem.style("fill", highlightProperties.color);
		}
		if(highlightProperties.fontSize){
			domElem.style("font-size", highlightProperties.fontSize);
		}
		if(highlightProperties.fontWeight){
			domElem.style("font-weight", highlightProperties.fontWeight);
		}
	}
		
}

function toggleHighlightShape(wpObject, domElem, d, highlightProperties, show){

	let plot = wpObject.contextualProperties.d3viz.dom.plot;
	let foregroundPlot = wpObject.contextualProperties.d3viz.dom.foregroundPlot;
	
	if(show === false){
		//opacity
		plot.selectAll("." + d.__shapeTypeClass__ + " .shape").style("opacity", function(data){ return (data.opacity ? data.opacity : 1)});
		
		//color
		plot.selectAll("." + d.__shapeTypeClass__ + " .shape").style("stroke", function(data){ return (data.__shapeColor__ ? data.__shapeColor__ : (data.shapeColor ? data.shapeColor : '#ffffff'))});
		if(wpObject.generalProperties.chartType === 'linechart'){
			foregroundPlot.selectAll(".linechart-point circle")
				.style("opacity", function(data){ return (data.__opacity__ ? data.__opacity__ : 0)})
				.style("stroke", function(data){ return (data.__shapeColor__ ? data.__shapeColor__ : (data.shapeColor ? data.shapeColor : '#ffffff'))});
		}		
		//strokeWidth
		plot.selectAll("." + d.__shapeTypeClass__ + " .shape").style("stroke-width", function(data){ return (data.__strokeWidth__ ? data.__strokeWidth__ : 1)});
	} else {
		//opacity
		if(highlightProperties.noneHighlight && (highlightProperties.noneHighlight.opacity || highlightProperties.noneHighlight.opacity === 0)){
			plot.selectAll("." + d.__shapeTypeClass__ + " .shape").style("opacity", highlightProperties.noneHighlight.opacity);
			if(wpObject.generalProperties.chartType === 'linechart'){
				foregroundPlot.selectAll(".linechart-point circle")
					.filter(function(data){ return data.__visible__ === true;})
					.style("opacity", highlightProperties.noneHighlight.opacity);
			}			
		}
		if(highlightProperties.opacity){
			domElem.style("opacity", highlightProperties.opacity);
		}
		//color
		if(highlightProperties.noneHighlight && highlightProperties.noneHighlight.strokeColor){
			plot.selectAll("." + d.__shapeTypeClass__ + " .shape").style("stroke", highlightProperties.noneHighlight.strokeColor);			
		}
		if(highlightProperties.strokeColor){
			domElem.style("stroke", highlightProperties.strokeColor);			
			if(wpObject.generalProperties.chartType === 'linechart'){
				foregroundPlot.selectAll(".linechart-point circle")
					.filter(function(data){ return data.serieIndex === d.serieIndex;})
					.style("opacity", 1)
					.style("stroke", highlightProperties.strokeColor);
			}
		}
		//strokeWidth
		if(highlightProperties.noneHighlight && highlightProperties.noneHighlight.strokeWidth){
			plot.selectAll("." + d.__shapeTypeClass__ + " .shape").style("stroke-width", highlightProperties.noneHighlight.strokeWidth);
		}
		if(highlightProperties.strokeWidth){
			domElem.style("stroke-width", highlightProperties.strokeWidth);
		}
	}
}

function toggleBreadcrumb(wpObject, domElem, d, show){
	
	let svgblock,
		xPos, yPos, size,
		tagId = '#' + wpObject.contextualProperties.tagId,
		BcArea = wpObject.contextualProperties.d3viz.dom.foregroundHtmlViz,
		BcProperties = wpObject.detailProperties.breadcrumb,
		margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom;
		
	if(show === false){
		d3.selectAll(tagId + ' .breadcrumbContainer').remove();
		return true;
	}
	
	//get ancestors;
	let sequenceArray = d.ancestors().reverse();

	let plot = wpObject.contextualProperties.d3viz.dom.plot;
		
	let selection = plot.selectAll('.shape')
		.filter(function(node) {
			return (sequenceArray.indexOf(node) >= 0);
		});
		
	svgblock  = "<svg class='breadcrumbContainer' style='overflow:visible'><g class='breadcrumbBlock' transform='translate(0,0)'>";
	svgblock += "	<g class='breadcrumbContent'>";
	let countElement = selection.size();
	selection.each(function(d,i){
		let value = "" ;
		let bcShape = "M0,0 h" + (BcProperties.width-30) + " l30," + BcProperties.height/2 + " l-30," + BcProperties.height/2 + " h-" + (BcProperties.width-30);
		if(i>0){
			bcShape += " l30,-" + BcProperties.height/2;
		}
		bcShape += " Z";
		
		svgblock += "<g class='breadcrumbElementContainer' transform='translate(" + (i*BcProperties.width + (-25*i)) + ",0)'>";
		svgblock += "	<path d='" + bcShape + "' style='fill:" + d.shapeColor + ";stroke : " + BcProperties.strokeColor + ";stroke-width : " + BcProperties.strokewidth + "' />";		
		
		if(BcProperties.SVG){
			value = BcProperties.SVG;
			value = mapVariableValue(value, d, BcProperties.variableFormat, wpObject);
		} else {
			if(!BcProperties.text || BcProperties.text === 'default'){
				value = d.__key__;
				if(d[wpObject.detailProperties.dimensionFields[i]]){
					value = d[wpObject.detailProperties.dimensionFields[i]];
				}
			}
		}
		
		svgblock += "	<g transform='translate(" + BcProperties.width/2 + ",8)'><text>" + value + "</text></g>";
		svgblock += "</g>";
	})
	
	svgblock += "	</g>";
	svgblock += "</g></svg>";
	
	BcArea.appendSVG(svgblock);
	
	BcArea.selectAll('.breadcrumbElementContainer text')
			.attr('dy','0.3em')
			.style('text-anchor',BcProperties.textAnchor)
			.style('font-family',BcProperties.fontFamily)
			.style('fill',BcProperties.color)
			.style('font-size',BcProperties.fontSize)
			.style('font-weight',BcProperties.fontWeight)
			.style('font-style',BcProperties.fontStyle);
	
	size = d3DomElementSize(BcArea.selectAll('.breadcrumbContainer'));
	xPos = getHorizontalPosition(wpObject, size, BcProperties);
	yPos = getVerticalPosition(wpObject, size, BcProperties);
		
	BcArea.select('.breadcrumbBlock')
		.attr("transform", "translate(" + xPos + ", " + yPos + ")");
	
}

function toggleTooltip(wpObject, domElem, d, show, shapeType){
	
	let svgblock, tooltipSvgBox,
		xPos, yPos, xDecalage = 0, pointerPadding,
		mousePositionViz, mousePositionPlot, tooltipBoxSize,
		hTooltipRelPos,vTooltipRelPos,
		tagId = '#' + wpObject.contextualProperties.tagId,
		tooltipArea = wpObject.contextualProperties.d3viz.dom.foregroundHtmlViz,
		tooltipProperties = wpObject.detailProperties.tooltip,
		margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom;

	
	//default dimensions
	let dimensions = {'width' : 200, 'height' : 150, 'margin' : 10};
	
	pointerPadding = (tooltipProperties.pointer ? 20 : 0);
	
	if(show === false){
		wpObject.contextualProperties.d3viz.tooltip.visible = false;
		d3.select(tagId + ' .tooltipContainer').remove();
		if(tooltipProperties.message){
			if(tooltipProperties.message.automaticDisappear === 0 || tooltipProperties.message.automaticDisappear > tooltipProperties.message.count){
				wpObject.contextualProperties.d3viz.dom.tooltipMsg.style('display', 'inline');
			}
		}
		if(tooltipProperties.highlight && tooltipProperties.highlight.active){		
			let plot = wpObject.contextualProperties.d3viz.dom.plot;
			let plotLink = wpObject.contextualProperties.d3viz.dom.plotLink;
			
			plot.selectAll('.shape')
				.style('opacity', 1)
				.style("fill", function(data){ return (data.__shapeColor__ ? data.__shapeColor__ : (data.shapeColor ? data.shapeColor : '#ffffff'))});
			
			plotLink.selectAll('.link')
				.style('opacity', function(data){ return (data.__opacity__ ? data.__opacity__ : 1);})
				.style('stroke-width', function(data){ return (data.__strokeWidth__ ? data.__strokeWidth__ : 1);})
				.style("fill", function(data){ return (data.__shapeColor__ ? data.__shapeColor__ : (data.shapeColor ? data.shapeColor : '#ffffff'))});
		}
		return true;
	}	
	
	//check restriction
	if(tooltipProperties.restrictionColumn){
		let restrictionflag = false;
		tooltipProperties.restrictionColumn.forEach(function(c,i){
			if(_.has(d, c) && (tooltipProperties.restrictionColumnToValue[i] || tooltipProperties.restrictionColumnToValue[i] === 0)){
				if(d[c] !== tooltipProperties.restrictionColumnToValue[i]){
					restrictionflag = true;
				}
			}
		})
		if(restrictionflag === true){
			return false;
		}
	}
	
	//get mouse position in plot & viz area
	//mousePositionPlot = d3.mouse(tooltipArea.node());
	mousePositionPlot = d3.mouse(wpObject.contextualProperties.d3viz.dom.plot.node());
	mousePositionViz = d3.mouse(wpObject.contextualProperties.d3viz.dom.viz.node());
	
	if(tooltipProperties.hRelPosition === 'adjust'){
		hTooltipRelPos = (mousePositionViz[0] < vizWidth/2 ? 'right' : 'left');
	} else {
		hTooltipRelPos = tooltipProperties.hRelPosition;
	}
	if(tooltipProperties.vRelPosition === 'adjust'){
		vTooltipRelPos = (mousePositionViz[1] < vizHeight/2 ? 'down' : 'up');
	} else {
		vTooltipRelPos = tooltipProperties.vRelPosition;
	}
	
	let borderRadius = tooltipProperties.borderRadius;
		
	svgblock  = "<svg class='tooltipContainer' style='overflow:visible;width:5px;height:5px'><g transform='translate(0,0)'><g class='tooltipBlock' transform='translate(0,0)'>";
	svgblock += "	<g class='tooltipBox'>";
	svgblock += "		<line class='verticalLine'/>";
	svgblock += "		<line class='horizontalLine'/>";
	svgblock += "		<rect class='bck' width='" + dimensions.width + "' height='" + dimensions.height + "' rx='" + borderRadius + "' ry='" + borderRadius + "'/>";
	svgblock += "		<path class='bck pointer' d='M0 0 L18 0 L9 16 Z' transform='translate(120, " + dimensions.height + ")' />";
	svgblock += "	</g>";
	svgblock += "	<g class='tooltipContent'>";
	svgblock += "	</g>";
	svgblock += "</g></g></svg>";

	
	if(wpObject.contextualProperties.d3viz.tooltip.visible === false){
		tooltipArea.appendSVG(svgblock);
	} else {
		tooltipSvgBox = tooltipArea.select('.tooltipElement');
	}
	

	//////// test call specificFn
	if(tooltipProperties.tooltipSpecificFn && checkSpecificFunction(tooltipProperties.tooltipSpecificFn)){
		specificFunctionCall(tooltipProperties.tooltipSpecificFn, wpObject, tooltipArea, dimensions, domElem, d);
		//window[tooltipProperties.tooltipSpecificFn](wpObject, tooltipArea, dimensions, domElem, d);
	} else {
		if(tooltipProperties.SVG){
			if(tooltipProperties.tooltipSpecificSVGRulesFn && checkSpecificFunction(tooltipProperties.tooltipSpecificSVGRulesFn)){
				tooltipProperties.SVG = specificFunctionCall(tooltipProperties.tooltipSpecificSVGRulesFn, wpObject, tooltipProperties, d);				
			}
			svgblock = tooltipProperties.SVG;
			svgblock = mapVariableValue(svgblock, d, tooltipProperties.variableFormat, wpObject);
		} else {
			svgblock = "<g>";
			//TODO : virer ce bout de code et remplacer avec la propriété text
			if(tooltipProperties.column && tooltipProperties.column.length > 0){
				tooltipProperties.column.forEach(function(c,i){
					if(d[c]){
						let value = d[c];
						if(tooltipProperties.columnFormat && tooltipProperties.columnFormat[i]){
							value = d3.format(tooltipProperties.columnFormat[i])(value);
						}
						svgblock += "<text class='tooltipText' x='" + (dimensions.margin + 10) + "' y='" + (20 + i*40) + "' dy='0.7em'><tspan>" + value + "</tspan><tspan>" + tooltipProperties.columnSuffix[i] + "</tspan></text>";
					}
					if(tooltipProperties.lineSeparator && i>0){
						svgblock += "<line class='lineSeparator' x1='" + (dimensions.margin) + "' x2='" + (dimensions.width - dimensions.margin) + "' y1='" + (5 + i*40) + "' y2='" + (5 + i*40) + "' />";
					}
				})		
			}
			svgblock += "</g>";
		}
		tooltipArea.select('.tooltipContent').appendSVG(svgblock);
		
		
		//styling text
		tooltipArea.selectAll('.tooltipContent text')
			.style('font-family',tooltipProperties.fontFamily)
			.style('fill', tooltipProperties.color)
			.style('font-weight',tooltipProperties.fontWeight)
			.style('font-size',tooltipProperties.fontSize)
			.style('text-anchor',tooltipProperties.textAnchor);
			
		tooltipArea.selectAll('.tooltipContent .lineSeparator')
			.style('stroke-width',0.5)
			.style('stroke','#000000');
	}
	
	tooltipBoxSize = d3DomElementSize(tooltipArea.selectAll('.tooltipContent'));
	
	let width = tooltipBoxSize.width;
	let height = tooltipBoxSize.height;
	
	//background size adjust
 	tooltipArea.selectAll('.tooltipBox rect.bck')
		.attr('width', width + dimensions.margin*2)
		.attr('height', height + dimensions.margin*2)
		//.style('filter',"url(#filterShadow1_" + wpObject.contextualProperties.tagId + ")")
		//.style('fill', tooltipProperties.backgroundColor)
		.style('stroke','transparent')
		.style('stroke-width',0)
		.style('fill', 'transparent')
		.style('opacity', 0);

	tooltipArea.selectAll('.tooltipBox .bck.pointer')
		.style('fill','transparent');

	tooltipArea.selectAll('.tooltipContainer rect.bck')
		;
		
	tooltipArea.selectAll('.tooltipContainer path.bck.pointer')
		.style('display', (tooltipProperties.pointer ? 'inline' : 'none'))
		.attr("transform","translate(" + (width/2  - xDecalage) + "," + (height + dimensions.margin*2) + ")");


	tooltipBoxSize = d3DomElementSize(tooltipArea.selectAll('.tooltipBox'));
	
	let boxWidth = tooltipBoxSize.width;
	let boxHeight = tooltipBoxSize.height;
	
	//adjust tooltip position	
	switch(tooltipProperties.hPosition){
		case 'mouse' :
			if(hTooltipRelPos === 'left'){
				xPos = mousePositionPlot[0] - boxWidth - tooltipProperties.padding;
			} else if(hTooltipRelPos === 'right'){
				xPos = mousePositionPlot[0] + tooltipProperties.padding; 
			} else {
				xPos = mousePositionPlot[0] - boxWidth/2;
			}
			xPos += margin.left;
			break;
		case 'shape' :
			if(hTooltipRelPos === 'left'){
				xPos = d.x - boxWidth - tooltipProperties.padding;
			} else if(hTooltipRelPos === 'right'){
				xPos = d.x + tooltipProperties.padding; 
			} else {
				xPos = d.x - boxWidth/2;
			}
			if(d.width){
				xPos += d.width/2;
			}
			xPos += margin.left;
			break;
		case 'left' :
			xPos = (tooltipProperties.hPadding ? tooltipProperties.hPadding : 0);
			break;
		case 'center' :
			xPos = plotWidth/2 + (tooltipProperties.hPadding ? tooltipProperties.hPadding : 0);
			break;
		case 'centerPlot' :
			xPos = margin.left + plotWidth/2  - boxWidth/2 + (tooltipProperties.hPadding ? tooltipProperties.hPadding : 0);
			break;
	}
	
	switch(tooltipProperties.vPosition){
		case 'mouse' :
			if(vTooltipRelPos === 'down'){
				yPos = mousePositionPlot[1] + tooltipProperties.padding; 
			} else if(vTooltipRelPos === 'up'){
				yPos = mousePositionPlot[1] - boxHeight - tooltipProperties.padding; 
			}
			yPos += margin.top;
			break;
		case 'shape' :
			if(vTooltipRelPos === 'down'){
				yPos = d.y + tooltipProperties.padding; 
			} else if(vTooltipRelPos === 'up'){
				yPos = d.y - boxHeight - tooltipProperties.padding; 
			}
			yPos += margin.top;
			break;
		case 'top' :
		case 'topViz' :
			yPos = (tooltipProperties.vPadding ? tooltipProperties.vPadding : 0);
			break;
		case 'topPlot' :
			yPos = margin.top + (tooltipProperties.vPadding ? tooltipProperties.vPadding : 0);
			break;
		case 'centerViz' :
			yPos = plotHeight/2 - boxHeight/2 + (tooltipProperties.vPadding ? tooltipProperties.vPadding : 0);
			break;
		case 'centerPlot' :
			yPos = margin.top + plotHeight/2 - boxHeight/2 + (tooltipProperties.vPadding ? tooltipProperties.vPadding : 0);
			break;
	}
	
	if((xPos + boxWidth + 20) > wpObject.generalProperties.size.width){
		//xDecalage = - ((wpObject.generalProperties.margin.left + d.x + boxWidth/2 + 40) - wpObject.generalProperties.size.width);
		xDecalage = - ((xPos + boxWidth + 20) - wpObject.generalProperties.size.width);
	} else if(xPos < 0){
		xDecalage = 20 - xPos;
	}

	//padding
	xPos += (tooltipProperties.hPadding ? tooltipProperties.hPadding : 0);
	yPos += (tooltipProperties.vPadding ? tooltipProperties.vPadding : 0);
	
	//tooltipArea.select('.tooltipContainer g.tooltipBlock')
	tooltipArea.select('.tooltipContainer')		
		.style("left",(xPos + xDecalage) + "px")
		.style("top",yPos + "px")
		.style("width",boxWidth + 'px')
		.style("height",boxHeight + 'px');
		
	tooltipArea.selectAll('.tooltipContent .lineSeparator')
		.attr('x2', boxWidth + dimensions.margin);

	tooltipArea.selectAll('.tooltipContainer path.bck.pointer')
		.attr("transform","translate(" + (width/2  - xDecalage) + "," + (height + dimensions.margin*2 - 1) + ")");
	
	let tooltipContour = 'M 0,0 h' + (width + dimensions.margin*2) + ' v' + (height + dimensions.margin*2);
	if(tooltipProperties.pointer){
		let rightspace = ((width + dimensions.margin*2)/2+ xDecalage-9);
		let leftspace = ((width + dimensions.margin*2)/2- xDecalage-9);
		if(rightspace < 0){
			leftspace = width + dimensions.margin*2 - 18;
			rightspace = 0;
		}
		tooltipContour += 'h-' + rightspace + ' l-9 16 l-9 -16 h-' + leftspace +'z';
	} else {
		tooltipContour += 'h-' + (width + dimensions.margin*2) + 'z';
	}
	
	tooltipArea.select('.tooltipBox')
		.append('path')
		.attr('d',tooltipContour)
		.style('filter',"url(#filterShadow1_" + wpObject.contextualProperties.tagId + ")")
		.style('stroke',tooltipProperties.contourColor)
		.style('stroke-width',tooltipProperties.contourWidth)
		.style('fill', tooltipProperties.backgroundColor)
		.style('opacity', tooltipProperties.backgroundOpacity);
	
	//tooltipMsg
	if(tooltipProperties.message){
		if(tooltipProperties.message.automaticHide){
			wpObject.contextualProperties.d3viz.dom.tooltipMsg.style('display', 'none');
		}
		if(!tooltipProperties.message.count){
			tooltipProperties.message.count = 1;
		} else {
			tooltipProperties.message.count += 1;
		}
	}
	
	//debug
	if(wpObject.contextualProperties.debug){
		console.log('shape pos : ' + d.x + ',' + d.y);
		console.log('mouse viz pos : ' + mousePositionViz[0] + ',' + mousePositionViz[1]);
		console.log('mouse plot pos : ' + mousePositionPlot[0] + ',' + mousePositionPlot[1]);
		console.log('tooltip size : ' + boxWidth + ',' + boxHeight);
		console.log('tooltip pos : ' + xPos + ',' + yPos);
		console.log('xDecalage : ' + xDecalage);
	}
	
	wpObject.contextualProperties.d3viz.tooltip.visible = true;
	
	//highlight Shape
	if(tooltipProperties.highlight && tooltipProperties.highlight.active){
		
		let plot = wpObject.contextualProperties.d3viz.dom.plot;
		let plotLink = wpObject.contextualProperties.d3viz.dom.plotLink;
		let selection, selectionLink;
		

		if(tooltipProperties.highlight.noneHighlight.fillColor || tooltipProperties.highlight.noneHighlight.fillMode){
			plot.selectAll('.shape')
				.style("fill", function(d){
					let value = tooltipProperties.highlight.noneHighlight.fillColor;
					if(tooltipProperties.highlight.noneHighlight.fillMode !== null){
						value = adjustColorRule(tooltipProperties.highlight.noneHighlight.fillMode, tooltipProperties.highlight.noneHighlight.fillFactor, d.shapeColor);
					}
					return value;
				});
				
			if(tooltipProperties.highlight.links){
				plotLink.selectAll('.link')
					.style("fill", function(d){
					let value = tooltipProperties.highlight.links.noneHighlight.fillColor;
					if(tooltipProperties.highlight.links.noneHighlight.fillMode !== null){
						value = adjustColorRule(tooltipProperties.highlight.links.noneHighlight.fillMode, tooltipProperties.highlight.links.noneHighlight.fillFactor, d.shapeColor);
					}
					return value;
				});
			}
		}
		
		if(tooltipProperties.highlight.noneHighlight.opacity){
			plot.selectAll('.shape')
				.style('opacity', tooltipProperties.highlight.noneHighlight.opacity);
			
			if(tooltipProperties.highlight.links){
				plotLink.selectAll('.link')
					.style('opacity', tooltipProperties.highlight.links.noneHighlight.opacity);
			}
		}
		
		// TODO : inserer ce bout de code dans toggleHighlightShape
		if(wpObject.generalProperties.chartType === 'dotPlot'){
			selection = plot.selectAll('.shape')
				.filter(function(node) {
					return (node.index === d.index);
				});			
		} else if(wpObject.generalProperties.chartType === 'barchart' || wpObject.generalProperties.chartType === 'linechart'){
			selection = plot.selectAll('.shape')
				.filter(function(node) {
					return (node.serieIndex === d.serieIndex);
				});
				
			selectionLink = plotLink.selectAll('.links')
				.filter(function(link) {
					return (link.source.serieIndex === d.serieIndex || link.target.serieIndex === d.serieIndex);
				});
			//put link on top
			selectionLink.raise();
			
			if(tooltipProperties.highlight.links.opacity){
				selectionLink.selectAll('.link').style("opacity", tooltipProperties.highlight.links.opacity);
			}
			
			if(tooltipProperties.highlight.links.fillColor || tooltipProperties.highlight.links.fillMode){
				selectionLink.selectAll('.link')
					.style("fill", function(d){
						let value = tooltipProperties.highlight.links.fillColor;
						if(tooltipProperties.highlight.links.fillMode !== null){
							value = adjustColorRule(tooltipProperties.highlight.links.fillMode, tooltipProperties.highlight.links.fillFactor, d.shapeColor);
						}
						return value;
					});
			}			
		} else if(wpObject.generalProperties.chartType === 'sunburst' || wpObject.generalProperties.chartType === 'forceSimulation' || wpObject.generalProperties.chartType === 'circlePack'){
			let sequenceArray = d.ancestors().reverse();
			
			selection = plot.selectAll('.shape')
				.filter(function(node) {
					return (sequenceArray.indexOf(node) >= 0);
				});
				
			if(wpObject.generalProperties.chartType === 'forceSimulation'){
				selectionLink = plotLink.selectAll('.links')
					.filter(function(node) {
						return (sequenceArray.indexOf(node.source) >= 0 && sequenceArray.indexOf(node.target) >= 0);
					});
				
				if(tooltipProperties.highlight.links.opacity){
					selectionLink.selectAll('.link').style("opacity", tooltipProperties.highlight.links.opacity);
				}
				if(tooltipProperties.highlight.links.strokeWidth){
					selectionLink.selectAll('.link').style("stroke-width", tooltipProperties.highlight.links.strokeWidth);
				}
			}
		} else if(wpObject.generalProperties.chartType === 'parallel'){
			selection = plot.selectAll('.shape')
				.filter(function(node) {
					return (node.serieIndex === d.serieIndex);
				});
				
			selectionLink = plotLink.selectAll('.links')
				.filter(function(node) {
					return (node.source.serieIndex === d.serieIndex || node.target.serieIndex === d.serieIndex);
				});
			//put link on top
			selectionLink.raise();
			
			if(tooltipProperties.highlight.links.opacity){
				selectionLink.selectAll('.link').style("opacity", tooltipProperties.highlight.links.opacity);
			}
			
			if(tooltipProperties.highlight.links.fillColor || tooltipProperties.highlight.links.fillMode){
				selectionLink.selectAll('.link')
					.style("fill", function(d){
						let value = tooltipProperties.highlight.links.fillColor;
						if(tooltipProperties.highlight.links.fillMode !== null){
							value = adjustColorRule(tooltipProperties.highlight.links.fillMode, tooltipProperties.highlight.links.fillFactor, d.shapeColor);
						}
						return value;
					});
			}
		}
		
		if(tooltipProperties.highlight.opacity){
			selection.style("opacity", tooltipProperties.highlight.opacity);
		}
		
		if(tooltipProperties.highlight.fillColor || tooltipProperties.highlight.fillMode){
			selection.style("fill", function(d){
				let value = tooltipProperties.highlight.fillColor;
				if(tooltipProperties.highlight.fillMode !== null){
					value = adjustColorRule(tooltipProperties.highlight.fillMode, tooltipProperties.highlight.fillFactor, d.shapeColor);
				}
				return value;
			});
		}
		
	}
			
}

function drawUserAction(wpObject){

	let htmlblock,
		tagId = '#' + wpObject.contextualProperties.tagId,
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		xPos, yPos, translateX, translateY;
	
	
	// calculation field selector
	let calculationCnt = wpObject.detailProperties.calculationFields.length;
	if(calculationCnt > 1 && wpObject.detailProperties.multiCalculationFields && wpObject.detailProperties.multiCalculationFields.active && wpObject.detailProperties.multiCalculationFields.mode === 'switch'){
		let mcfProperties = wpObject.detailProperties.multiCalculationFields;
		htmlblock  = "<div class='d3calculationSelector'><span class='d3calculationSelectorBlock'>";
		wpObject.detailProperties.calculationFields.forEach(function(c,i){
			let contextualClass = '';
			if(i === 0){
				contextualClass += ' d3BtnStart';
			}
			if(i === (calculationCnt-1)){
				contextualClass += ' d3BtnEnd';
			}
			if(i === wpObject.detailProperties.currentCalculationFieldsIndex){
				contextualClass += ' d3BtnSelected';
			}
			htmlblock += "	<button class='d3Btn " + contextualClass + "' data-index='" + i + "'>" + wpObject.detailProperties.calculationFieldsLabel[i] + "</button>";	
		});
		htmlblock += "</span></div>";
		
		d3.select(tagId + ' .foregroundHtmlPlot .d3calculationSelector').remove();
		d3.select(tagId + ' .foregroundHtmlPlot').appendHTML(htmlblock);
		
		d3.selectAll(tagId + " .d3calculationSelector button").on('click',function(d){
			//console.log('click calculation selector');
			let calculationFieldsIndex = Number(this.attributes['data-index'].value);
			let currentCalculationFieldsIndex = wpObject.detailProperties.currentCalculationFieldsIndex;
			
			//update title //very specific for the moment  TODO : industrialize
			if(wpObject.detailProperties.title.SVG){
				wpObject.detailProperties.title.SVG = wpObject.detailProperties.title.SVG.replace(wpObject.detailProperties.calculationFieldsLabel[currentCalculationFieldsIndex].toLowerCase(),wpObject.detailProperties.calculationFieldsLabel[calculationFieldsIndex].toLowerCase());
			} else {
				wpObject.detailProperties.title.text = wpObject.detailProperties.title.text.replace(wpObject.detailProperties.calculationFieldsLabel[currentCalculationFieldsIndex].toLowerCase(),wpObject.detailProperties.calculationFieldsLabel[calculationFieldsIndex].toLowerCase());
			}
			
			//update suffix
			if(wpObject.detailProperties.label.suffixFields){
				if(wpObject.detailProperties.label.suffixScheme && wpObject.detailProperties.label.suffixScheme.length > 0){
					wpObject.detailProperties.label.suffixScheme.forEach(function(s, i){
						wpObject.detailProperties.label.suffixScheme[i] = s.replace(wpObject.detailProperties.label.suffixFields[currentCalculationFieldsIndex], wpObject.detailProperties.label.suffixFields[calculationFieldsIndex]);
					});
				}
			}
			//update lineChartLabel
			if(wpObject.detailProperties.XYChart.linechartLabel && wpObject.detailProperties.XYChart.linechartLabel.visible && wpObject.detailProperties.XYChart.linechartLabel.text){
				wpObject.detailProperties.XYChart.linechartLabel.text = wpObject.detailProperties.XYChart.linechartLabel.text.replace(wpObject.detailProperties.calculationFields[currentCalculationFieldsIndex], wpObject.detailProperties.calculationFields[calculationFieldsIndex]);
			}
			//update current calculation column index
			wpObject.detailProperties.currentCalculationFieldsIndex = calculationFieldsIndex;
			
			//redraw
			switch(mcfProperties.action){
				case 'draw' :
					drawWidget(wpObject, mcfProperties.actionState);
					break;
				case 'redraw' :
					redrawWidget(wpObject, mcfProperties.actionState);
					break;
				case 'render' :
					widgetRender(wpObject, mcfProperties.actionState);
					break;
			}
		})
		
		d3.select(tagId + ' .d3calculationSelector')
			.style('position', 'absolute')
			.style('width', '2000px');


		d3.selectAll(tagId + ' .d3calculationSelectorBlock button')
			.style('font-family', mcfProperties.btnFontFamily)
			.style('font-size', mcfProperties.btnFontSize)
			.style('font-weight', mcfProperties.btnFontWeight)
			.style('font-style', mcfProperties.btnFontStyle);				
			
		d3.selectAll(tagId + ' .d3calculationSelectorBlock button')
			.style('width', (mcfProperties.btnWidth ? mcfProperties.btnWidth : 50) + 'px')
			.style('background-color', mcfProperties.backgroundColor)
			.style('color', mcfProperties.labelColor)
			.style('border-color', mcfProperties.selectedBackgroundColor);
			
		d3.selectAll(tagId + ' .d3calculationSelectorBlock button.d3BtnSelected')
			.style('background-color', mcfProperties.selectedBackgroundColor)
			.style('color', mcfProperties.selectedLabelColor);
		
		let size = d3DomElementSize(d3.select(tagId + ' .d3calculationSelector .d3calculationSelectorBlock'), 'html');

		//positionning
		let hPadding = (mcfProperties.hPadding || mcfProperties.hPadding === 0 ? mcfProperties.hPadding : 0);
		let vPadding = (mcfProperties.vPadding || mcfProperties.vPadding === 0 ? mcfProperties.vPadding : 0);

		xPos = hPadding;
		yPos = vPadding;
		let cssXAttr = 'left';
		let cssYAttr = 'top';
		translateX = 0;
		translateY = 0;
		if(mcfProperties.hPosition){
			switch(mcfProperties.hPosition){
				case 'left' :
					xPos = hPadding;
					break;
				case 'right' :
					cssXAttr = 'right';
					xPos = hPadding;
					break;
				default :	//i.e center
					xPos = vizWidth / 2;
					translateX = '-50%';
					break;
			}
		}
		if(mcfProperties.vPosition){
			switch(mcfProperties.vPosition){
				case 'top' :
					yPos = vPadding;
					break;
				case 'bottom' :
					yPos = vizHeight - vPadding;
					break;
				default :	//i.e center
					yPos = vizHeight / 2;
					translateY = '-50%';
					break;
			}
		}		
		d3.select(tagId + ' .d3calculationSelector')
			.style('transform', 'translate(' + translateX + ',' + translateY + ')')
			//.style('position', 'absolute')
			.style('font-size', '0px')	// to avoid space between button
			.style('width', size.width + 'px')
			.style(cssXAttr, xPos + 'px')
			.style(cssYAttr, yPos + 'px');
	}

	//multiDimensionStyle selector
	if(wpObject.detailProperties.multiDimensionStyleSwitch && wpObject.detailProperties.multiDimensionStyleSwitch.active){
		let dimStyleCnt = wpObject.detailProperties.multiDimensionStyleSwitch.styleSelector.length;
		htmlblock  = "<div class='d3DimensionStyleSelector'>";
		htmlblock += "<span class='d3DimensionStyleSelectorBlock'><span class='dimensionStyleTitle'>" + wpObject.detailProperties.multiDimensionStyleSwitch.text + "</span>";
		wpObject.detailProperties.multiDimensionStyleSwitch.styleSelector.forEach(function(c,i){
			let contextualClass = '';
			if(i === 0){
				contextualClass += ' d3BtnStart';
			}
			if(i === (dimStyleCnt-1)){
				contextualClass += ' d3BtnEnd';
			}
			if(c === wpObject.detailProperties.multiDimensionStyle){
				contextualClass += ' d3BtnSelected';
			}
			htmlblock += "	<button class='d3Btn multiDimensionStyleBtn " + contextualClass + "' data-index='" + i + "'>" + wpObject.detailProperties.multiDimensionStyleSwitch.styleSelectorLabel[i] + "</button>";	
		});
		htmlblock += "</span></div>";
		d3.select(tagId + ' .foregroundHtmlPlot .d3DimensionStyleSelector').remove();
		d3.select(tagId + ' .foregroundHtmlPlot').appendHTML(htmlblock);
		
		d3.selectAll(tagId + " .d3DimensionStyleSelector button").on('click',function(d){
			
			let styleSelectorIndex = Number(this.attributes['data-index'].value);
			let oldStyle = wpObject.detailProperties.multiDimensionStyle;
			let newStyle = wpObject.detailProperties.multiDimensionStyleSwitch.styleSelector[styleSelectorIndex];
			
			//update current calculation column index
			wpObject.detailProperties.multiDimensionStyle = newStyle;
			if(newStyle === 'grouped'){
				wpObject.detailProperties.XYChart.barPadding = wpObject.detailProperties.XYChart.barPadding / 2;
			} else if(oldStyle === 'grouped'){
				wpObject.detailProperties.XYChart.barPadding = wpObject.detailProperties.XYChart.barPadding * 2;
			}
			
			if(wpObject.detailProperties.multiDimensionStyleSwitch.callSpecificFn && checkSpecificFunction(wpObject.detailProperties.multiDimensionStyleSwitch.callSpecificFn)){
						   specificFunctionCall(wpObject.detailProperties.multiDimensionStyleSwitch.callSpecificFn, wpObject, newStyle);
			}
			redrawWidget(wpObject,'updateData');
		})
		
		d3.select(tagId + ' .d3DimensionStyleSelector .dimensionStyleTitle')
			.style('font-family', wpObject.detailProperties.multiDimensionStyleSwitch.fontFamily)
			.style('color', wpObject.detailProperties.multiDimensionStyleSwitch.color)
			.style('font-size', wpObject.detailProperties.multiDimensionStyleSwitch.fontSize)
			.style('font-weight', wpObject.detailProperties.multiDimensionStyleSwitch.fontWeight)
			.style('font-style', wpObject.detailProperties.multiDimensionStyleSwitch.fontStyle);

		let size = d3DomElementSize(d3.select(tagId + ' .d3DimensionStyleSelector .d3DimensionStyleSelectorBlock'), 'html');
		xPos = getHorizontalPosition(wpObject, size, wpObject.detailProperties.multiDimensionStyleSwitch);
		yPos = getVerticalPosition(wpObject, size, wpObject.detailProperties.multiDimensionStyleSwitch);
		
		d3.select(tagId + ' .d3DimensionStyleSelector')
			.style('position', 'absolute')
			.style('font-size', '0px');
			
		d3.select(tagId + ' .d3DimensionStyleSelector')
			.style('left', xPos + 'px')
			.style('top', yPos + 'px')
			.style('width', size.width + 'px');
			
	}
	
	//axis zoom
	if(wpObject.detailProperties.XYChart.categoricalAxisZoom && wpObject.detailProperties.XYChart.categoricalAxisZoom.active){
		htmlblock  = "<div class='d3AxisZoomSelector categoricalAxisZoom'>";
		htmlblock += "<span class='categoricalAxisZoomBlock'><span class='categoricalAxisZoomTitle'>" + wpObject.detailProperties.XYChart.categoricalAxisZoom.text + "</span>";
		if(wpObject.detailProperties.XYChart.categoricalAxisZoom.zoomType === 'bucket'){
			calculationCnt = wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketsLabel.length;
													  
											  
																		  
			wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketsLabel.forEach(function(b,i){
				let contextualClass = '';
				if(i === 0){
					contextualClass += ' d3BtnStart';
				}
				if(i === (calculationCnt-1)){
					contextualClass += ' d3BtnEnd';
				}
				if(i === wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketIndexSelected){
					contextualClass += ' d3BtnSelected';
				}
				htmlblock += "	<button class='d3Btn categoricalAxisZoomBtn " + contextualClass + "' data-index='" + i + "'>" + b + "</button>";					
			})
		}
		htmlblock += "</span></div>";
		
		
		d3.select(tagId + ' .foregroundHtmlPlot .d3AxisZoomSelector.categoricalAxisZoom').remove();
		d3.select(tagId + ' .foregroundHtmlPlot').appendHTML(htmlblock);
		
		d3.selectAll(tagId + " .d3AxisZoomSelector.categoricalAxisZoom button").on('click',function(d){
			let bucketIndex = Number(this.attributes['data-index'].value);
			let currentBucketIndex = wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketIndexSelected;
			
			wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketIndexSelected = bucketIndex;
			wpObject.detailProperties.XYChart.categoricalAxisMinMax = wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketsDomain[bucketIndex];
			//redraw
			redrawWidget(wpObject,'updateZoom');
		})
		
		d3.select(tagId + ' .d3AxisZoomSelector.categoricalAxisZoom')
			.style('position', 'absolute')
			.style('width', '2000px');
			//.style('font-size', '0px');	// to avoid space between button
		
		d3.select(tagId + ' .d3AxisZoomSelector.categoricalAxisZoom .categoricalAxisZoomTitle')
			.style('font-family', wpObject.detailProperties.XYChart.categoricalAxisZoom.fontFamily)
			.style('color', wpObject.detailProperties.XYChart.categoricalAxisZoom.color)
			.style('font-size', wpObject.detailProperties.XYChart.categoricalAxisZoom.fontSize)
			.style('font-weight', wpObject.detailProperties.XYChart.categoricalAxisZoom.fontWeight)
			.style('font-style', wpObject.detailProperties.XYChart.categoricalAxisZoom.fontStyle);
			
			
		d3.selectAll(tagId + ' .d3AxisZoomSelector.categoricalAxisZoom button')
			.style('width', '30px')
			.style('background-color', wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketBckColor)
			.style('color', wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketLabelColor);
			
		d3.selectAll(tagId + ' .d3AxisZoomSelector.categoricalAxisZoom button.d3BtnSelected')
			.style('background-color', wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketSelectedBckColor)
			.style('color', wpObject.detailProperties.XYChart.categoricalAxisZoom.buckets.bucketSelectedLabelColor);
		
		let size = d3DomElementSize(d3.select(tagId + ' .d3AxisZoomSelector.categoricalAxisZoom .categoricalAxisZoomBlock'), 'html');
		xPos = getHorizontalPosition(wpObject, size, wpObject.detailProperties.XYChart.categoricalAxisZoom);
		yPos = getVerticalPosition(wpObject, size, wpObject.detailProperties.XYChart.categoricalAxisZoom);
		
		d3.select(tagId + ' .d3AxisZoomSelector.categoricalAxisZoom')
			.style('position', 'absolute')
			.style('font-size', '0px');
			
		d3.select(tagId + ' .d3AxisZoomSelector.categoricalAxisZoom')
			.style('left', xPos + 'px')
			.style('top', yPos + 'px')
			.style('width', size.width + 'px');
	}
	
	// filtre Menu
	if(wpObject.detailProperties.filterSelectors && wpObject.detailProperties.filterSelectors.filterMenu){		
		wpObject.detailProperties.filterSelectors.filterMenu.data.forEach(function(d,i){
			d.index = i;
		})
		
		let categories = _.chain(wpObject.detailProperties.filterSelectors.data).map('category').uniq().value();
		
		htmlblock  = "<div class='d3FilterContainer'>";		
		htmlblock += "	<div class='d3FilterSelector'>";	
		htmlblock += "		<div class='d3FilterMenuBtn'><i class='filterIcon fas fa-filter'></i></div>";
		htmlblock += "	</div>";
		htmlblock += "	<div class='d3FilterMenuContainer'>";
		htmlblock += "		<div class='d3FilterMenu'>";
		htmlblock += "			<div class='d3FilterTitle'><span>Filtres</span></div>";
		categories.forEach(function(c, i){
			let values = _.filter(wpObject.detailProperties.filterSelectors.filterMenu.data, function(o){ return o.category === c;});
			htmlblock += "<ul class='filterCategory'><li>" + c + "</li>";
			htmlblock += "<ul class='filterCategoryDetails'>";
			values.forEach(function(v, j){
				htmlblock += "<li><span class='filterSelectionIcon'><i class='fas fa-check'></i></span><span>" + v.value + "</span></li>";
			})
			htmlblock += "</ul></ul>";
		});
		htmlblock += "	<div class='filterSelectionUnselection'><i class='filterIcon fas fa-check-square'></i><span> tout désélectionner</span></div>";
		htmlblock += "		</div>";
		htmlblock += "	</div>";
		htmlblock += "</div>";
		
		d3.select(tagId + ' .d3FilterSelector').remove();
		d3.select(tagId).appendHTML(htmlblock);
		
		d3.selectAll(tagId + ' .d3FilterContainer .d3FilterMenuBtn').on('click', function(){
			let elem = d3.select(tagId + ' .d3FilterContainer .d3FilterMenu');
			if(elem.classed('visible')){				
				elem.classed('visible', false);
				console.log('refresh dataset');
				//wpObject.contextualProperties.dataIn = dataset_AltUS332;
				widgetRender(wpObject,'updateData');
			} else {
				elem.classed('visible', true);
			}			
		})
		
		d3.selectAll(tagId + ' .d3FilterContainer .filterCategoryDetails li').on('click', function(){
			let elem = d3.select(this);
			if(elem.select('.filterSelectionIcon').classed('selected')){
				elem.select('.filterSelectionIcon').classed('selected', false);
				elem.classed('selected', false);
			} else {
				elem.select('.filterSelectionIcon').classed('selected', true);
				elem.classed('selected', true);
			}
		});
		
		d3.selectAll(tagId + ' .d3FilterContainer .filterSelectionUnselection').on('click', function(){
			let elem = d3.select(tagId + ' .d3FilterContainer .d3FilterMenu');
			elem.classed('visible', false);
			//wpObject.contextualProperties.dataIn = dataset_US332;	
			widgetRender(wpObject,'updateData');
		})
	}

	// filtre selector
	if(wpObject.detailProperties.filterSelectors && wpObject.detailProperties.filterSelectors.filters){
		d3.select(tagId + ' .foregroundHtmlPlot .d3filterSelectorUI').remove();
		wpObject.detailProperties.filterSelectors.filters.forEach(function(f,i){
			if(f.active){
				let filterOpacity = 1;
				if(wpObject.contextualProperties.state === 'animation' && f.visibleInAnimation === false){
					filterOpacity = 0;
				}
				htmlblock  = "<div class='d3filterSelectorUI' style='opacity:" + filterOpacity + "'>";
				htmlblock += "<span class='filterSelectorUIBlock'><span class='filterSelectorUITitle'>" + f.text + "</span>";
				if(f.UI === 'toggleButton'){
					calculationCnt = f.values.length;
																				  
					f.values.forEach(function(v,i){
						let contextualClass = '';
						if(i === 0){
							contextualClass += ' d3BtnStart';
						}
						if(i === (calculationCnt-1)){
							contextualClass += ' d3BtnEnd';
						}
						if(v === f.selectedValue){
							contextualClass += ' d3BtnSelected';
						}
						htmlblock += "	<button class='d3Btn filterSelectorUIBtn " + contextualClass + "' data-index='" + i + "'>" + v + "</button>";					
					})
				}
				htmlblock += "</span></div>";
							
				d3.select(tagId + ' .foregroundHtmlPlot').appendHTML(htmlblock);

				d3.selectAll(tagId + " .d3filterSelectorUI button").on('click',function(d){
					let index = Number(this.attributes['data-index'].value);
					wpObject.detailProperties.dataFiltering.restrictionColumn[0] = f.field;
					wpObject.detailProperties.dataFiltering.restrictionColumnToValue[0] = f.values[index];
					f.selectedValue = f.values[index];
					
					//redraw
					switch(f.action){
						case 'draw' :
							drawWidget(wpObject, f.actionState);
							break;
						case 'redraw' :
							redrawWidget(wpObject, f.actionState);
							break;
						case 'render' :
							widgetRender(wpObject, f.actionState);
							break;
					}
				})
				
				d3.select(tagId + ' .d3filterSelectorUI')
					.style('position', 'absolute')
					.style('width', '2000px');
					//.style('font-size', '0px');	// to avoid space between button
				
				d3.select(tagId + ' .d3filterSelectorUI .filterSelectorUITitle')
					.style('font-family', f.fontFamily)
					.style('color', f.color)
					.style('font-size', f.fontSize)
					.style('font-weight', f.fontWeight)
					.style('font-style', f.fontStyle);

				d3.selectAll(tagId + ' .d3filterSelectorUI button')
					.style('font-family', f.btnFontFamily)
					.style('font-size', f.btnFontSize)
					.style('font-weight', f.btnFontWeight)
					.style('font-style', f.btnFontStyle);				
					
				d3.selectAll(tagId + ' .d3filterSelectorUI button')
					.style('width', (f.btnWidth ? f.btnWidth : 50) + 'px')
					.style('background-color', f.backgroundColor)
					.style('color', f.labelColor);
					
				d3.selectAll(tagId + ' .d3filterSelectorUI button.d3BtnSelected')
					.style('background-color', f.selectedBackgroundColor)
					.style('color', f.selectedLabelColor);
				
				let size = d3DomElementSize(d3.select(tagId + ' .d3filterSelectorUI .filterSelectorUIBlock'), 'html');
				xPos = getHorizontalPosition(wpObject, size, f);
				yPos = getVerticalPosition(wpObject, size, f);
				
				d3.select(tagId + ' .d3filterSelectorUI')
					.style('font-size', '0px');
					
				d3.select(tagId + ' .d3filterSelectorUI')
					.style('left', xPos + 'px')
					.style('top', yPos + 'px')
					.style('width', (size.width + 20) + 'px');
			}
		})
	}

}


//////////////////////////////
// scales definition
/////////////////////////////

function setAxisScales(wpObject, action){

	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		panelWidth = plotWidth - padding.left - padding.right,
		panelHeight = plotHeight - padding.top - padding.bottom,
		data = wpObject.contextualProperties.dataOut,
		multiDimensionStyle, x, y, x2, y2,
		categoricalScaleType;
		

	if(wpObject.detailProperties.dimensionFields && wpObject.detailProperties.dimensionFields.length === 2 && wpObject.detailProperties.multiDimensionStyle){
		multiDimensionStyle = wpObject.detailProperties.multiDimensionStyle;
	}
	
	switch(wpObject.generalProperties.chartType){
		case 'barchart' :
			categoricalScaleType = 'scaleBand';
			break;
		case 'linechart' :
			if(wpObject.detailProperties.dimensionFieldsDatatype[0] !== 'numeric' && wpObject.detailProperties.dimensionFieldsDatatype[0] !== 'number'){
				categoricalScaleType = 'scalePoint';
			} else {
				categoricalScaleType = 'scaleLinear';
			}
			break;
		case 'sunburst' :
			categoricalScaleType = 'scaleLinear';
			break;
		case 'dotPlot' :			
			break;
		case 'spider' :
			let calculateDomain;
			let dimensionField = wpObject.detailProperties.dimensionFields[0];
			let calculationField = wpObject.detailProperties.calculationFields[0];
			
			wpObject.contextualProperties.d3viz.axis.dimension.domain = [];
			wpObject.contextualProperties.d3viz.axis.measure.domain = [];
			
			//dimension axis
			let dataScope = _.chain(data).map(dimensionField).uniq().value();
			dataScope = _.orderBy(dataScope, function(o){return o;}, [wpObject.detailProperties.dimensionFieldsSortOrder[0]]);
			wpObject.contextualProperties.d3viz.axis.dimension.domain = dataScope;
			
			//measure axis
			if(wpObject.detailProperties.spider.linearAxisMinMaxExtendFactor && wpObject.detailProperties.spider.linearAxisMinMaxExtendFactor.length === 2){
				let minExtendFactor = wpObject.detailProperties.spider.linearAxisMinMaxExtendFactor[0];
				let maxExtendFactor = wpObject.detailProperties.spider.linearAxisMinMaxExtendFactor[1];
			}
			
			if(wpObject.detailProperties.spider.linearAxisMinMax){
				calculateDomain = wpObject.detailProperties.spider.linearAxisMinMax;
			} else {
				calculateDomain =  d3.extent(data, function(d){
					return d[calculationField];
				});
				//check if includeOrigin
				if(wpObject.detailProperties.spider.includeOrigin){
					calculateDomain[0] = d3.min([0,calculateDomain[0]]);
				}
			}
			wpObject.contextualProperties.d3viz.axis.measure.domain = calculateDomain;		
			return true;
			break;
	}
	
	wpObject.contextualProperties.d3viz.axis.dimension.categoricalScaleType = categoricalScaleType;
	
	wpObject.contextualProperties.d3viz.axis.dimension.domain = [];
	if(action === 'updateData' && wpObject.detailProperties.XYChart.linearAxisMinMaxOnDataset){
	} else {
		wpObject.contextualProperties.d3viz.axis.measure.domain = [];
	}
	
	//sub function to set axis domain
	function linearScale(axis, measureIdx){
		
		let minExtendFactor = 1, maxExtendFactor = 1, calculateDomain = [], calcColumn;
			
		if(measureIdx === null || measureIdx === undefined || measureIdx < 0 || !wpObject.detailProperties.calculationFields[measureIdx]){
			measureIdx = wpObject.detailProperties.currentCalculationFieldsIndex;
		}
		calcColumn = wpObject.detailProperties.calculationFields[measureIdx];
		
		if(wpObject.detailProperties.XYChart.linearAxisMinMaxExtendFactor && wpObject.detailProperties.XYChart.linearAxisMinMaxExtendFactor.length === 2){
			minExtendFactor = wpObject.detailProperties.XYChart.linearAxisMinMaxExtendFactor[0];
			maxExtendFactor = wpObject.detailProperties.XYChart.linearAxisMinMaxExtendFactor[1];
		}
		
		if(wpObject.detailProperties.multiDimensionStyle && wpObject.detailProperties.multiDimensionStyle === 'stacked'){
			calcColumn = '__stackValue__';
		} else if(wpObject.detailProperties.multiCalculationFields && wpObject.detailProperties.multiCalculationFields.active && wpObject.detailProperties.multiCalculationFields.mode === 'range'){
			calcColumn = [wpObject.detailProperties.calculationFields[0], wpObject.detailProperties.calculationFields[1]];
		}
		
		if(wpObject.detailProperties.XYChart.linearAxisMinMax){
			calculateDomain = wpObject.detailProperties.XYChart.linearAxisMinMax;
		} else {
			if(wpObject.detailProperties.multiCalculationFields && wpObject.detailProperties.multiCalculationFields.active && wpObject.detailProperties.multiCalculationFields.mode === 'range'){
				let calculateDomainStart =  d3.extent(data, function(d){
					return d[calcColumn[0]];
				});
				let calculateDomainEnd =  d3.extent(data, function(d){
					return d[calcColumn[1]];
				});
				calculateDomain[0] = d3.min([calculateDomainStart[0],calculateDomainEnd[0]]);
				calculateDomain[1] = d3.max([calculateDomainStart[1],calculateDomainEnd[1]]);
			} else {
				calculateDomain =  d3.extent(data, function(d){
					return d[calcColumn];
				});
			}

			//check if includeOrigin
			if(wpObject.detailProperties.XYChart.includeOrigin){
				if(typeof wpObject.detailProperties.XYChart.includeOrigin === 'object'){
					if(wpObject.detailProperties.XYChart.includeOrigin[measureIdx]){
						calculateDomain[0] = d3.min([0,calculateDomain[0]]);
					}
				} else {
					calculateDomain[0] = d3.min([0,calculateDomain[0]]);
				}
			}
			
			//check if referenceLines include in Scale
			if(wpObject.detailProperties.XYChart.referenceLines){
				wpObject.detailProperties.XYChart.referenceLines.forEach(function(refLine){
					if(refLine.axis === 'linear' && refLine.includeInScale){
						if(refLine.type === 'line'){
							calculateDomain[0] = d3.min([refLine.values[0],calculateDomain[0]]);
							calculateDomain[1] = d3.max([refLine.values[0],calculateDomain[1]]);
						}
					}
				})
			}
			
		}		
		
		calculateDomain[0] -= (calculateDomain[1] - calculateDomain[0]) * (1 - minExtendFactor);
		calculateDomain[1] += (calculateDomain[1] - calculateDomain[0]) * (maxExtendFactor - 1);

		if(wpObject.detailProperties.XYChart.linearAxisMinMaxAdjust && !wpObject.detailProperties.XYChart.linearAxisMinMaxExtendFactor){
			let tickValues, tickStep = 0;
			tickValues = d3.ticks(calculateDomain[0], calculateDomain[1], (wpObject.detailProperties.XYChart.linearAxisTicksNumber ? wpObject.detailProperties.XYChart.linearAxisTicksNumber : (wpObject.detailProperties.XYChart.linearAxisTicksNumber[measureIdx] ? wpObject.detailProperties.XYChart.linearAxisTicksNumber[measureIdx] : null)));
			if(tickValues.length > 1){
				tickStep = tickValues[1] - tickValues[0];
				if(tickValues[0] > calculateDomain[0]){
					calculateDomain[0] = tickValues[0] - tickStep;
				}
				if(tickValues[tickValues.length - 1] < calculateDomain[1]){
					calculateDomain[1] = tickValues[tickValues.length - 1] + tickStep;
				}
			}
		}
		
		if(wpObject.detailProperties.XYChart.linearAxisReverse){
			let tmp = calculateDomain[0];
			calculateDomain[0] = calculateDomain[1];
			calculateDomain[1] = tmp;
		}
		axis.domain(calculateDomain);
		wpObject.contextualProperties.d3viz.axis.measure.domain.push(axis.domain());
	};
	
	function categoricalScale(axis, dimensionIdx){
		
		let dataScope, dimSort, unixDates, categoricalScaleType,
			field = wpObject.detailProperties.dimensionFields[dimensionIdx];
		
		
		switch(wpObject.generalProperties.chartType){
			case 'barchart' :
				categoricalScaleType = 'scaleBand';
				break;
			case 'linechart' :
				if(wpObject.detailProperties.dimensionFieldsDatatype[dimensionIdx] !== 'numeric'){
					categoricalScaleType = 'scalePoint';
				} else {
					categoricalScaleType = 'scaleLinear';
				}
				break;
		}
	
		if(categoricalScaleType === 'scaleLinear'){
			if(wpObject.detailProperties.XYChart.categoricalAxisMinMax){
				dataScope = wpObject.detailProperties.XYChart.categoricalAxisMinMax;
			} else {
				dataScope =  d3.extent(data, function(d){
					return d[wpObject.detailProperties.dimensionFields[dimensionIdx]];
				});
			}
			if(wpObject.detailProperties.dimensionFieldsSortOrder && wpObject.detailProperties.dimensionFieldsSortOrder[dimensionIdx] === 'desc'){
				dataScope = [dataScope[1],dataScope[0]];
			}
			let scope = _.chain(data).map(wpObject.detailProperties.dimensionFields[dimensionIdx]).uniq().value();
			//TODO gestion du cas ou il y a un sortOrder 'desc' et/ou un categoricalAxisMinMax
			/* scope = scope.filter(function(d){
				
				
			}); */
			axis.step = function(){return (axis.range()[1] - axis.range()[0]) / scope.length};
		} else if(wpObject.detailProperties.dimensionFieldsCustomSort && wpObject.detailProperties.dimensionFieldsCustomSort[dimensionIdx]){
			dataScope = wpObject.detailProperties.dimensionFieldsCustomSort[dimensionIdx];
		} else if(wpObject.detailProperties.dimensionFieldsSortOrder && (wpObject.detailProperties.dimensionFieldsSortOrder[dimensionIdx] === 'asc' || wpObject.detailProperties.dimensionFieldsSortOrder[dimensionIdx] === 'desc')){			
			if(wpObject.detailProperties.dimensionFieldsDatatype[dimensionIdx] === 'date'){
				let dateParse = d3.timeParse(wpObject.detailProperties.dimensionFieldsFormat[0]);
				let dateFormat = d3.timeFormat('%s');	//unix EPOCH format
				
				dataScope = _.chain(data).map(function(d){ 
								return dateFormat(dateParse(d[field]));
								}).uniq().value();
			} else {
				dataScope = _.chain(data).map(field).uniq().value();
			}
			
			dataScope = _.orderBy(dataScope, function(o){return o;}, [wpObject.detailProperties.dimensionFieldsSortOrder[dimensionIdx]]);
			
			if(wpObject.detailProperties.dimensionFieldsDatatype[dimensionIdx] === 'date'){
				let dateParse = d3.timeParse('%s');
				let dateFormat = d3.timeFormat(wpObject.detailProperties.dimensionFieldsFormat[0]);
				dataScope = _.map(dataScope, function(d){ 
									return dateFormat(dateParse(d));
								});
			}
		} else {
			dataScope = _.chain(data).map(field).uniq().value();
		}
		
		axis.domain(dataScope);
		wpObject.contextualProperties.d3viz.axis.dimension.domain.push(dataScope);
	};
	
	
	if(wpObject.generalProperties.chartType === 'sunburst'){
		let pieRadius = Math.min(plotWidth, plotHeight)/2 - wpObject.detailProperties.sunburst.sunburstPadding;
		
		wpObject.contextualProperties.d3viz.sunburst.maxRadius = pieRadius;
		
		x = d3.scaleLinear()
            .range([0, 2 * Math.PI])
            .clamp(true);

        y = d3.scaleLinear()
            .range([pieRadius*wpObject.detailProperties.sunburst.centerFactor, pieRadius]);
	} else if(wpObject.generalProperties.chartType === 'dotPlot'){
		x = d3.scaleLinear().range([0, plotWidth]);
		y = d3.scaleLinear().range([plotHeight, 0]);
		
		linearScale(x, 0);
		linearScale(y, 1);
		
		//size
		if(typeof wpObject.detailProperties.XYChart.nodeSize === 'object' && wpObject.detailProperties.XYChart.nodeSize.length === 2){
			let s = wpObject.contextualProperties.d3viz.dotPlot.sizeAxis = d3.scaleLinear().range(wpObject.detailProperties.XYChart.nodeSize);
			let calcColumn = wpObject.detailProperties.sizeFields[0];
			let minExtendFactor = 1, maxExtendFactor = 1, calculateDomain = [];
			
			if(wpObject.detailProperties.XYChart.sizeAxisMinMaxExtendFactor && wpObject.detailProperties.XYChart.sizeAxisMinMaxExtendFactor.length === 2){
				minExtendFactor = wpObject.detailProperties.XYChart.sizeAxisMinMaxExtendFactor[0];
				maxExtendFactor = wpObject.detailProperties.XYChart.sizeAxisMinMaxExtendFactor[1];
			}
			if(wpObject.detailProperties.XYChart.sizeAxisMinMax){
				calculateDomain = wpObject.detailProperties.XYChart.sizeAxisMinMax;
			} else if(calcColumn){
				calculateDomain =  d3.extent(data, function(d){
					return d[calcColumn];
				});
			} else {
				calculateDomain[0] = 99999999999999999;
				calculateDomain[1] = 99999999999999999;
			}
			
			calculateDomain[0] -= (calculateDomain[1] - calculateDomain[0]) * (1 - minExtendFactor);
			calculateDomain[1] += (calculateDomain[1] - calculateDomain[0]) * (maxExtendFactor - 1);
			
			if(wpObject.detailProperties.XYChart.linearAxisReverse){
				let tmp = calculateDomain[0];
				calculateDomain[0] = calculateDomain[1];
				calculateDomain[1] = tmp;
			}
			s.domain(calculateDomain);
		}
	} else if(wpObject.generalProperties.orientation === 'horizontal'){
		wpObject.contextualProperties.d3viz.axis.dimension.axis = 'x';
		wpObject.contextualProperties.d3viz.axis.measure.axis = 'y';
		//set range
		x = d3[categoricalScaleType]();
		
		if(wpObject.generalProperties.chartType === 'barchart'){
			x.rangeRound([0, plotWidth])
			.paddingInner(wpObject.detailProperties.XYChart.barPadding)
			.paddingOuter((wpObject.detailProperties.XYChart.barPaddingOuter || wpObject.detailProperties.XYChart.barPaddingOuter === 0 ? wpObject.detailProperties.XYChart.barPaddingOuter : wpObject.detailProperties.XYChart.barPadding));
		} else if(wpObject.generalProperties.chartType === 'linechart'){
			x.range([0, plotWidth]);
		}
		
		if(wpObject.detailProperties.XYChart.categoricalAxisReverse){
			x.range(_.reverse(x.range()));
		}		
		
		//set domain
		categoricalScale(x, 0);
		if(action === 'updateData' && wpObject.detailProperties.XYChart.linearAxisMinMaxOnDataset){
			y = wpObject.contextualProperties.d3viz.axis.y;
		} else {
			y = d3.scaleLinear().range([plotHeight, 0]);
			linearScale(y);
		}
		
		if(wpObject.generalProperties.chartType === 'barchart'){
			wpObject.contextualProperties.d3viz.barchart.bandwidth = x.bandwidth();
			wpObject.contextualProperties.d3viz.barchart.step = x.step();
		} else if(wpObject.generalProperties.chartType === 'linechart'){
			wpObject.contextualProperties.d3viz.linechart.step = x.step();
		}
		
		switch(multiDimensionStyle){
			case 'grouped' :
				x2 = d3[categoricalScaleType]();
				if(wpObject.generalProperties.chartType === 'barchart'){
					x2.rangeRound([0, x.bandwidth()])
						.padding(wpObject.detailProperties.XYChart.barGroupPadding);
				} else if(wpObject.generalProperties.chartType === 'linechart'){
					
				}
				categoricalScale(x2, 1);
				wpObject.contextualProperties.d3viz.axis.x2 = x2;
				if(wpObject.generalProperties.chartType === 'barchart'){
					wpObject.contextualProperties.d3viz.barchart.bandwidth = x2.bandwidth();
					wpObject.contextualProperties.d3viz.barchart.step = x2.step();
				}
				break;
			case 'bullet' :
				x2 = d3[categoricalScaleType]();
				categoricalScale(x2, 1);
				wpObject.contextualProperties.d3viz.axis.x2 = null;
				break;
			case 'overlay' :
				x2 = d3[categoricalScaleType]();
				categoricalScale(x2, 1);
				wpObject.contextualProperties.d3viz.axis.x2 = null;
				break;
			case 'stacked' :
				x2 = d3[categoricalScaleType]();
				categoricalScale(x2, 1);
				wpObject.contextualProperties.d3viz.axis.x2 = null;
				break;
			case 'split' :
				x2 = d3[categoricalScaleType]();
				categoricalScale(x2, 1);
				y.range([plotHeight, plotHeight - plotHeight/(x2.domain().length + 1)]);
				wpObject.contextualProperties.d3viz.axis.x2 = null;
				break;
		}
	} else {
		wpObject.contextualProperties.d3viz.axis.dimension.axis = 'y';
		wpObject.contextualProperties.d3viz.axis.measure.axis = 'x';		
		//set range		
		y = d3[categoricalScaleType]();
		
		if(wpObject.generalProperties.chartType === 'barchart'){
			y.rangeRound([0, plotHeight])
			.paddingInner(wpObject.detailProperties.XYChart.barPadding)
			.paddingOuter((wpObject.detailProperties.XYChart.barPaddingOuter || wpObject.detailProperties.XYChart.barPaddingOuter === 0 ? wpObject.detailProperties.XYChart.barPaddingOuter : wpObject.detailProperties.XYChart.barPadding));			
		} else if(wpObject.generalProperties.chartType === 'linechart'){
			y.range([0, plotHeight]);
		}
		
		if(wpObject.detailProperties.XYChart.categoricalAxisReverse){
			y.range(_.reverse(y.range()));
		}
		
		//setdomain
		if(action === 'updateData' && wpObject.detailProperties.XYChart.linearAxisMinMaxOnDataset){
			x = wpObject.contextualProperties.d3viz.axis.x;
		} else {
			x = d3.scaleLinear().range([0, plotWidth]);
			linearScale(x);
		}
		categoricalScale(y, 0);
		
		if(wpObject.generalProperties.chartType === 'barchart'){
			wpObject.contextualProperties.d3viz.barchart.bandwidth = y.bandwidth();
			wpObject.contextualProperties.d3viz.barchart.step = y.step();
		} else if(wpObject.generalProperties.chartType === 'linechart'){
			wpObject.contextualProperties.d3viz.linechart.step = y.step();
		}
		
		switch(multiDimensionStyle){
			case 'grouped' :
				y2 = d3[categoricalScaleType]();
				if(wpObject.generalProperties.chartType === 'barchart'){
					y2.rangeRound([0, y.bandwidth()])
						.padding(wpObject.detailProperties.XYChart.barGroupPadding);
				} else if(wpObject.generalProperties.chartType === 'linechart'){
					
				}
				categoricalScale(y2,1);
				wpObject.contextualProperties.d3viz.axis.y2 = y2;
				if(wpObject.generalProperties.chartType === 'barchart'){
					wpObject.contextualProperties.d3viz.barchart.bandwidth = y2.bandwidth();
					wpObject.contextualProperties.d3viz.barchart.step = y2.step();
				}
				break;
			case 'bullet' :
				y2 = d3[categoricalScaleType]();
				categoricalScale(y2, 1);
				wpObject.contextualProperties.d3viz.axis.y2 = null;
				break;
			case 'overlay' :
				y2 = d3[categoricalScaleType]();
				categoricalScale(y2, 1);
				wpObject.contextualProperties.d3viz.axis.y2 = null;
				break;
			case 'stacked' :
				y2 = d3[categoricalScaleType]();
				categoricalScale(y2, 1);
				wpObject.contextualProperties.d3viz.axis.y2 = null;
				break;
			case 'split' :
				y2 = d3[categoricalScaleType]();
				categoricalScale(y2, 1);
				x.range([0, plotWidth/(y2.domain().length + 1)]);
				wpObject.contextualProperties.d3viz.axis.y2 = null;
				break;
			case 'diverging' :
				y2 = d3[categoricalScaleType]();
				categoricalScale(y2, 1);
				x.range([plotWidth/2, plotWidth]);
				break;
		}
	}	
	
	wpObject.contextualProperties.d3viz.axis.x = x;
	wpObject.contextualProperties.d3viz.axis.y = y;
	
	return true;
	
}

function setColorScales(wpObject, data){
	
	wpObject.contextualProperties.d3viz.axis.color = wpObject.detailProperties.colorScheme;
	wpObject.contextualProperties.d3viz.axis.colorGradient = wpObject.detailProperties.colorGradientScheme;

	let svgDefs = wpObject.contextualProperties.d3viz.dom.svgDefs;
	
	if(wpObject.contextualProperties.d3viz.axis.colorGradient){
		wpObject.contextualProperties.d3viz.axis.colorGradient.forEach(function(g,i){
			//url
			g.url = 'shapeLinearGradient_' + wpObject.contextualProperties.tagId + '_' + i;
			//linear gradient
			let gradient = svgDefs.append("linearGradient")
				.attr("id", g.url)
				.attr("x1", "0%")
				.attr("y1", "0%")
				.attr("x2", (g.orientation === 'horizontal' ? "100%" : "0%"))
				.attr("y2", (g.orientation === 'vertical' ? "100%" : "0%"))
				.attr("spreadMethod", "pad");
		 
			gradient.append("stop")
				.attr("offset", "10%")
				.attr("stop-color", g.colors[0])
				.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[0] ? g.colorsOpacity[0] : 1));
		 
			gradient.append("stop")
				.attr("offset", "90%")
				.attr("stop-color", g.colors[1])
				.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[1] ? g.colorsOpacity[1] : 1));	
		
		})
	}
	
	if(wpObject.detailProperties.XYChart.areaColorGradientScheme){
		wpObject.contextualProperties.d3viz.axis.areaColorGradient = wpObject.detailProperties.XYChart.areaColorGradientScheme;
		
		wpObject.contextualProperties.d3viz.axis.areaColorGradient.forEach(function(g,i){
			//url
			g.url = 'areaLinearGradient_' + wpObject.contextualProperties.tagId + '_' + i;
			//linear gradient
			let gradient = svgDefs.append("linearGradient")
				.attr("id", g.url)
				.attr("x1", "0%")
				.attr("y1", "0%")
				.attr("x2", (g.orientation === 'horizontal' ? "100%" : "0%"))
				.attr("y2", (g.orientation === 'vertical' ? "100%" : "0%"))
				.attr("spreadMethod", "pad");
		 
			gradient.append("stop")
				.attr("offset", "10%")
				.attr("stop-color", g.colors[0])
				.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[0] ? g.colorsOpacity[0] : 1));
		 
			gradient.append("stop")
				.attr("offset", "90%")
				.attr("stop-color", g.colors[1])
				.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[1] ? g.colorsOpacity[1] : 1));
		
		})
	} else if(wpObject.detailProperties.XYChart.areaDefaultGradient){
		wpObject.contextualProperties.d3viz.axis.colorGradient  = [];
		let g = wpObject.contextualProperties.d3viz.axis.colorGradient[0] = wpObject.detailProperties.XYChart.areaDefaultGradient;

		//url
		//modif à cause de react, mais il y a surement un bug qlq part ici
		g.url = 'areaLinearGradient_' + wpObject.contextualProperties.tagId + '_0';
		//g.url = 'areaLinearGradient_' + wpObject.contextualProperties.tagId + '_' + i;
		//linear gradient
		let gradient = svgDefs.append("linearGradient")
			.attr("id", g.url)
			.attr("x1", "0%")
			.attr("y1", "0%")
			.attr("x2", (g.orientation === 'horizontal' ? "100%" : "0%"))
			.attr("y2", (g.orientation === 'vertical' ? "100%" : "0%"))
			.attr("spreadMethod", "pad");
	 
		gradient.append("stop")
			.attr("offset", "10%")
			.attr("stop-color", g.colors[0])
			.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[0] ? g.colorsOpacity[0] : 1));
	 
		gradient.append("stop")
			.attr("offset", "90%")
			.attr("stop-color", g.colors[1])
			.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[1] ? g.colorsOpacity[1] : 1));
	}

	if(wpObject.detailProperties.highlightArea.colorGradientScheme){
		wpObject.contextualProperties.d3viz.highlightArea.colorGradient = wpObject.detailProperties.highlightArea.colorGradientScheme;
		
		wpObject.contextualProperties.d3viz.highlightArea.colorGradient.forEach(function(g,i){
			//url
			g.url = 'highlightAreaLinearGradient_' + wpObject.contextualProperties.tagId + '_' + i;
			//linear gradient
			let gradient = svgDefs.append("linearGradient")
				.attr("id", g.url)
				.attr("x1", "0%")
				.attr("y1", "0%")
				.attr("x2", (g.orientation === 'horizontal' ? "100%" : "0%"))
				.attr("y2", (g.orientation === 'vertical' ? "100%" : "0%"))
				.attr("spreadMethod", "pad");
		 
			gradient.append("stop")
				.attr("offset", "10%")
				.attr("stop-color", g.colors[0])
				.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[0] ? g.colorsOpacity[0] : 1));
		 
			gradient.append("stop")
				.attr("offset", "90%")
				.attr("stop-color", g.colors[1])
				.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[1] ? g.colorsOpacity[1] : 1));
		
		})
	} else if(wpObject.detailProperties.highlightArea.defaultGradient){
		wpObject.contextualProperties.d3viz.highlightArea.colorGradient  = [];
		let g = wpObject.contextualProperties.d3viz.highlightArea.colorGradient[0] = wpObject.detailProperties.highlightArea.defaultGradient;
		//url
		g.url = 'highlightAreaLinearGradient_' + wpObject.contextualProperties.tagId + '_0';
		//linear gradient
		let gradient = svgDefs.append("linearGradient")
			.attr("id", g.url)
			.attr("x1", "0%")
			.attr("y1", "0%")
			.attr("x2", (g.orientation === 'horizontal' ? "100%" : "0%"))
			.attr("y2", (g.orientation === 'vertical' ? "100%" : "0%"))
			.attr("spreadMethod", "pad");
	 
		gradient.append("stop")
			.attr("offset", "10%")
			.attr("stop-color", g.colors[0])
			.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[0] ? g.colorsOpacity[0] : 1));
	 
		gradient.append("stop")
			.attr("offset", "90%")
			.attr("stop-color", g.colors[1])
			.attr("stop-opacity", (g.colorsOpacity && g.colorsOpacity[1] ? g.colorsOpacity[1] : 1));
	}
	
	
	//new color scheme
	if(wpObject.detailProperties.styles && wpObject.detailProperties.styles.colors){
		let styleColors = wpObject.detailProperties.styles.colors;
		let colorDimensionDomain;
		wpObject.contextualProperties.d3viz.styles.colors = styleColors;
		if(styleColors.dimensionField && styleColors.dimensionField.length > 0){
			wpObject.contextualProperties.d3viz.styles.colors.scale = d3[styleColors.scaleType]();
			if(styleColors.dimensionScaleMode[0] === 'categorical'){
				if(styleColors.dimensionFieldCustomOrder){
					colorDimensionDomain = styleColors.dimensionFieldCustomOrder;
				} else {
					colorDimensionDomain = _.chain(data).map(styleColors.dimensionField[0]).uniq().value();
					colorDimensionDomain = _.orderBy(colorDimensionDomain,styleColors.dimensionFieldSortOrder);
				}
			} else if(styleColors.dimensionScaleMode[0] === 'continous'){
				colorDimensionDomain = d3.extent(data, function(d){	return d[styleColors.dimensionField[0]];});
				if(colorDimensionDomain,styleColors.dimensionFieldSortOrder[0] === 'desc'){
					let minVal = colorDimensionDomain[0];
					colorDimensionDomain[0] = colorDimensionDomain[1];
					colorDimensionDomain[1] = minVal;
				}
			}
			if(styleColors.schemeType === 'colorArray'){
				wpObject.contextualProperties.d3viz.styles.colors.scale
					.range(styleColors.scheme)
					.domain(colorDimensionDomain);
			}
		}
	}
	
	return true;
}


function setTextureScales(wpObject){
//mis en commentaire à cause de react	
/* 	wpObject.contextualProperties.d3viz.axis.texture = [];
	
	if(wpObject.detailProperties.textureScheme && wpObject.detailProperties.textureScheme.length > 0){
		wpObject.detailProperties.textureScheme.forEach(function(t,i){
			if(typeof t === 'string' && textures && textures[t]){				
				wpObject.contextualProperties.d3viz.axis.texture[i] = textures[t]();
				wpObject.contextualProperties.d3viz.axis.texture[i].thicker().strokeWidth(0.5).stroke(wpObject.contextualProperties.d3viz.axis.color[i]);
			} else if(typeof t === 'string' && t !== 'none' && textures && !textures[t]){
				wpObject.contextualProperties.d3viz.axis.texture[i] = predefineTextures(t, wpObject.contextualProperties.d3viz.axis.color[i]);
			} else if(typeof t === 'string'){
				wpObject.contextualProperties.d3viz.axis.texture[i] = null;
			} else if(typeof t === 'object'){
				wpObject.contextualProperties.d3viz.axis.texture[i] = t;
			}
			
			if(wpObject.contextualProperties.d3viz.axis.texture[i]){
				wpObject.contextualProperties.d3viz.dom.viz.call(wpObject.contextualProperties.d3viz.axis.texture[i]);
			}
		});
		return true;
	} else {
		return false;
	} */
	
}


//////////////////////////////
// primitive shape drawing
/////////////////////////////

function drawBar(wpObject, d, width, height, radius){
	
	let shape, tRadius = 0, bRadius = 0, reverseFactor = 1, angle = ' 0 0 1 ', decalage = 0, 
		radiusPos;

	if(Math.abs(width) < radius*2 || Math.abs(height) < radius*2){
		//radius = (Math.abs(width) < radius*2 ? Math.abs(width)/2 : Math.abs(height)/2);
		if(Math.abs(width) < Math.abs(height)){
			radius = Math.abs(width) / 2;
		} else {
			radius = Math.abs(height) / 2;
		}
	}
	
	if(wpObject.detailProperties.multiDimensionStyle === 'diverging'){
		decalage = wpObject.detailProperties.XYChart.divergingBarSpacing / 2;
		if(d.order && d.order[0] === 0){
			decalage = -decalage;
			reverseFactor = -1;
			angle = ' 1 0 0 ';
			if(wpObject.generalProperties.orientation === 'horizontal'){
			} else {
				width = -width;
			}
		}
	} else if(width < 0){
		reverseFactor = -1;
		angle = ' 1 0 0 ';
	} 
	
	if(wpObject.generalProperties.chartType === 'barchart'){
		radiusPos = wpObject.detailProperties.XYChart.barRadiusPosition;
	} else if(wpObject.generalProperties.chartType === 'parallel'){
		radiusPos = 'all';
	}
	switch(radiusPos){
		case 'all' :
			tRadius = bRadius = radius;
			break;
		case 'top' :
			tRadius = radius;
			break;
		case 'bottom' :
			bRadius = radius;
			break;
	}
	
	//for stacked bar
	if(wpObject.generalProperties.chartType === 'barchart'){
		if(wpObject.detailProperties.multiDimensionStyle === 'stacked'){
			if(d.serieIndex === 0){
				tRadius = 0;
			} else if(d.serieIndex === 1){
				bRadius = 0;
			}
		}
	} else if(wpObject.generalProperties.chartType === 'parallel'){
		if(d.dimensionIndex > 0){
			decalage = - wpObject.detailProperties.parallel.nodeWidth;
		}
	}
	
	if(!_.isNumber(width)){
		width = 0;
	}
	if(!_.isNumber(height)){
		height = 0;
	}
	if(wpObject.generalProperties.orientation === 'horizontal'){
		shape = "M" + (tRadius + decalage) + ",0"
			+ "h" + (width - 2*tRadius)
			+ "a" + tRadius + "," + tRadius + angle + tRadius + "," + tRadius
			+ "v" + (height - tRadius - bRadius)
			+ "a" + bRadius + "," + bRadius + angle + -bRadius + "," + bRadius
			+ "h" + (2*bRadius - width)
			+ "a" + bRadius + "," + bRadius + angle + -bRadius + "," + (-bRadius)
			+ "v" + (tRadius + bRadius - height)
			+ "a" + tRadius + "," + tRadius + angle + tRadius + "," + (-tRadius)
			+ "z";
	} else {
		shape = "M" + (reverseFactor*bRadius + decalage) + ",0"			
			+ "h" + (width - reverseFactor*tRadius - reverseFactor*bRadius)
			+ "a" + reverseFactor*tRadius + "," + tRadius + angle + reverseFactor*tRadius + "," + tRadius
			+ "v" + (height - 2 * tRadius)
			+ "a" + tRadius + "," + tRadius + angle + -reverseFactor*tRadius + "," + tRadius
			+ "h" + (reverseFactor*tRadius + reverseFactor*bRadius - width)
			+ "a" + bRadius + "," + bRadius + angle + -reverseFactor*bRadius + "," + -bRadius
			+ "v" + (2 * bRadius - height)
			+ "a" + reverseFactor*bRadius + "," + bRadius + angle + reverseFactor*bRadius + "," + -bRadius
			+ "z";		
	}
	
	return shape;
	
}

function drawLine(wpObject, d, width, height){
	
	let shape;

	if(wpObject.generalProperties.orientation === 'horizontal'){
		shape = "M0,0" + "h" + (width);
	} else {
		shape = "M0,0" + "v" + (height);
	}
	
	return shape;
}

function drawLinechart(wpObject, d){
	return wpObject.contextualProperties.d3viz.linechart.lineLayout(d);
}

function drawAreachart(wpObject, d){
	return wpObject.contextualProperties.d3viz.linechart.areaLayout(d);
}

function drawHighlightArea(wpObject, d, width, height, start, padding){
	
	let decalage = 0, shape;
	
	if(wpObject.detailProperties.multiDimensionStyle === 'diverging'){
		decalage = wpObject.detailProperties.XYChart.divergingBarSpacing / 2;
		if(d.order && d.order[0] === 0){
			decalage = -decalage;
			width = - width;
		}
	}
	if(wpObject.generalProperties.orientation === 'horizontal'){
		shape =  "M-" + padding + "," + (height-start) + " H" + (width + padding) + " V-" + start + " H-" + padding + " Z";
	} else {
		shape =  "M" + decalage + ",-" + padding + " H" + width + " V" + (height+padding) + " H0 V-" + padding + " Z";
	}
	
	return shape;
}

function drawCirclePath(wpObject, d, r){
	
	let cx = 0, cy = 0;
	
    return 'M '+cx+' '+cy+' m -'+r+', 0 a '+ r +','+ r +' 0 1,0 '+ (r*2) +',0 a '+r+','+r+' 0 1,0 -'+(r*2)+',0';
}

function arcTween(d, arclayout, startValue, endValue, property) {

  return function(d) {
    //var interpolate = d3.interpolate(d.initEndAngle, d.endAngle);
    var interpolate = d3.interpolate(startValue, endValue);
    return function(t) {
      d[property] = interpolate(t);
      return arclayout(d);
    };
  };
}


//////////////////////////////
// utilities function
/////////////////////////////

function getVerticalPosition(wpObject, size, textProperties){
	
	let margin = wpObject.generalProperties.margin,
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		panelWidth = plotWidth, panelHeight = plotHeight,
		yPos = 0;
	
	
	switch(textProperties.vPosition){
		case 'top' :				
		case 'topViz' :				
			yPos = 5 + (textProperties.vPadding ? textProperties.vPadding : (textProperties.padding ? textProperties.padding : 0));
			break;
		case 'topPlot' :				
			yPos = margin.top + (textProperties.vPadding ? textProperties.vPadding : (textProperties.padding ? textProperties.padding : 0));
			break;
		case 'center' :
			yPos = plotHeight/2;
			break;
		case 'centerPlot' :
			yPos = plotHeight/2 - size.height/2 + (textProperties.vPadding ? textProperties.vPadding : (textProperties.padding ? textProperties.padding : 0));
			break;
		case 'centerViz' :
			yPos = vizHeight/2 - size.height/2 + (textProperties.vPadding ? textProperties.vPadding : (textProperties.padding ? textProperties.padding : 0));
			break;
		case 'bottom' :
		case 'bottomViz' :
			yPos = vizHeight - size.height - (textProperties.vPadding ? textProperties.vPadding : (textProperties.padding ? textProperties.padding : 0));
			break;
		case 'bottomPlot' :
			yPos = vizHeight - size.height - margin.bottom - (textProperties.vPadding ? textProperties.vPadding : (textProperties.padding ? textProperties.padding : 0));
			break;
		default :
			if(typeof textProperties.vPosition === 'number'){
				yPos = textProperties.vPosition;
			} else if(textProperties.vPosition.indexOf('px')>0){
				yPos = textProperties.vPosition.replace('px','');
			} else if(textProperties.vPosition.indexOf('%')>0){
				yPos = vizHeight*(Number(textProperties.vPosition.replace('%',''))/100);
			} else {
				yPos = 0;
			}
			break;
	}
	
	return yPos;
}

function getHorizontalPosition(wpObject, size, textProperties, considerSizeWidth = false){
		
	let margin = wpObject.generalProperties.margin,
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom,
		panelWidth = plotWidth, panelHeight = plotHeight,
		xPos = 0;

		
	switch(textProperties.hPosition){
		case 'left' :
		case 'leftViz' :
			xPos = (textProperties.hPadding ? textProperties.hPadding : 0);
			break;
		case 'leftPlot' :
			xPos = margin.left + (textProperties.hPadding ? textProperties.hPadding : 0);
			break;
		case 'center' :
			xPos = vizWidth/2 + (textProperties.hPadding ? textProperties.hPadding : 0);
			break;
		case 'centerViz' :
			xPos = vizWidth/2 + (textProperties.hPadding ? textProperties.hPadding : 0) - (considerSizeWidth ? size.width/2 : 0);
			break;
		case 'centerPlot' :
			xPos = plotWidth/2 + (textProperties.hPadding ? textProperties.hPadding : 0) - (considerSizeWidth ? size.width/2 : 0);
			break;
		case 'right' :
		case 'rightViz' :
			xPos = vizWidth - size.width + (textProperties.hPadding ? - textProperties.hPadding : 0);
			break;
		case 'rightPlot' :
			xPos = vizWidth - size.width - margin.right + (textProperties.hPadding ? -textProperties.hPadding : 0);
			break;
		default :
			if(typeof textProperties.hPosition === 'number'){
				xPos = textProperties.hPosition;
			} else if(textProperties.hPosition.indexOf('px')>0){
				xPos = textProperties.hPosition.replace('px','');
			} else if(textProperties.hPosition.indexOf('%')>0){
				xPos = wpObject.generalProperties.size.width*(Number(textProperties.hPosition.replace('%',''))/100);
			} else {
				xPos = 0;
			}
			break;
	}
	
	return xPos;
}

function drawText(wpObject, domContainer, textProperties, dataMapping){
	
	let margin = wpObject.generalProperties.margin,
		padding = {top: 0, right: 0, bottom: 0, left: 0},
		vizWidth = wpObject.generalProperties.size.width,
		vizHeight = wpObject.generalProperties.size.height,
		plotWidth = vizWidth - margin.left - margin.right,
		plotHeight = vizHeight - margin.top - margin.bottom;
		
	let txtDom, size, xPos, yPos, svgblock;
	
	//remove content
	domContainer.selectAll('text').remove();
	
	if(textProperties.SVG){
		svgblock = textProperties.SVG;
		svgblock = mapVariableValue(svgblock, dataMapping, textProperties.variableFormat, wpObject);
		domContainer.appendSVG(svgblock);
		txtDom = domContainer.select('text');
	} else {
		txtDom = domContainer
			.append("text")
			.attr('class','text')
			.attr("dy","0.7em")
			.text(textProperties.text);
	}	
	
	if(txtDom){
		//styling
		txtDom
			.style('fill', textProperties.color)
			.style("font-family", textProperties.fontFamily)
			.style("font-size", textProperties.fontSize)
			.style("font-weight", textProperties.fontWeight)
			.style("font-style", textProperties.fontStyle);
			
		if(!textProperties.SVG){
			txtDom
				.style("text-anchor",textProperties.textAnchor);
			
			textWrap(txtDom, vizWidth, null, 0.7);
		}
	}

	//calculate Title block size for adjustment
	size = d3DomElementSize(domContainer);
	xPos = getHorizontalPosition(wpObject, size, textProperties);
	yPos = getVerticalPosition(wpObject, size, textProperties);
		
	domContainer
		.attr("transform","translate(" + xPos + "," + yPos + ")");
			
}

function setShapeColor(wpObject, d){

	let styleColors = wpObject.contextualProperties.d3viz.styles.colors;

	if(styleColors.dimensionField && styleColors.dimensionField.length > 0){
		d.shapeColor = styleColors.scale(d[styleColors.dimensionField[0]]);
	} else {
		d.shapeColor = styleColors.defaultColor;
	}
	
	if(wpObject.generalProperties.chartType === 'sunburst' && wpObject.detailProperties.sunburst.depthColorDecreaseMode){
		d.shapeColor = adjustHierarchyColor(d, wpObject.detailProperties.sunburst, d.shapeColor);
	}
	if(wpObject.generalProperties.chartType === 'forceSimulation' && wpObject.detailProperties.forceSimulation.depthColorDecreaseMode){
		d.shapeColor = adjustHierarchyColor(d, wpObject.detailProperties.forceSimulation, d.shapeColor);
	}
	if(wpObject.generalProperties.chartType === 'circlePack' && wpObject.detailProperties.circlePack.depthColorDecreaseMode){
		d.shapeColor = adjustHierarchyColor(d, wpObject.detailProperties.circlePack, d.shapeColor);
	}
	if(d.__highlightRule__ && d.__highlightRule__.color){
		d.shapeColor = d.__highlightRule__.color;
	}

	
	
}

function getColor(serieIndex, colorIndex, colorArray, defaultColors){

	let selectedColor;
	//(colorArray[colorIndex] ? colorArray[colorIndex] : defaultColor);
	
	if(typeof colorArray === 'object' && _.isArray(colorArray) && colorArray[colorIndex]){
		selectedColor = colorArray[colorIndex];
	} else if(typeof defaultColors === 'object' && defaultColors[serieIndex]){
		selectedColor = defaultColors[serieIndex];
	} else if(typeof defaultColors === 'string'){
		selectedColor = defaultColors;
	} else {
		selectedColor = "#000000";
	}
	
	return selectedColor;
}

//wrap a text in multiple line depending on width
function textWrap(text, width, lineHeight, dy) { //lineHeight em

	var lineNumber = 0;
	
	if(!lineHeight){
		lineHeight = 1.1;
	}
	
	text.each(function() {
	  var text = d3.select(this),
		  words = text.text().split(/\s+/).reverse(),
		  word,
		  line = [],
		  y = text.attr("y"),
		  x = text.attr("x"),		  
		  //dy = parseFloat(text.attr("dy")),		  
		  tspan;
		  
		  if(!x){
			  x = 0;
		  }
		  //tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
		  tspan = text.text(null).append("tspan").attr('class','textLine textLine0').attr("lineNumber",0).attr("x", x).attr("y", y).attr("dy", dy + "em");
			lineNumber = 0;
	  while (word = words.pop()) {
		line.push(word);
		tspan.text(line.join(" "));
		if (tspan.node().getComputedTextLength() > width) {
		  line.pop();
		  tspan.text(line.join(" "));
		  line = [word];
		  lineNumber += 1;
		  //tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
		  tspan = text.append("tspan").attr("x", x).attr("y", y).attr('class','textLine textLine' + lineNumber).attr("lineNumber",lineNumber).attr("dy", (dy + lineNumber*lineHeight) + "em").text(word);
		}
	  }
	});
	
	lineNumber += 1;
	return lineNumber;
}

function d3DomElementSize(d3DomElement, tagType){

	let size = {'width' : 0, 'height' : 0},
		node = d3DomElement.node();

	if(tagType && tagType === 'html'){
		if(node){
			size = node.getBoundingClientRect();
		}
	} else {
		if(node){
			if(node.getBBox){
				size = node.getBBox();
				if(size === null){
					size = node.getBoundingClientRect();
				}
			}
		}
	}
	
	return size;
}

function predefineTextures(textureName, color){
	
	//mis en commentaire à cause de react
	
/* 	let returnTexture = null;
	
	switch(textureName){
		case 'lines1' :
			returnTexture = textures.lines().thicker().strokeWidth(0.5).stroke(color);
			break;
		case 'lines2' :
			returnTexture = textures.lines().size(4).strokeWidth(1).stroke(color);
			break;
		case 'lines3' :
			returnTexture = textures.lines().size(8).strokeWidth(2).stroke(color);
			break;
		case 'lines4' :
			returnTexture = textures.lines().size(12).strokeWidth(4).stroke(color);
			break;
		case 'lines5' :
			returnTexture = textures.lines().size(12).strokeWidth(6).stroke(color);
			break;
		case 'circles1' :
			returnTexture = textures.circles().thicker().fill(color);
			break;
		case 'circles2' :
			returnTexture = textures.circles().thicker().radius(4).fill(color);
			break;
		case 'circles3' :
			returnTexture = textures.circles().size(5).fill(color);
			break;
		case 'circles4' :
			returnTexture = textures.circles().radius(4).fill("transparent").strokeWidth(2).stroke(color);
			break;
		case 'paths1' :
			returnTexture = textures.paths().d("hexagons").size(8).strokeWidth(2).stroke(color);
			break;
		case 'paths2' :
			returnTexture = textures.paths().d("crosses").lighter().thicker().stroke(color);
			break;
		case 'paths3' :
			returnTexture = textures.paths().d("caps").lighter().thicker().strokeWidth(1).stroke(color);
			break;
		case 'paths4' :
			returnTexture = textures.paths().d("woven").lighter().thicker().strokeWidth(2).stroke(color);
			break;
		case 'paths5' :
			returnTexture = textures.paths().d("nylon").lighter().shapeRendering("crispEdges").strokeWidth(2).stroke(color);
			break;
	}

	
	return returnTexture; */
	
}

function getVariables(text){

	let pattern = /\[.*?\]/g;
	let result = text.match(pattern);
	
	if(result){
		result.forEach(function(p,i){
			result[i] = p.slice(1,-1);
		})
	}
	
	return result;
	
}

//in a text, replace variable by value, applying a formatting if necessary
function mapVariableValue(text, d, format, wpObject){
	
	let pattern = /\[.*?\]/g;
	let result = text.match(pattern);
	if(result){
		result.forEach(function(p,i){
			let substring = p.slice(1,-1);
			let variable = null;
			if(d[substring] || d[substring] === 0){
				variable = d[substring];
			}
			if(variable || variable === 0){
				if(format && format[substring]){
					if(typeof format[substring] === 'string'){
						variable = d3.format(format[substring])(variable);
					} else if(typeof format[substring] === 'object'){
						if(format[substring].datatype === 'date'){
							let dateParse = d3.timeParse(format[substring].formatIn);
							let locale = wpObject.contextualProperties.d3viz.localeFormat;					
							let dateFormat = locale.format(format[substring].formatOut);
							variable = dateFormat(dateParse(variable));
						} else if(format[substring].datatype === 'number'){
							let locale = wpObject.contextualProperties.d3viz.localeNumberFormat;
							let localeFormat = locale.format(format[substring].formatOut);
							variable = localeFormat(variable);
							//variable = d3.format(format[substring].formatOut)(variable);
							
							//TODO : gérer plus proprement l'override de format via une fonction spécifique
							//variable = variable.replace(/G/, 'md');
							variable = overrideLocalNumberShortcut(wpObject, variable);
						}
						
						if(format[substring].removeFormatPctSign){
							variable = variable.replace(wpObject.contextualProperties.d3viz.numberFormatSpecifier.percent,'');
						}
					}
				}
				text = text.replace(p, variable);
				if(variable === 0 || variable === 1){
					text = text.replace("(s)", "");
				} else {
					text = text.replace("(s)", "s");
				}
			} else {
				console.log('variable not available in data');
				variable = '---';
				text = text.replace(p, variable);
			}
		})
	}
	return text;
	
}

function overrideLocalNumberShortcut(wpObject, val){
	
	let newVal;
	
	switch(wpObject.generalProperties.defaultLocalFormat){
		case 'US' :
			newVal = val.replace(/M/, 'm');
			newVal = newVal.replace(/G/, 'b');
			newVal = newVal.replace(/T/, 't');
			break;
		default :
			newVal = val.replace(/G/, 'md');
			break;
	}
	
	return newVal;
}

//degree 2 radian conversion
function deg2rad(deg) {
	return deg * Math.PI / 180;
}

//radian 2 degree conversion
function rad2deg(rad) {
	return rad * 180 / Math.PI;
}

//calculates the angle for the middle of a slice
function midAngle(d) { 
	return d.startAngle + (d.endAngle - d.startAngle) / 2;
}

//adjust color : brighter, darker, grayscale, etc ...
function adjustColorRule(rule, factor, color, altColor, backcgroundColor){
	let newColor = d3.hsl(color);
	
	switch(rule){
		case 'brighter' :
			newColor = newColor.brighter(factor);
			break;
		case 'darker' :
			newColor = newColor.darker(factor);
			break;
		case 'hue' :
			newColor.h += factor;
			break;
		case 'grayscale' :
			if(factor === 0){	//luminance
				newColor.s = 0.05;
			} else {			// corrected average
				let gray = (d3.rgb(newColor).r * 0.3 + d3.rgb(newColor).g * 0.59 + d3.rgb(newColor).b * 0.11);
				newColor = d3.rgb(gray, gray, gray);
			}
			break;
		case 'saturation' :
			newColor.s += factor;
			break;
		case 'lumimance' :
			newColor.l += factor;
			break;
		case 'contrast' :
			if(d3.hsl(backcgroundColor).l < 0.5){
				newColor = d3.hsl(altColor);
			}
			break;
	}
	
	return newColor.hex();
}

var tmpDepth = 0;

function deepAssignProperty(wpObject, key, value) {
	
    Object.keys(wpObject).forEach(function (k) {

        if (wpObject[k] !== null && typeof wpObject[k] === 'object') {
            return deepAssignProperty(wpObject[k], key, value);
        }

        //if (k === key)
		let lk = k.toLowerCase();
        if (lk.indexOf(key.toLowerCase())>-1)
			wpObject[k] = value;
            return true;
			

    });
}

function isCyclic(obj) {
  var keys = [];
  var stack = [];
  var stackSet = new Set();
  var detected = false;

  function detect(obj, key) {
    if (!(obj instanceof Object)) { return; } // Now works with other
                                              // kinds of object.

    if (stackSet.has(obj)) { // it's cyclic! Print the object and its locations.
      var oldindex = stack.indexOf(obj);
      var l1 = keys.join('.') + '.' + key;
      var l2 = keys.slice(0, oldindex + 1).join('.');
      console.log('CIRCULAR: ' + l1 + ' = ' + l2 + ' = ' + obj);
      console.log(obj);
      detected = true;
      return;
    }

    keys.push(key);
    stack.push(obj);
    stackSet.add(obj);
    for (var k in obj) { //dive on the object's children
      if (obj.hasOwnProperty(k)) { detect(obj[k], k); }
    }

    keys.pop();
    stack.pop();
    stackSet.delete(obj);
    return;
  }

  detect(obj, 'obj');
  return detected;
}

//update data __key__ : to simplify animation for change chartType, data diltering, etc ...
function updateKey(wpObject){
	
}


//////////////////////////////////////////////
// specific functions for chart
//////////////////////////////////////////////


//sunburst focus/zoom

function sunburstZoom(wpObject, d = { x0: 0, x1: 1, y0: 0, y1: 1 }) {
	// Reset to top-level if no data point specified

	let x, y, arc, middleArcLine, textFits, svg, pieRadius;
	
	x = wpObject.contextualProperties.d3viz.axis.x;		
	y = wpObject.contextualProperties.d3viz.axis.y;
	arc = wpObject.contextualProperties.d3viz.sunburst.arcLayout;
	middleArcLine = wpObject.contextualProperties.d3viz.sunburst.middleArcLine;
	textFits = wpObject.contextualProperties.d3viz.sunburst.textFits;
	svg = wpObject.contextualProperties.d3viz.dom.viz;
	
	wpObject.contextualProperties.d3viz.sunburst.focus = d;
	if(wpObject.contextualProperties.d3viz.sunburst.root !== d){
		pieRadius = wpObject.contextualProperties.d3viz.sunburst.maxRadius;
		y.range([pieRadius*0.4,pieRadius]);
	} else {
		y.range([pieRadius*0.3,pieRadius]);
	}
	
 	const transition = svg.transition()
		.duration(750)
		.tween('scale', () => {
			const xd = d3.interpolate(x.domain(), [d.x0, d.x1]),
				yd = d3.interpolate(y.domain(), [d.y0, 1]);
			return t => { x.domain(xd(t)); y.domain(yd(t)); };
		});

	transition.selectAll('path.shape')
		.attrTween('d', d => () => arc(d))
		.style('display',function(d){ return ( d.depth < (wpObject.contextualProperties.d3viz.sunburst.focus.depth-1) ? 'none' :'inline');});		

	transition.selectAll('path.hidden-arc')
		.attrTween('d', d => () => middleArcLine(d));
		
	transition.selectAll('text.label')
		.styleTween('display', d => () => textFits(d) ? null : 'none')
		.on('end',function(d){
			let txt = d3.select(this).selectAll('.textShadow');			
			txt.attr('startOffset', '50.1%');
			console.log('end txt zoom : ' + txt.size());
		});
	

	
	moveStackToFront(d);

	//

	function moveStackToFront(elD) {
		svg.selectAll('.sunburst').filter(d => d === elD)
			.each(function(d) {
				this.parentNode.appendChild(this);
				if (d.parent) { moveStackToFront(d.parent); }
			})
	}
}

function adjustHierarchyColor(d, hierarchyProperties, shapeColor){
	let newColor = d3.hsl(shapeColor);
	
	if(d.depth > 1){
		switch(hierarchyProperties.depthColorDecreaseMode){
			case 'brighter' :
				newColor = newColor.brighter(hierarchyProperties.depthColorDecreasefactor*(d.depth-1));
				break;
			case 'darker' :
				newColor = newColor.darker(hierarchyProperties.depthColorDecreasefactor*(d.depth-1));
				break;
			case 'hue' :
				newColor.h += hierarchyProperties.depthColorDecreasefactor*(d.depth-1);
				break;
			case 'saturation' :
				newColor.s += hierarchyProperties.depthColorDecreasefactor*(d.depth-1);
				break;
		}
	}
	
	return newColor.hex();
}

function circlePackZoom(wpObject, d) {
	
	if(!d.children){
		d = d.parent;
	}
	var focus0 = wpObject.contextualProperties.d3viz.circlePack.focus,
		focus = wpObject.contextualProperties.d3viz.circlePack.focus = d,
		view = wpObject.contextualProperties.d3viz.circlePack.view;

	let svg = wpObject.contextualProperties.d3viz.dom.viz;

	var transition = d3.transition()
		.duration(d3.event.altKey ? 7500 : 1600)
		.tween("zoom", function(d) {
		  var i = d3.interpolateZoom(view, [focus.x, focus.y, focus.r*2]);
		  return function(t) { zoomTo(wpObject, i(t)); };
		});

	let shapeLabel = svg.selectAll(".marker").transition(transition);
	
	stylingLabels(wpObject, shapeLabel);
	
	/*   .filter(function(d) { return d.parent === focus || this.style.display === "inline"; })
		.style("fill-opacity", function(d) { return d.parent === focus ? 1 : 0; })
		.on("start", function(d) { if (d.parent === focus) this.style.display = "inline"; })
		.on("end", function(d) { if (d.parent !== focus) this.style.display = "none"; }); */
}

function zoomTo(wpObject, v) {
	var k = wpObject.contextualProperties.d3viz.circlePack.diameter / v[2];
	
	wpObject.contextualProperties.d3viz.circlePack.view = v;
	
	let svg = wpObject.contextualProperties.d3viz.dom.viz;
	
	svg.selectAll('.circlePack').attr("transform", function(d) { return "translate(" + ((d.x - v[0]) * k + wpObject.contextualProperties.d3viz.circlePack.xPos) + "," + ((d.y - v[1]) * k + wpObject.contextualProperties.d3viz.circlePack.yPos) + ")"; });
	svg.selectAll('.marker').attr("transform", function(d) { return "translate(" + ((d.x - v[0]) * k + wpObject.contextualProperties.d3viz.circlePack.xPos) + "," + ((d.y - v[1]) * k + wpObject.contextualProperties.d3viz.circlePack.yPos) + ")"; });
	svg.selectAll('.shape').attr("r", function(d) { return d.r * k; });
}

// forceSimulation

function dragstarted(d, wpObject) {
	
	if(d.depth === 0){
		return false;
	}
	if (!d3.event.active) wpObject.contextualProperties.d3viz.forceSimulation.forceLayout.alphaTarget(0.3).restart();
	d.fx = d.x;
	d.fy = d.y;
}

function dragged(d) {
	if(d.depth === 0){
		return false;
	}	
	d.fx = d3.event.x;
	d.fy = d3.event.y;
}

function dragended(d, wpObject) {
	if (!d3.event.active) wpObject.contextualProperties.d3viz.forceSimulation.forceLayout.alphaTarget(0);
	d.fx = null;
	d.fy = null;
}

function forceClick(wpObject, d) {
  if (!d3.event.defaultPrevented && d.depth > 1) {
    if (d.children) {
      d._children = d.children;
      d.children = null;
    } else {
      d.children = d._children;
      d._children = null;
    }
    redrawWidget(wpObject,'updateData');
  }
}


//specific function call

function checkSpecificFunction( name ){
	switch(name){
		case 'ttHYG344_SVG' :
			return true;
			break;
	}
	return false;
}

function specificFunctionCall( _ ){
	
	let fnReturn;
	
	switch(arguments[0]){
		case 'ttHYG344_SVG' :
			fnReturn = ttHYG344_SVG( arguments );
			return fnReturn;
			break;
	}
	return false;
}

function ttHYG344_SVG( _ ){	// wpObject, tooltipArea, dimensions, domElem, d
	
	//console.log('call tooltip specific function');
	
	let wpObject = arguments[0][1];
	let tooltipProperties = arguments[0][2];
	let d = arguments[0][3];
	
	let svg;
	
	if(d.distribution === 1){
		svg = "<g><g><line x1='14' x2='14' y1='14' y2='54' style='stroke : #ff4700;stroke-width: 2' /></g><text x='26' y='34' dy='0em'><tspan x='26' y='46' style='font-weight:800;font-size : 33px'>[pct]</tspan><tspan dy='-1em' style='font-weight :700'>%</tspan><tspan x='150' y='24'>de vos salariés ne se sont jamais</tspan><tspan x='150' y='50'>absentés</tspan></text></g>";
	} else {
		svg = "<g><g><line x1='14' x2='14' y1='14' y2='54' style='stroke : #ff4700;stroke-width: 2' /></g><text x='26' y='34' dy='0em'><tspan x='26' y='46' style='font-weight:800;font-size : 33px'>[pct]</tspan><tspan dy='-1em' style='font-weight :700'>%</tspan><tspan x='150' y='24'>de vos salariés ont été absents</tspan><tspan x='150' y='50'>moins de</tspan><tspan style='font-weight:600'> [distribution] jour(s)</tspan></text></g>";
	}
	
	return svg;
}


//////////////////////////////////////////////
// link text to widget action
//////////////////////////////////////////////

function linkText(links){
	
	if(links && links.length > 0){
		let linkedTxtTags = d3.selectAll('linkedTxt');		
		links.forEach(function(l,i){
			let tags = linkedTxtTags.filter("[linkedId= " + l.generalProperties.id + "]");
			if(tags){
				tags.datum(l);
				switch(l.generalProperties.event){
					case 'over' :
						tags.on('mouseover',function(d){
								//console.log('mouse over on ' + d.detailProperties.linkedObject[0].tagId + ' / ' + d.detailProperties.linkedObject[0].elementClass);
								let wpObject = d.detailProperties.linkedObject[0].wpObject;
								let plot = wpObject.contextualProperties.d3viz.dom.plot;
								
								//let shape = d3.selectAll('#' + wpObject.contextualProperties.tagId + ' .' + d.detailProperties.linkedObject[0].elementClass);
								let shape = plot.selectAll('.shape')
													.filter(function(data) {
															return data[d.detailProperties.linkedObject[0].searchColumn] === d.detailProperties.linkedObject[0].searchValue;
													});
								if(shape.size() !== 1){
									return false;
								}
								let shapeData = shape.datum();
								if(wpObject.detailProperties.events.mouseover){
									switch(d.detailProperties.linkedObject[0].action){
										case 'tooltip' :
											//show highlightArea
											if(wpObject.detailProperties.highlightArea.active === true){
												toggleHighlightArea(wpObject, shape, shapeData, true);
											}
											if(wpObject.detailProperties.tooltip.active === true && shapeData.benchmarkData === false){
												toggleTooltip(wpObject, shape, shapeData, true);
											}
											break;
										case 'breadcrumb' :
											if(wpObject.detailProperties.tooltip.active === true && shapeData.benchmarkData === false){
												toggleTooltip(wpObject, shape, shapeData, true);
											}
											if(wpObject.detailProperties.breadcrumb && wpObject.detailProperties.breadcrumb.active === true ){
												toggleBreadcrumb(wpObject, shape, shapeData, true);
											}
											break;
										case 'zoom2Parent_focus' :
											if(wpObject.generalProperties.chartType === 'sunburst'){
												sunburstZoom(wpObject, shapeData.parent);
											} else if(wpObject.generalProperties.chartType === 'circlePack'){
												circlePackZoom(wpObject, shapeData.parent);
											}
											if(wpObject.detailProperties.breadcrumb && wpObject.detailProperties.breadcrumb.active === true ){
												toggleBreadcrumb(wpObject, shape, shapeData, true);
											}
											if(wpObject.detailProperties.tooltip.active === true && shapeData.benchmarkData === false){
												toggleTooltip(wpObject, shape, shapeData, true);
											}
											break;
									}
								}
							});
						tags.on('mouseleave',function(d){
								//console.log('mouse over on ' + d.detailProperties.linkedObject[0].tagId + ' / ' + d.detailProperties.linkedObject[0].elementClass);
								let wpObject = d.detailProperties.linkedObject[0].wpObject;
								let plot = wpObject.contextualProperties.d3viz.dom.plot;
								let shape = plot.selectAll('.shape')
													.filter(function(data) {
															return data[d.detailProperties.linkedObject[0].searchColumn] === d.detailProperties.linkedObject[0].searchValue;
													});
								let shapeData = shape.datum();
								if(wpObject.detailProperties.events.mouseover){
									switch(d.detailProperties.linkedObject[0].action){
										case 'tooltip' :
											//show highlightArea
											if(wpObject.detailProperties.highlightArea.active === true){
												toggleHighlightArea(wpObject, shape, shapeData, false);
											}
											if(wpObject.detailProperties.tooltip.active === true && shapeData.benchmarkData === false){
												toggleTooltip(wpObject, shape, shapeData, false);
											}
											break;
										case 'breadcrumb' :
											if(wpObject.detailProperties.tooltip.active === true && shapeData.benchmarkData === false){
												toggleTooltip(wpObject, shape, shapeData, false);
											}
											if(wpObject.detailProperties.breadcrumb && wpObject.detailProperties.breadcrumb.active === true ){
												toggleBreadcrumb(wpObject, shape, shapeData, false);
											}
											break;											
										case 'zoom2Parent_focus' :
											if(wpObject.generalProperties.chartType === 'sunburst'){
												sunburstZoom(wpObject, wpObject.contextualProperties.d3viz.sunburst.root);
											} else if(wpObject.generalProperties.chartType === 'circlePack'){
												circlePackZoom(wpObject, wpObject.contextualProperties.d3viz.circlePack.root);
											}
											if(wpObject.detailProperties.breadcrumb && wpObject.detailProperties.breadcrumb.active === true ){
												toggleBreadcrumb(wpObject, shape, shapeData, false);
											}
											if(wpObject.detailProperties.tooltip.active === true && shapeData.benchmarkData === false){
												toggleTooltip(wpObject, shape, shapeData, false);
											}
											break;
									}
								}
							});
						break;
					case 'click' :
						break;
				}
				
			}
		})
	}
}


//////////////////////////////////////////////
// link annotations
//////////////////////////////////////////////

//mis en commentaire à cause de react
/* function linkAnnotations(wpObject, annotations){
	
	let annotationArea = wpObject.contextualProperties.d3viz.dom.foregroundPlot;
	let plot = wpObject.contextualProperties.d3viz.dom.plot;
	let margin = wpObject.generalProperties.margin;
	let annotationToggleIndicatorOpacity = 1;
	
	if(wpObject.detailProperties.annotation && !wpObject.detailProperties.annotation.active){
		return false;
	}
	
	if(typeof annotations === 'object' && annotations.detailProperties.notes.length > 0){
		wpObject.contextualProperties.d3viz.annotation.annotationList = annotations;
	} else if((annotations === null || annotations === undefined) && wpObject.contextualProperties.d3viz.annotation.annotationList === null){
		return false;
	} else {
		annotations = wpObject.contextualProperties.d3viz.annotation.annotationList;
	}
	
	//add annotation icon indicator
	if(wpObject.detailProperties.annotation && wpObject.detailProperties.annotation.annotationToggleIndicator.visible === false
		|| (wpObject.contextualProperties.state === 'animation' && wpObject.detailProperties.annotation.annotationToggleIndicator.visibleInAnimation === false)){
		annotationToggleIndicatorOpacity = 0;
	}
	let tagId = '#' + wpObject.contextualProperties.tagId;
	let htmlblock = "<div class='d3AnnotationIconIndicator' style='transform:translate(" + (margin.left + 5) + "px," + (margin.top - 25) + "px);opacity : " + annotationToggleIndicatorOpacity + "'>" ;
	htmlblock += "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='26px' height='26px' viewBox='0 0 33.205 33.205'><g><path d='M16.603,17.908c-3.131,0-5.679-2.548-5.679-5.68s2.547-5.68,5.679-5.68s5.679,2.548,5.679,5.68 S19.734,17.908,16.603,17.908z M16.603,7.549c-2.58,0-4.679,2.099-4.679,4.68s2.099,4.68,4.679,4.68s4.679-2.099,4.679-4.68 S19.183,7.549,16.603,7.549z'/><g><path d='M16.603,33.205c-0.148,0-0.288-0.065-0.383-0.179C15.736,32.449,4.376,18.811,4.376,12.229C4.376,5.486,9.861,0,16.603,0 s12.227,5.486,12.227,12.229c0,6.583-11.36,20.22-11.843,20.798C16.891,33.14,16.75,33.205,16.603,33.205z M16.603,1 C10.412,1,5.376,6.037,5.376,12.229c0,5.571,9.216,17.215,11.227,19.688c2.01-2.474,11.227-14.118,11.227-19.688 C27.829,6.037,22.793,1,16.603,1z'/></g></svg>";
	htmlblock += "</div>";
	d3.select(tagId + ' .foregroundHtmlPlot .d3AnnotationIconIndicator').remove();
	d3.select(tagId + ' .foregroundHtmlPlot').appendHTML(htmlblock);
	
	d3.select(tagId + ' .foregroundHtmlPlot .d3AnnotationIconIndicator')
		.on('click',function(){
			if(wpObject.contextualProperties.d3viz.annotation.containerVisible){
				toggleWidgetAnnotations(wpObject,null, null, false);
			} else {
				toggleWidgetAnnotations(wpObject,null, null, true);
			}
		})
	
	//remove
	notes_del_t = d3.transition().delay(0).duration(300);
	annotationArea.selectAll(".annotationContainer")
		.transition(notes_del_t)
		.style('opacity',0)
		.on('end',function(){
			d3.select(this).remove();
		});
		
	
	//set annotation to d3-annotation 'format'
	let linkAnnotations = [];
	annotations.detailProperties.notes.forEach(function(n,i){
		if(n.linkedObject && n.linkedObject.searchObject === 'shapes' && n.linkedObject.searchMethod === 'data'){
			let shape = plot.selectAll('.shapes')
								.filter(function(data) {
									let selected = true;
									_.forIn(n.linkedObject.searchValues, function(value, key) {
									  if(data[key] && data[key] === value){										  
									  } else {
										  selected = false;
									  }
									});									
									return selected;									
								});
			if(shape.size() !== 1){
				return false;
			}
			let shapeData = shape.datum();
			switch(wpObject.generalProperties.chartType){
				case 'barchart' :
					n.x = shapeData.x + shapeData.bandwidth/2;
					n.y = shapeData.y;
					break;
				default :
					n.x = shapeData.x;
					n.y = shapeData.y;
				break;
			}
			n.dx = n.hPadding;
			n.dy = n.vPadding;
			linkAnnotations.push(n);
		} else {
			n.dx = n.hPadding;
			n.dy = n.vPadding;
			linkAnnotations.push(n);
		}
	})
	
	if(linkAnnotations.length > 0){
		wpObject.contextualProperties.d3viz.annotation.linkedAnnotation = true;
	} else {
		wpObject.contextualProperties.d3viz.annotation.linkedAnnotation = false;
	}
	
	let makeAnnotations = wpObject.contextualProperties.d3viz.annotation.notes = d3.annotation()
        .annotations(linkAnnotations);
	
	annotationArea.append("g").attr("class", "annotationContainer").style('opacity',0).call(makeAnnotations);
	
	//formatting
	annotationArea.selectAll(".bei-annotation .annotation-note .annotation-note-title")
		.style('font-family', annotations.generalProperties.titleFormatting.fontFamily)
		.style('font-size', annotations.generalProperties.titleFormatting.fontSize)
		.style('font-weight', annotations.generalProperties.titleFormatting.fontWeight);
	
	annotationArea.selectAll(".bei-annotation .annotation-note .annotation-note-label")
		.style('font-family', annotations.generalProperties.textFormatting.fontFamily)
		.style('font-size', annotations.generalProperties.textFormatting.fontSize)
		.style('font-weight', annotations.generalProperties.textFormatting.fontWeight);
	
	//update annotation
	makeAnnotations.update();
	
	notes_t = d3.transition().delay(2000).duration(600);

	

	if(wpObject.detailProperties.annotation.visible === true){
		let AnnotationsPromise = new Promise((resolve, reject) => {
			annotationArea.selectAll(".annotationContainer").transition(notes_t).style('opacity',1).on("end", resolve) ;
		});
		wpObject.contextualProperties.promises.push(AnnotationsPromise);
				
		wpObject.contextualProperties.d3viz.annotation.containerVisible = true;
	} else {
		wpObject.contextualProperties.d3viz.annotation.containerVisible = false;
	}
	
}
 */

//////////////////////////////////////////////
// Animations
//////////////////////////////////////////////

function animationIndicator(wpObject, animationProperties){
	
	
	animationList(wpObject, animationProperties, 'add');
	
	let animationMsgArea = wpObject.contextualProperties.d3viz.dom.foregroundHtmlViz;

	//animationIndicator
	animationMsgArea.selectAll(".animationIndicatorContainer").remove();
	let htmlblock  = "<div class='animationIndicatorContainer' style='position: absolute'>";
		htmlblock += "	<span class='animationIndicatorBlock' style='opacity:0'>";
		htmlblock += "		<div class='animationList btnBlock'>";
		htmlblock += "			<div class='animationListBtn btnIcon'><svg version='1.1' xmlns='http://www.w3.org/2000/svg' style='left:5px;top:5px' height='20px' width='20px' viewBox='0 0 201.611 201.611'><g><g><path d='M0,27.539v130.345h201.611V27.539H0z M195.903,152.183H5.708V33.248h190.194 C195.903,33.248,195.903,152.183,195.903,152.183z'/></g><g><polygon points='62.78,174.072 99.252,174.072 136.526,174.072 136.526,164.262 62.78,164.262'/></g><g><path d='M87.632,121.549c0.361,0.168,0.752,0.251,1.142,0.251c0.612,0,1.217-0.215,1.711-0.616 l31.909-26.33c0.623-0.501,0.977-1.267,0.977-2.076c0-0.798-0.358-1.564-0.977-2.065l-31.909-26.33 c-0.809-0.662-1.915-0.798-2.852-0.354c-0.941,0.437-1.546,1.385-1.546,2.426v52.652 C86.086,120.153,86.691,121.101,87.632,121.549z M91.461,72.16l25.002,20.621l-25.002,20.632V72.16z'/></g></g></svg>";
		htmlblock += "			<div class='btnTxt'></div>";
		htmlblock += "		</div>";
		htmlblock += "	</span>";
		htmlblock += "</div>";
		
	animationMsgArea.appendHTML(htmlblock);
	animationMsgArea.select('.animationListBtn')
		.on('click', function(){
			animationListSelection(wpObject);
		})
		
}

function animationEnd(wpObject){
	
	let foregroundHtmlPlot = wpObject.contextualProperties.d3viz.dom.foregroundHtmlPlot;
	//annotation indicator
	if(wpObject.contextualProperties.d3viz.annotation.linkedAnnotation && wpObject.detailProperties.annotation.annotationToggleIndicator.visible === true){				
		foregroundHtmlPlot.select('.d3AnnotationIconIndicator').style('opacity', 1);
	}
	//filter selector
	foregroundHtmlPlot.select('.d3filterSelectorUI').style('opacity', 1);
	
	wpObject.contextualProperties.state = null;
	wpObject.contextualProperties.animation.state = 'end';
	wpObject.contextualProperties.animation.currentStepIdx = -1;
	
}

function animationList(wpObject, animationProperties, action){
	
	let animationIdx = -1;
	
	if(wpObject.contextualProperties.animationList.length > 0){
		animationIdx = _.findIndex(wpObject.contextualProperties.animationList, function(o) { return o.id === animationProperties.id; });
		switch(action){
			case 'add' : 
				if(animationIdx === -1){
					wpObject.contextualProperties.animationList.push(animationProperties);
				}
				break;
			case 'remove':
				if(animationIdx > -1){
				}
				break;
		}
	} else if(action === 'add'){
		wpObject.contextualProperties.animationList.push(animationProperties);
	}
}

function animationListSelection(wpObject){

	if(wpObject.contextualProperties.animationList.length === 1){
		let animationProperties = wpObject.contextualProperties.animationList[0];
		animationProperties.start();
	}
}


//////////////////////////////////////////////
// d3.js addons to insert directly html/svg 
//////////////////////////////////////////////

d3.selection.prototype.appendHTML = function(HTMLString) {
	return this.select(function() {
		return this.appendChild(document.importNode(new DOMParser().parseFromString(HTMLString, 'text/html').body.childNodes[0], true));
	});
};

d3.selection.prototype.appendSVG = function(SVGString) {
	return this.select(function() {
		return this.appendChild(document.importNode(new DOMParser()
		.parseFromString('<svg xmlns="http://www.w3.org/2000/svg">' + SVGString + '</svg>', 'application/xml').documentElement.firstChild, true));
	});
};


function cumsum(values, valueof) {
  var sum = 0, index = 0;
  return Float64Array.from(values, valueof === undefined
    ? v => (sum += +v || 0)
    : v => (sum += +valueof(v, index++, values) || 0));
}

//function roundCurveStep(context) {
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//mis en commentaire à cause de react
/*
var roundCurveStep = function () {


  function roundCurveStep(context, config) {
    _classCallCheck(this, roundCurveStep);

    this.context = context;
    this.config = {
      distance: 0.5, // Range: 0 to 1
      shift: 0.5, // Range: (0 - distance) to (1 - distance)
      tilt: 0.5 // Range: 0 to 1      
    };

    this._t = this.config.shift;
  }

  _createClass(roundCurveStep, [{
    key: "areaStart",
    value: function areaStart() {
      this._line = 0;
    }
  }, {
    key: "areaEnd",
    value: function areaEnd() {
      this._line = NaN;
    }
  }, {
    key: "lineStart",
    value: function lineStart() {
      this._x = this._y = NaN;
      this._point = 0;
    }
  }, {
    key: "lineEnd",
    value: function lineEnd() {
      if (0 < this._t && this._t < 1 && this._point === 2) this.context.lineTo(this._x, this._y);
      if (this._line || this._line !== 0 && this._point === 1) this.context.closePath();
      if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    }
  }, {
    key: "point",
    value: function point(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0:
          this._point = 1;
          this._line ? this.context.lineTo(x, y) : this.context.moveTo(x, y);
          break;
        case 1:
          this._point = 2; // Proceed
        default:
          {
            if (this._t <= 0) {
              this.context.lineTo(this._x, y);
              this.context.lineTo(x, y);
            } else {
              var _context, _context2;

              var x1 = this._x * (1 - this._t) + x * this._t;

              var pointOffset = (x - this._x) * (this.config.distance / 2);
              var tilt = this.config.tilt;

              var points = {
                a: [x1 - pointOffset, this._y], // Point on left divider
                // b: [x1, (this._y + (y - this._y) / 2)],  // Point in between
                c: [x1 + pointOffset, y] // Point on right divider
              };

              var yDistance = points.c[1] - points.a[1];
              var xDistance = points.c[0] - points.a[0];

              var controlPoints = {
                ab1: [points.a[0] + xDistance * tilt, points.a[1]], // Control point starting from poin on left divider
                // ab2: [points.b[0], points.b[1] - yDistance * 0.5],  // First control point starting from point in between
                // bc1: [points.b[0], points.b[1] + yDistance * 0.5],  // Second control point starting from point in between
                bc2: [points.c[0] - xDistance * tilt, points.c[1]] // Control point starting from poin on right divider
              };

              (_context = this.context).lineTo.apply(_context, _toConsumableArray(points.a));
              (_context2 = this.context).bezierCurveTo.apply(_context2, _toConsumableArray(controlPoints.ab1).concat(_toConsumableArray(controlPoints.bc2), _toConsumableArray(points.c)));
              // NOTE: The following lines might be helpful in case we consider drawing two curves connected by the point in the middle (points.b)
              // this.context.bezierCurveTo(...controlPoints.ab1, ...controlPoints.ab2, ...points.b);
              // this.context.bezierCurveTo(...controlPoints.bc1, ...controlPoints.bc2, ...points.c);
            }
            break;
          }
      }
      this._x = x, this._y = y;
    }
  }]);

  return roundCurveStep;
}();
*/

//class roundCurveStep ES6 not supported by IE 11
/*
class roundCurveStep {

 // Constructor
 // @param {object} context d3.js curve context
 // @param {object} config Optional configuration
 
  constructor(context, config) {
    this.context = context;
    this.config = {
      distance: 0.5, // Range: 0 to 1
      shift: 0.5, // Range: (0 - distance) to (1 - distance)
      tilt: 0.5 // Range: 0 to 1      
    };

    this._t = this.config.shift;
  }

  areaStart() {
    this._line = 0;
  }

  areaEnd() {
    this._line = NaN;
  }

  lineStart() {
    this._x = this._y = NaN;
    this._point = 0;
  }

  lineEnd() {
    if (0 < this._t && this._t < 1 && this._point === 2) this.context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this.context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  }

  point(x, y) {
    x = +x, y = +y;
    switch (this._point) {
    case 0:
      this._point = 1;
      this._line ? this.context.lineTo(x, y) : this.context.moveTo(x, y);
      break;
    case 1:
      this._point = 2; // Proceed
    default:
      {
        if (this._t <= 0) {
          this.context.lineTo(this._x, y);
          this.context.lineTo(x, y);
        } else {
          const x1 = this._x * (1 - this._t) + x * this._t;

          const pointOffset = (x - this._x) * (this.config.distance / 2);
          const tilt = this.config.tilt;

          const points = {
            a: [x1 - pointOffset, this._y], // Point on left divider
            // b: [x1, (this._y + (y - this._y) / 2)],  // Point in between
            c: [x1 + pointOffset, y], // Point on right divider
          };

          const yDistance = points.c[1] - points.a[1];
          const xDistance = points.c[0] - points.a[0];

          const controlPoints = {
            ab1: [points.a[0] + xDistance * tilt, points.a[1]], // Control point starting from poin on left divider
            // ab2: [points.b[0], points.b[1] - yDistance * 0.5],  // First control point starting from point in between
            // bc1: [points.b[0], points.b[1] + yDistance * 0.5],  // Second control point starting from point in between
            bc2: [points.c[0] - xDistance * tilt, points.c[1]], // Control point starting from poin on right divider
          };

          this.context.lineTo(...points.a);
          this.context.bezierCurveTo(...controlPoints.ab1, ...controlPoints.bc2, ...points.c);
          // NOTE: The following lines might be helpful in case we consider drawing two curves connected by the point in the middle (points.b)
          // this.context.bezierCurveTo(...controlPoints.ab1, ...controlPoints.ab2, ...points.b);
          // this.context.bezierCurveTo(...controlPoints.bc1, ...controlPoints.bc2, ...points.c);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
}
*/

//mis en commentaire à cause de react
/* d3.roundCurveStep1 = function(context){return new roundCurveStep(context)};
d3.roundCurveStep2 = function(context){return new roundCurveStep(context,{'distance' : 0.2, 'shift' : 0.5, 'tilt' : 0.2})};
 */


/* // Change D3's SI prefix to more business friendly units
//      K = thousands
//      M = millions
//      B = billions
//      T = trillion
//      P = quadrillion
//      E = quintillion
// small decimals are handled with e-n formatting.
var d3_formatPrefixes = ["e-24","e-21","e-18","e-15","e-12","e-9","e-6","e-3","","K","M","mds","T","P","E","Z","Y"].map(d3_formatPrefix);

// Override d3's formatPrefix function
d3.formatPrefix = function(value, precision) {
	var i = 0;
	if (value) {
		if (value < 0) {
			value *= -1;
		}
		if (precision) {
			value = d3.round(value, d3_format_precision(value, precision));
		}
		i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
		i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	}
	return d3_formatPrefixes[8 + i / 3];
};

function d3_formatPrefix(d, i) {
	var k = Math.pow(10, Math.abs(8 - i) * 3);
	return {
		scale: i > 8 ? function(d) { return d / k; } : function(d) { return d * k; },
		symbol: d
	};
}

function d3_format_precision(x, p) {
	return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
}	

 */
 
export default widgetRender;